{
  "level": "eb05",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:eb05",
    "objects": "AREAS.E3:eb05.e3",
    "mesh": "TREES.E3:eb05.e3"
  },
  "spawn_point": {
    "position": [
      1672.1470640741497,
      1842.754941959971,
      1.300048828125
    ],
    "facing_rad": 0.0,
    "look_point": [
      1672.1470640741497,
      1942.754941959971,
      1.300048828125
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -6158.31884765625,
      -3684.182861328125,
      -22.699951171875
    ],
    "bbox_max": [
      6992.103515625,
      7450.0,
      1951.3048095703125
    ],
    "vertex_count": 1358,
    "vertices": [
      [
        -3714.042724609375,
        -2323.521484375,
        1179.1292724609375
      ],
      [
        -5545.388671875,
        4741.15380859375,
        334.1224365234375
      ],
      [
        -6158.31884765625,
        3750.891357421875,
        976.300048828125
      ],
      [
        -5532.3203125,
        4687.76513671875,
        347.8642883300781
      ],
      [
        -5504.7001953125,
        4729.1015625,
        -22.699951171875
      ],
      [
        -5704.54443359375,
        4430.01318359375,
        976.300048828125
      ],
      [
        -5573.556640625,
        4626.0498046875,
        901.1133422851562
      ],
      [
        -5174.01171875,
        5224.01171875,
        -11.839268684387207
      ],
      [
        -5532.3203125,
        4687.76513671875,
        347.8642578125
      ],
      [
        -5174.01171875,
        5224.01171875,
        -11.8392333984375
      ],
      [
        -5158.470703125,
        5234.39599609375,
        -22.699951171875
      ],
      [
        -4474.53173828125,
        4475.62646484375,
        150.0
      ],
      [
        -5174.01171875,
        5224.01171875,
        41.12900161743164
      ],
      [
        -5342.2373046875,
        4972.24462890625,
        157.0411834716797
      ],
      [
        -5174.01171875,
        5224.01171875,
        41.1290283203125
      ],
      [
        -5020.71826171875,
        5326.439453125,
        -22.699951171875
      ],
      [
        -5174.01171875,
        5224.01171875,
        671.7750244140625
      ],
      [
        -4901.68505859375,
        5405.974609375,
        546.6460571289062
      ],
      [
        -4468.451171875,
        5695.4521484375,
        -22.699951171875
      ],
      [
        -5174.01171875,
        5224.01171875,
        671.7749633789062
      ],
      [
        -3179.908447265625,
        3702.748046875,
        150.0
      ],
      [
        -2916.739501953125,
        3191.2431640625,
        124.09432983398438
      ],
      [
        -1156.463623046875,
        -2051.8349609375,
        202.6451416015625
      ],
      [
        -200.806640625,
        -3123.862548828125,
        0.0
      ],
      [
        -3662.578857421875,
        6233.91845703125,
        -22.699951171875
      ],
      [
        4526.4208984375,
        -1556.87548828125,
        543.49267578125
      ],
      [
        -1145.6080322265625,
        -2059.143798828125,
        251.769287109375
      ],
      [
        -158.70802307128906,
        -3106.798095703125,
        670.1329345703125
      ],
      [
        334.5896301269531,
        -3672.376220703125,
        892.7235717773438
      ],
      [
        -158.70806884765625,
        -3106.798095703125,
        670.1329956054688
      ],
      [
        -504.59906005859375,
        -1467.1614990234375,
        114.45516967773438
      ],
      [
        -504.59906005859375,
        -1467.1614990234375,
        114.45515441894531
      ],
      [
        -681.8506469726562,
        -1625.7083740234375,
        150.77035522460938
      ],
      [
        -1143.6485595703125,
        -2061.22412109375,
        252.5999755859375
      ],
      [
        -236.08404541015625,
        -3010.201904296875,
        790.0325927734375
      ],
      [
        353.0361328125,
        -3680.16650390625,
        1163.4200439453125
      ],
      [
        -236.0840606689453,
        -3010.201904296875,
        790.0326538085938
      ],
      [
        1019.587158203125,
        -1695.03662109375,
        431.56463623046875
      ],
      [
        -1088.6651611328125,
        -2097.481689453125,
        509.4501647949219
      ],
      [
        -317.6634216308594,
        -2908.3583984375,
        916.4456787109375
      ],
      [
        362.54669189453125,
        -3684.182861328125,
        1302.984619140625
      ],
      [
        -317.6634521484375,
        -2908.3583984375,
        916.4457397460938
      ],
      [
        544.5404052734375,
        -1746.02099609375,
        431.07000732421875
      ],
      [
        -52.85992431640625,
        -1691.1807861328125,
        376.3770446777344
      ],
      [
        -436.79736328125,
        -1689.80029296875,
        356.6197509765625
      ],
      [
        -778.3905029296875,
        -2110.8046875,
        530.965576171875
      ],
      [
        -614.9921264648438,
        -1565.9052734375,
        137.07241821289062
      ],
      [
        544.5404052734375,
        -1746.0208740234375,
        431.07000732421875
      ],
      [
        1019.5870971679688,
        -1695.03662109375,
        431.5646057128906
      ],
      [
        -411.225341796875,
        -1658.283447265625,
        343.568115234375
      ],
      [
        -411.2253723144531,
        -1658.283447265625,
        343.56805419921875
      ],
      [
        2400.0,
        -1844.385986328125,
        749.0462646484375
      ],
      [
        4526.4208984375,
        -1556.87548828125,
        543.49267578125
      ],
      [
        85.42291259765625,
        -3334.0634765625,
        1814.080322265625
      ],
      [
        -560.6014404296875,
        -2605.074951171875,
        1292.8955078125
      ],
      [
        -1025.829345703125,
        -2139.787109375,
        793.7977294921875
      ],
      [
        -560.601318359375,
        -2605.074951171875,
        1292.895263671875
      ],
      [
        -869.4028930664062,
        -2286.437255859375,
        1065.087646484375
      ],
      [
        191.95556640625,
        -2234.21533203125,
        1027.7520751953125
      ],
      [
        360.5933837890625,
        -2000.716796875,
        742.364990234375
      ],
      [
        1109.866455078125,
        -2018.822998046875,
        873.7589111328125
      ],
      [
        -166.50140380859375,
        -2318.3291015625,
        1087.8885498046875
      ],
      [
        -193.13873291015625,
        -2403.4306640625,
        1148.7313232421875
      ],
      [
        -609.42333984375,
        -1902.55712890625,
        444.72637939453125
      ],
      [
        -476.1238708496094,
        -1980.497314453125,
        595.6365356445312
      ],
      [
        -164.90322875976562,
        -2162.4677734375,
        947.9736938476562
      ],
      [
        -136.14230346679688,
        -2221.337158203125,
        1018.544921875
      ],
      [
        -136.14230346679688,
        -2221.337158203125,
        1018.544921875
      ],
      [
        -164.90321350097656,
        -2162.4677734375,
        947.9736938476562
      ],
      [
        360.59381103515625,
        -2000.71630859375,
        742.3642578125
      ],
      [
        191.95559692382812,
        -2234.21533203125,
        1027.7520751953125
      ],
      [
        1721.035888671875,
        -1875.4091796875,
        771.2261352539062
      ],
      [
        2400.0,
        -1844.385986328125,
        749.0462646484375
      ],
      [
        1721.035888671875,
        -1875.4091796875,
        771.2261962890625
      ],
      [
        -476.1239013671875,
        -1980.4971923828125,
        595.6365356445312
      ],
      [
        -580.3715209960938,
        -1866.7515869140625,
        429.89862060546875
      ],
      [
        -374.7518615722656,
        -1732.939208984375,
        433.0638427734375
      ],
      [
        -52.8599853515625,
        -1691.1807861328125,
        376.3770446777344
      ],
      [
        -374.75189208984375,
        -1732.939208984375,
        433.06378173828125
      ],
      [
        -436.79736328125,
        -1689.80029296875,
        356.6197509765625
      ],
      [
        -987.384765625,
        -2165.6708984375,
        967.7686767578125
      ],
      [
        -963.9840698242188,
        -2188.843505859375,
        995.313720703125
      ],
      [
        -984.6701049804688,
        -2167.49853515625,
        980.0532836914062
      ],
      [
        6992.103515625,
        -1390.9161376953125,
        590.90966796875
      ],
      [
        1109.866455078125,
        -2018.822998046875,
        873.7589111328125
      ],
      [
        -233.89097595214844,
        -2962.61669921875,
        1774.980712890625
      ],
      [
        -556.1371459960938,
        -2604.275634765625,
        1411.13330078125
      ],
      [
        -596.0433959960938,
        -2560.8291015625,
        1347.8153076171875
      ],
      [
        -713.9907836914062,
        -2446.799560546875,
        1179.737548828125
      ],
      [
        -596.0433959960938,
        -2560.8291015625,
        1347.815185546875
      ],
      [
        -166.5013427734375,
        -2318.328857421875,
        1087.888427734375
      ],
      [
        -869.4028930664062,
        -2286.437255859375,
        1065.087646484375
      ],
      [
        -602.8601684570312,
        -2552.319091796875,
        1358.3782958984375
      ],
      [
        -841.7437133789062,
        -2312.367919921875,
        1113.056884765625
      ],
      [
        -602.8601684570312,
        -2552.319091796875,
        1358.37841796875
      ],
      [
        -274.4960021972656,
        -2915.38232421875,
        1770.0086669921875
      ],
      [
        -620.4630126953125,
        -2530.34375,
        1385.6552734375
      ],
      [
        -620.4629516601562,
        -2530.34375,
        1385.6551513671875
      ],
      [
        -773.8844604492188,
        -2375.986083984375,
        1230.7451171875
      ],
      [
        6992.103515625,
        -1390.916015625,
        590.90966796875
      ],
      [
        3366.189697265625,
        -1334.87353515625,
        384.7739562988281
      ],
      [
        -973.9005126953125,
        -2174.74951171875,
        1028.788330078125
      ],
      [
        2962.533935546875,
        -1257.6368408203125,
        329.5541687011719
      ],
      [
        2455.532470703125,
        -1160.625732421875,
        260.1967468261719
      ],
      [
        2621.07421875,
        -1158.5028076171875,
        267.47998046875
      ],
      [
        -575.9976806640625,
        -2564.65576171875,
        1733.090087890625
      ],
      [
        -725.1876220703125,
        -2399.605712890625,
        1547.9334716796875
      ],
      [
        -3749.496337890625,
        -2237.32958984375,
        1293.859130859375
      ],
      [
        -4249.0625,
        -2322.946044921875,
        1375.4637451171875
      ],
      [
        -3749.49609375,
        -2237.329345703125,
        1293.859130859375
      ],
      [
        -3766.849609375,
        -2126.165771484375,
        1171.234130859375
      ],
      [
        -903.2229614257812,
        -2222.334716796875,
        1348.62158203125
      ],
      [
        -725.1875610351562,
        -2399.605712890625,
        1547.9334716796875
      ],
      [
        -5174.01171875,
        5224.01171875,
        714.5433349609375
      ],
      [
        -2708.39404296875,
        6871.484375,
        182.69976806640625
      ],
      [
        -2579.824462890625,
        6957.392578125,
        151.5449981689453
      ],
      [
        -2581.58544921875,
        6956.2158203125,
        150.0
      ],
      [
        647.2877197265625,
        1384.3714599609375,
        161.05001831054688
      ],
      [
        582.7122802734375,
        1384.3714599609375,
        173.7375946044922
      ],
      [
        699.5303955078125,
        1346.4150390625,
        163.2774658203125
      ],
      [
        647.2877197265625,
        1384.3714599609375,
        161.05001831054688
      ],
      [
        -2708.39404296875,
        6871.484375,
        182.69976806640625
      ],
      [
        -1472.92333984375,
        7117.23486328125,
        -22.699951171875
      ],
      [
        -2574.443359375,
        6957.37060546875,
        154.18719482421875
      ],
      [
        -2522.372314453125,
        6908.486328125,
        151.7732696533203
      ],
      [
        -2525.29052734375,
        6907.90576171875,
        150.0
      ],
      [
        -5174.01171875,
        5224.01171875,
        714.5433349609375
      ],
      [
        -5331.83203125,
        4987.81689453125,
        762.3635864257812
      ],
      [
        1070.0,
        1390.0,
        211.37973022460938
      ],
      [
        1180.0,
        1390.0,
        195.39779663085938
      ],
      [
        647.2877197265625,
        1384.3714599609375,
        273.3889465332031
      ],
      [
        582.7122802734375,
        1384.3714599609375,
        282.77117919921875
      ],
      [
        699.5303955078125,
        1346.4150390625,
        269.79852294921875
      ],
      [
        647.2877197265625,
        1384.3714599609375,
        273.3889465332031
      ],
      [
        1535.0,
        1030.0,
        181.7567596435547
      ],
      [
        1535.0,
        1130.0,
        171.2186737060547
      ],
      [
        1180.0,
        1384.3714599609375,
        97.64706420898438
      ],
      [
        1180.0,
        1375.0,
        196.97845458984375
      ],
      [
        1180.0,
        1384.3714599609375,
        195.99087524414062
      ],
      [
        1180.0,
        1375.0,
        196.97845458984375
      ],
      [
        1200.0,
        1375.0,
        194.07266235351562
      ],
      [
        1400.0,
        1270.0,
        176.07955932617188
      ],
      [
        1464.145751953125,
        1334.145751953125,
        160.0
      ],
      [
        1518.0,
        960.0,
        191.60336303710938
      ],
      [
        1525.0,
        1030.0,
        183.20968627929688
      ],
      [
        1475.0,
        1130.0,
        179.9361114501953
      ],
      [
        1535.0,
        1130.0,
        171.21868896484375
      ],
      [
        1405.0,
        1375.0,
        160.0
      ],
      [
        1350.0,
        1320.0,
        178.07501220703125
      ],
      [
        1405.0,
        1375.0,
        164.28807067871094
      ],
      [
        1414.3714599609375,
        1384.3714599609375,
        160.0
      ],
      [
        1414.3714599609375,
        1384.3714599609375,
        161.9389190673828
      ],
      [
        1615.0,
        1030.0,
        170.13352966308594
      ],
      [
        1615.0,
        1130.0,
        159.59542846679688
      ],
      [
        1598.0,
        960.0,
        179.98013305664062
      ],
      [
        1605.0,
        1030.0,
        171.58642578125
      ],
      [
        1555.0,
        1130.0,
        168.3128662109375
      ],
      [
        1615.0,
        1130.0,
        159.59542846679688
      ],
      [
        1180.0,
        1390.0,
        195.39773559570312
      ],
      [
        1420.0,
        1390.0,
        160.0
      ],
      [
        1420.0,
        1390.0,
        160.5279998779297
      ],
      [
        1070.0,
        1540.0,
        195.57257080078125
      ],
      [
        1180.0,
        1540.0,
        179.59066772460938
      ],
      [
        1160.0,
        1460.0,
        190.92684936523438
      ],
      [
        1160.0,
        1390.0,
        198.3035888671875
      ],
      [
        1200.0,
        1475.0,
        183.5345458984375
      ],
      [
        1200.0,
        1525.0,
        178.2655029296875
      ],
      [
        1180.0,
        1460.0,
        188.02108764648438
      ],
      [
        1180.0,
        1475.0,
        186.44033813476562
      ],
      [
        1180.0,
        1540.0,
        179.59059143066406
      ],
      [
        1180.0,
        1525.0,
        181.17129516601562
      ],
      [
        1180.0,
        1525.0,
        181.17129516601562
      ],
      [
        1200.0,
        1525.0,
        178.2655029296875
      ],
      [
        1422.1063232421875,
        1392.1063232421875,
        160.0
      ],
      [
        1090.0,
        1550.0,
        191.61289978027344
      ],
      [
        1160.0,
        1550.0,
        181.44259643554688
      ],
      [
        1160.0,
        1550.0,
        181.44256591796875
      ],
      [
        1160.0,
        1540.0,
        182.49642944335938
      ],
      [
        -2484.12060546875,
        6872.57568359375,
        150.0
      ],
      [
        200.0,
        7450.0,
        680.7955932617188
      ],
      [
        3108.39404296875,
        6871.484375,
        547.115966796875
      ],
      [
        3108.39404296875,
        6871.484375,
        547.115966796875
      ],
      [
        5574.01171875,
        5224.01171875,
        89.7060775756836
      ],
      [
        -2708.39404296875,
        6871.484375,
        470.3935546875
      ],
      [
        200.0,
        7450.0,
        680.7955932617188
      ],
      [
        -2282.542236328125,
        6956.19140625,
        297.5124206542969
      ],
      [
        -2522.372314453125,
        6908.486328125,
        151.7732696533203
      ],
      [
        -1857.3212890625,
        6954.4736328125,
        506.29852294921875
      ],
      [
        -1146.6842041015625,
        5724.8427734375,
        150.0
      ],
      [
        -234.04736328125,
        5684.36474609375,
        150.0
      ],
      [
        -450.0968933105469,
        7064.0869140625,
        557.4569091796875
      ],
      [
        -2708.39404296875,
        6871.484375,
        470.3935241699219
      ],
      [
        -3381.2060546875,
        6421.92578125,
        327.8280029296875
      ],
      [
        6166.06201171875,
        5070.96826171875,
        1783.6749267578125
      ],
      [
        3249.21630859375,
        2461.31005859375,
        413.9189758300781
      ],
      [
        3662.360107421875,
        2778.274169921875,
        667.953125
      ],
      [
        3023.2666015625,
        965.064453125,
        161.0574951171875
      ],
      [
        3188.037109375,
        1690.0,
        402.6617126464844
      ],
      [
        3437.258056640625,
        1506.344482421875,
        495.7249755859375
      ],
      [
        5574.01171875,
        5224.01171875,
        727.6093139648438
      ],
      [
        5312.15966796875,
        5398.9755859375,
        138.28363037109375
      ],
      [
        2939.5361328125,
        1830.0,
        140.0
      ],
      [
        3211.68603515625,
        1830.0,
        440.30340576171875
      ],
      [
        3211.68603515625,
        1830.0,
        440.3033752441406
      ],
      [
        3206.5634765625,
        1846.1043701171875,
        435.9788818359375
      ],
      [
        3210.02099609375,
        1690.0,
        414.3177185058594
      ],
      [
        3188.037109375,
        1690.0,
        402.6617126464844
      ],
      [
        3210.02099609375,
        1690.0,
        414.3177185058594
      ],
      [
        3740.468017578125,
        816.188232421875,
        509.64764404296875
      ],
      [
        3437.258056640625,
        1506.344482421875,
        495.7249755859375
      ],
      [
        2780.0,
        2051.553955078125,
        129.53286743164062
      ],
      [
        2963.558349609375,
        716.4630737304688,
        76.50570678710938
      ],
      [
        3023.2666015625,
        965.0643920898438,
        161.0574951171875
      ],
      [
        3662.360107421875,
        2778.274169921875,
        667.953125
      ],
      [
        2780.0,
        2099.70263671875,
        127.25813293457031
      ],
      [
        3066.83935546875,
        2308.073974609375,
        316.9542236328125
      ],
      [
        3249.21630859375,
        2461.31005859375,
        413.9189758300781
      ],
      [
        3066.83935546875,
        2308.073974609375,
        316.9542236328125
      ],
      [
        3197.37939453125,
        1690.0,
        407.6151123046875
      ],
      [
        6166.06201171875,
        5070.96826171875,
        1783.6749267578125
      ],
      [
        6113.75048828125,
        5124.94384765625,
        1755.698974609375
      ],
      [
        4978.5498046875,
        5621.88623046875,
        976.300048828125
      ],
      [
        4024.158203125,
        6259.5908203125,
        377.2276611328125
      ],
      [
        6113.75048828125,
        5124.94384765625,
        1755.698974609375
      ],
      [
        4447.9970703125,
        5744.82666015625,
        939.7493286132812
      ],
      [
        4447.9970703125,
        5744.82666015625,
        939.7493286132812
      ],
      [
        3410.901123046875,
        6257.458984375,
        423.10589599609375
      ],
      [
        4550.60546875,
        5907.82958984375,
        976.300048828125
      ],
      [
        3548.869140625,
        6577.16845703125,
        465.40106201171875
      ],
      [
        3323.18310546875,
        6163.4072265625,
        388.7722473144531
      ],
      [
        3410.9013671875,
        6257.458984375,
        423.1058654785156
      ],
      [
        3033.31640625,
        5852.611328125,
        275.3160400390625
      ],
      [
        3033.31640625,
        5852.611328125,
        275.3160400390625
      ],
      [
        2638.3466796875,
        5453.03271484375,
        119.09219360351562
      ],
      [
        4529.33349609375,
        5879.8046875,
        1099.716064453125
      ],
      [
        4529.33349609375,
        5879.8046875,
        1099.7161865234375
      ],
      [
        3278.010986328125,
        6567.681640625,
        523.6412353515625
      ],
      [
        4264.15087890625,
        6099.232421875,
        976.300048828125
      ],
      [
        3270.9990234375,
        6762.83544921875,
        516.9502563476562
      ],
      [
        3173.411865234375,
        6443.86376953125,
        478.7689208984375
      ],
      [
        3278.010986328125,
        6567.68212890625,
        523.6412353515625
      ],
      [
        3323.18310546875,
        6163.4072265625,
        388.7722473144531
      ],
      [
        3027.2626953125,
        6270.8603515625,
        416.07177734375
      ],
      [
        2459.022216796875,
        5637.51416015625,
        171.58868408203125
      ],
      [
        3027.2626953125,
        6270.8603515625,
        416.07177734375
      ],
      [
        4910.861328125,
        6512.951171875,
        1850.077880859375
      ],
      [
        3151.548095703125,
        6862.900390625,
        619.3140869140625
      ],
      [
        4910.861328125,
        6512.951171875,
        1850.077880859375
      ],
      [
        5075.25439453125,
        6480.25146484375,
        1951.3048095703125
      ],
      [
        1489.97119140625,
        7193.40869140625,
        643.8284301757812
      ],
      [
        3018.309814453125,
        6889.4033203125,
        624.2333984375
      ],
      [
        3018.309814453125,
        6889.4033203125,
        624.2333984375
      ],
      [
        3151.548095703125,
        6862.900390625,
        619.3140258789062
      ],
      [
        3108.39404296875,
        6871.484375,
        620.9073486328125
      ],
      [
        3380.85986328125,
        6689.4287109375,
        567.7627563476562
      ],
      [
        3108.39404296875,
        6871.484375,
        623.078369140625
      ],
      [
        3394.5791015625,
        6680.26171875,
        574.108154296875
      ],
      [
        3163.701416015625,
        6834.52880859375,
        610.11962890625
      ],
      [
        3156.05517578125,
        6862.00390625,
        622.4671630859375
      ],
      [
        3170.047119140625,
        6830.28955078125,
        612.5286254882812
      ],
      [
        3288.431884765625,
        6561.953125,
        528.4387817382812
      ],
      [
        4128.3427734375,
        6189.9765625,
        976.300048828125
      ],
      [
        3170.046630859375,
        6830.28955078125,
        612.5287475585938
      ],
      [
        3108.39404296875,
        6871.484375,
        740.1891479492188
      ],
      [
        3968.1376953125,
        6297.02197265625,
        976.300048828125
      ],
      [
        1325.0,
        1835.0,
        429.0
      ],
      [
        1350.0,
        1835.0,
        379.0
      ],
      [
        1320.0,
        1860.0,
        438.9999084472656
      ],
      [
        1319.5,
        1858.792724609375,
        440.0
      ],
      [
        1320.0,
        1860.0,
        438.9999084472656
      ],
      [
        1319.5,
        1861.207275390625,
        440.0
      ],
      [
        1332.0,
        1830.0,
        415.0
      ],
      [
        1332.0,
        1835.0,
        415.0
      ],
      [
        1770.0,
        1830.0,
        370.0
      ],
      [
        1704.19970703125,
        1830.0,
        1059.6480712890625
      ],
      [
        1704.5107421875,
        1830.0,
        1060.0
      ],
      [
        1770.0,
        1895.4892578125,
        1060.0
      ],
      [
        1770.0,
        1896.0,
        1059.422119140625
      ],
      [
        1704.510498046875,
        1830.0,
        1060.0
      ],
      [
        1711.9351806640625,
        1837.4246826171875,
        1060.0
      ],
      [
        1762.629150390625,
        1888.1185302734375,
        1060.0
      ],
      [
        1770.0,
        1895.489501953125,
        1060.0
      ],
      [
        1711.9351806640625,
        1837.4246826171875,
        1060.0
      ],
      [
        1762.629150390625,
        1888.1185302734375,
        1060.0
      ],
      [
        1770.0,
        1881.243408203125,
        1130.0
      ],
      [
        1718.756591796875,
        1830.0,
        1130.0
      ],
      [
        1766.382568359375,
        1830.0,
        1130.0
      ],
      [
        1770.0,
        1833.617431640625,
        1130.0
      ],
      [
        1718.756591796875,
        1830.0,
        1130.0
      ],
      [
        1706.639892578125,
        1830.0,
        1130.0
      ],
      [
        1770.0,
        1893.3599853515625,
        1130.0
      ],
      [
        1770.0,
        1881.243408203125,
        1130.0
      ],
      [
        1704.19970703125,
        1830.0,
        1060.0
      ],
      [
        1704.19970703125,
        1830.0,
        1059.6480712890625
      ],
      [
        1770.0,
        1896.0,
        1059.422119140625
      ],
      [
        1770.0,
        1896.0,
        1060.0
      ],
      [
        1723.412353515625,
        1830.0,
        1060.0
      ],
      [
        1770.0,
        1876.693359375,
        1060.0
      ],
      [
        1723.412353515625,
        1830.0,
        1060.0
      ],
      [
        1770.0,
        1830.0,
        1060.0
      ],
      [
        1770.0,
        1876.693359375,
        1060.0
      ],
      [
        1770.0,
        1830.0,
        1130.0
      ],
      [
        1770.0,
        1860.753173828125,
        375.0
      ],
      [
        1739.246826171875,
        1830.0,
        375.0
      ],
      [
        1739.246826171875,
        1830.0,
        370.0
      ],
      [
        1770.0,
        1860.753173828125,
        370.0
      ],
      [
        1739.246826171875,
        1830.0,
        375.0
      ],
      [
        1770.0,
        1860.753173828125,
        375.0
      ],
      [
        1770.0,
        1832.4688720703125,
        375.0
      ],
      [
        1767.5311279296875,
        1830.0,
        375.0
      ],
      [
        1767.5311279296875,
        1830.0,
        375.0
      ],
      [
        1770.0,
        1832.4688720703125,
        375.0
      ],
      [
        1770.0,
        1832.4688720703125,
        380.0
      ],
      [
        1767.5311279296875,
        1830.0,
        380.0
      ],
      [
        1767.5311279296875,
        1830.0,
        380.0
      ],
      [
        1770.0,
        1832.4688720703125,
        380.0
      ],
      [
        1770.0,
        1830.0,
        380.0
      ],
      [
        2068.396240234375,
        1912.614990234375,
        439.99993896484375
      ],
      [
        1989.689453125,
        1991.3216552734375,
        440.00006103515625
      ],
      [
        1999.2860107421875,
        1911.0145263671875,
        665.0
      ],
      [
        1982.4197998046875,
        1976.98095703125,
        665.0
      ],
      [
        2017.9737548828125,
        2019.60595703125,
        640.0
      ],
      [
        2025.044677734375,
        2012.53466796875,
        640.0
      ],
      [
        2088.90234375,
        1948.677490234375,
        640.0
      ],
      [
        2096.6806640625,
        1940.899169921875,
        640.0
      ],
      [
        2025.044677734375,
        2012.53466796875,
        645.0
      ],
      [
        2025.044677734375,
        2012.53466796875,
        640.0
      ],
      [
        2088.90234375,
        1948.677490234375,
        640.0
      ],
      [
        2088.90234375,
        1948.677490234375,
        645.0
      ],
      [
        2014.5472412109375,
        1987.6771240234375,
        432.5
      ],
      [
        2018.082763671875,
        1991.212646484375,
        429.9999694824219
      ],
      [
        2014.5472412109375,
        1994.7481689453125,
        430.0001525878906
      ],
      [
        2011.01171875,
        1991.212646484375,
        432.5
      ],
      [
        2014.5472412109375,
        1987.6771240234375,
        432.5
      ],
      [
        2011.01171875,
        1991.212646484375,
        432.5
      ],
      [
        2018.082763671875,
        1991.212646484375,
        429.9999694824219
      ],
      [
        2014.5472412109375,
        1994.7481689453125,
        430.0001525878906
      ],
      [
        1989.689453125,
        1991.3216552734375,
        440.00006103515625
      ],
      [
        2067.580322265625,
        1941.7152099609375,
        429.9999694824219
      ],
      [
        2064.044677734375,
        1938.1796875,
        432.5
      ],
      [
        2067.580322265625,
        1934.6441650390625,
        432.5
      ],
      [
        2071.11572265625,
        1938.1796875,
        430.0001525878906
      ],
      [
        2067.580322265625,
        1934.6441650390625,
        432.5
      ],
      [
        2064.044677734375,
        1938.1796875,
        432.5
      ],
      [
        2071.11572265625,
        1938.1796875,
        430.0001525878906
      ],
      [
        2067.580322265625,
        1941.7152099609375,
        429.9999694824219
      ],
      [
        2068.396240234375,
        1912.614990234375,
        439.99993896484375
      ],
      [
        1973.2493896484375,
        2012.847412109375,
        385.0
      ],
      [
        1974.996337890625,
        2006.0147705078125,
        385.0
      ],
      [
        2008.5718994140625,
        1874.696533203125,
        370.0
      ],
      [
        2012.35205078125,
        1859.912109375,
        370.0
      ],
      [
        1974.996337890625,
        2006.0147705078125,
        370.0
      ],
      [
        1980.99072265625,
        1982.5692138671875,
        370.0
      ],
      [
        2008.5718994140625,
        1874.696533203125,
        370.0
      ],
      [
        1999.2861328125,
        1911.0142822265625,
        370.0
      ],
      [
        1999.2861328125,
        1911.0142822265625,
        370.0
      ],
      [
        1980.99072265625,
        1982.5692138671875,
        370.0
      ],
      [
        2000.743408203125,
        1905.314453125,
        372.5
      ],
      [
        1990.527099609375,
        1945.272216796875,
        372.5
      ],
      [
        2001.1121826171875,
        1958.685791015625,
        372.5
      ],
      [
        2036.467529296875,
        1923.3304443359375,
        372.5
      ],
      [
        2008.1832275390625,
        1895.046142578125,
        372.5
      ],
      [
        2036.467529296875,
        1923.3304443359375,
        372.5
      ],
      [
        1989.951171875,
        1947.5247802734375,
        370.0
      ],
      [
        2001.1121826171875,
        1958.685791015625,
        372.5
      ],
      [
        1989.951171875,
        1947.5247802734375,
        372.5
      ],
      [
        2001.715087890625,
        1901.5142822265625,
        370.0
      ],
      [
        2001.715087890625,
        1901.5142822265625,
        372.5
      ],
      [
        2008.1832275390625,
        1895.046142578125,
        372.5
      ],
      [
        2016.962890625,
        1846.0794677734375,
        372.5
      ],
      [
        2041.829833984375,
        1849.496826171875,
        372.5
      ],
      [
        2045.659912109375,
        1878.78271484375,
        372.5
      ],
      [
        2059.802001953125,
        1892.9248046875,
        372.5
      ],
      [
        2047.1448974609375,
        1877.2977294921875,
        372.5
      ],
      [
        2061.287109375,
        1891.4398193359375,
        372.5
      ],
      [
        2043.5599365234375,
        1873.712890625,
        370.0
      ],
      [
        2045.659912109375,
        1878.78271484375,
        372.5
      ],
      [
        2043.5599365234375,
        1873.712890625,
        372.5
      ],
      [
        2064.802001953125,
        1894.9959716796875,
        372.5
      ],
      [
        2059.802001953125,
        1892.9248046875,
        372.5
      ],
      [
        2064.802001953125,
        1894.9959716796875,
        370.0
      ],
      [
        2015.9613037109375,
        1849.0841064453125,
        370.0
      ],
      [
        2016.7037353515625,
        1846.85693359375,
        370.0
      ],
      [
        2016.7037353515625,
        1846.85693359375,
        372.5
      ],
      [
        2015.9613037109375,
        1849.0841064453125,
        372.5
      ],
      [
        2051.316650390625,
        1858.9837646484375,
        372.5
      ],
      [
        2045.659912109375,
        1864.640625,
        372.5
      ],
      [
        2042.73095703125,
        1871.711669921875,
        372.5
      ],
      [
        2045.659912109375,
        1864.640625,
        372.5
      ],
      [
        2052.8017578125,
        1860.46875,
        372.5
      ],
      [
        2047.1448974609375,
        1866.1256103515625,
        372.5
      ],
      [
        2047.1448974609375,
        1877.2977294921875,
        372.5
      ],
      [
        2044.8310546875,
        1871.7115478515625,
        372.5
      ],
      [
        2042.73095703125,
        1871.711669921875,
        372.5
      ],
      [
        2044.8310546875,
        1871.7115478515625,
        372.5
      ],
      [
        2047.1448974609375,
        1866.1256103515625,
        372.5
      ],
      [
        2066.287109375,
        1893.510986328125,
        370.0
      ],
      [
        2061.287109375,
        1891.4398193359375,
        372.5
      ],
      [
        2066.287109375,
        1893.510986328125,
        372.5
      ],
      [
        2016.962890625,
        1846.0794677734375,
        372.5
      ],
      [
        2012.35205078125,
        1859.912109375,
        370.0
      ],
      [
        2012.35205078125,
        1859.912109375,
        372.5
      ],
      [
        2024.4466552734375,
        1885.853759765625,
        372.5
      ],
      [
        2032.224853515625,
        1893.6319580078125,
        372.5
      ],
      [
        2032.224853515625,
        1878.0755615234375,
        372.5
      ],
      [
        2024.4466552734375,
        1885.853759765625,
        372.5
      ],
      [
        2040.0030517578125,
        1885.853759765625,
        372.5
      ],
      [
        2032.224853515625,
        1878.0755615234375,
        372.5
      ],
      [
        2032.224853515625,
        1893.6319580078125,
        372.5
      ],
      [
        2040.0030517578125,
        1885.853759765625,
        372.5
      ],
      [
        2096.6806640625,
        1940.899169921875,
        372.5
      ],
      [
        2075.46728515625,
        1919.6859130859375,
        372.5
      ],
      [
        2086.672119140625,
        1894.339111328125,
        372.5
      ],
      [
        2068.396240234375,
        1912.614990234375,
        372.5
      ],
      [
        2073.944091796875,
        1892.9249267578125,
        372.5
      ],
      [
        2079.60107421875,
        1887.2679443359375,
        372.5
      ],
      [
        2073.944091796875,
        1892.9249267578125,
        372.5
      ],
      [
        2066.873046875,
        1895.853759765625,
        372.5
      ],
      [
        2072.459228515625,
        1891.4398193359375,
        372.5
      ],
      [
        2078.115966796875,
        1885.7830810546875,
        372.5
      ],
      [
        2072.459228515625,
        1891.4398193359375,
        372.5
      ],
      [
        2066.873291015625,
        1893.7537841796875,
        372.5
      ],
      [
        2066.873046875,
        1895.853759765625,
        372.5
      ],
      [
        2066.873291015625,
        1893.7537841796875,
        372.5
      ],
      [
        2017.9737548828125,
        2019.60595703125,
        372.5
      ],
      [
        1996.7606201171875,
        1998.3927001953125,
        372.5
      ],
      [
        1989.689453125,
        1991.3216552734375,
        372.5
      ],
      [
        1974.996337890625,
        2006.0147705078125,
        370.0
      ],
      [
        1974.996337890625,
        2006.0147705078125,
        372.5
      ],
      [
        2060.50927734375,
        1941.7152099609375,
        372.5
      ],
      [
        2049.902587890625,
        1931.108642578125,
        372.5
      ],
      [
        2060.50927734375,
        1941.7152099609375,
        372.5
      ],
      [
        2071.224609375,
        1930.999755859375,
        372.5
      ],
      [
        2068.396240234375,
        1912.614990234375,
        372.5
      ],
      [
        2060.6181640625,
        1920.39306640625,
        372.5
      ],
      [
        2049.902587890625,
        1931.108642578125,
        372.5
      ],
      [
        2060.6181640625,
        1920.39306640625,
        372.5
      ],
      [
        2075.46728515625,
        1919.6859130859375,
        372.5
      ],
      [
        2067.689208984375,
        1927.464111328125,
        372.5
      ],
      [
        2067.689208984375,
        1927.464111328125,
        372.5
      ],
      [
        2060.6181640625,
        1920.39306640625,
        372.5
      ],
      [
        2067.689208984375,
        1927.464111328125,
        372.5
      ],
      [
        2071.224609375,
        1930.999755859375,
        372.5
      ],
      [
        2067.580322265625,
        1941.7152099609375,
        372.5
      ],
      [
        2064.044677734375,
        1938.1796875,
        372.5
      ],
      [
        2067.580322265625,
        1934.6441650390625,
        372.5
      ],
      [
        2071.11572265625,
        1938.1796875,
        372.5
      ],
      [
        2067.580322265625,
        1941.7152099609375,
        372.5
      ],
      [
        2071.11572265625,
        1938.1796875,
        372.5
      ],
      [
        2007.4761962890625,
        1973.5350341796875,
        372.5
      ],
      [
        2018.082763671875,
        1984.1416015625,
        372.5
      ],
      [
        2007.3671875,
        1994.857177734375,
        372.5
      ],
      [
        2018.082763671875,
        1984.1416015625,
        372.5
      ],
      [
        1989.689453125,
        1991.3216552734375,
        372.5
      ],
      [
        1996.7606201171875,
        1984.2506103515625,
        372.5
      ],
      [
        1996.7606201171875,
        1984.2506103515625,
        372.5
      ],
      [
        2007.4761962890625,
        1973.5350341796875,
        372.5
      ],
      [
        2007.3671875,
        1994.857177734375,
        372.5
      ],
      [
        2003.8316650390625,
        1991.3216552734375,
        372.5
      ],
      [
        2003.8316650390625,
        1991.3216552734375,
        372.5
      ],
      [
        1996.7606201171875,
        1984.2506103515625,
        372.5
      ],
      [
        1996.7606201171875,
        1998.3927001953125,
        372.5
      ],
      [
        2003.8316650390625,
        1991.3216552734375,
        372.5
      ],
      [
        2014.5472412109375,
        1994.7481689453125,
        372.5
      ],
      [
        2011.01171875,
        1991.212646484375,
        372.5
      ],
      [
        2014.5472412109375,
        1987.6771240234375,
        372.5
      ],
      [
        2018.082763671875,
        1991.212646484375,
        372.5
      ],
      [
        2014.5472412109375,
        1994.7481689453125,
        372.5
      ],
      [
        2018.082763671875,
        1991.212646484375,
        372.5
      ],
      [
        2044.8939208984375,
        1961.455322265625,
        372.5
      ],
      [
        2045.60107421875,
        1960.7481689453125,
        372.5
      ],
      [
        2050.55078125,
        1955.7984619140625,
        372.5
      ],
      [
        2051.2578125,
        1955.09130859375,
        372.5
      ],
      [
        2031.4588623046875,
        1974.8902587890625,
        372.5
      ],
      [
        2032.166015625,
        1974.1832275390625,
        372.5
      ],
      [
        2037.11572265625,
        1969.2333984375,
        372.5
      ],
      [
        2037.82275390625,
        1968.5263671875,
        372.5
      ],
      [
        2045.60107421875,
        1960.7481689453125,
        372.5
      ],
      [
        2050.55078125,
        1955.7984619140625,
        372.5
      ],
      [
        2032.166015625,
        1974.1832275390625,
        372.5
      ],
      [
        2037.11572265625,
        1969.2333984375,
        372.5
      ],
      [
        2040.56884765625,
        1972.6865234375,
        372.5
      ],
      [
        2035.6190185546875,
        1977.6363525390625,
        372.5
      ],
      [
        2054.003662109375,
        1959.25146484375,
        372.5
      ],
      [
        2049.053955078125,
        1964.201171875,
        372.5
      ],
      [
        2037.11572265625,
        1969.2333984375,
        372.5
      ],
      [
        2040.56884765625,
        1972.6865234375,
        372.5
      ],
      [
        2032.166015625,
        1974.1832275390625,
        372.5
      ],
      [
        2035.6190185546875,
        1977.6363525390625,
        372.5
      ],
      [
        2049.053955078125,
        1964.201171875,
        372.5
      ],
      [
        2045.60107421875,
        1960.7481689453125,
        372.5
      ],
      [
        2054.003662109375,
        1959.25146484375,
        372.5
      ],
      [
        2050.55078125,
        1955.7984619140625,
        372.5
      ],
      [
        2040.0030517578125,
        1956.564453125,
        372.5
      ],
      [
        2039.2958984375,
        1955.8572998046875,
        372.5
      ],
      [
        2041.7708740234375,
        1958.332275390625,
        372.5
      ],
      [
        2040.0030517578125,
        1956.564453125,
        372.5
      ],
      [
        2041.7708740234375,
        1958.332275390625,
        372.5
      ],
      [
        2044.8939208984375,
        1961.455322265625,
        372.5
      ],
      [
        2045.659912109375,
        1950.9075927734375,
        372.5
      ],
      [
        2044.9527587890625,
        1950.2005615234375,
        372.5
      ],
      [
        2047.427734375,
        1952.6754150390625,
        372.5
      ],
      [
        2045.659912109375,
        1950.9075927734375,
        372.5
      ],
      [
        2047.427734375,
        1952.6754150390625,
        372.5
      ],
      [
        2050.55078125,
        1955.7984619140625,
        372.5
      ],
      [
        2046.3670654296875,
        1950.2005615234375,
        372.5
      ],
      [
        2045.659912109375,
        1949.493408203125,
        372.5
      ],
      [
        2048.134765625,
        1951.96826171875,
        372.5
      ],
      [
        2046.3670654296875,
        1950.2005615234375,
        372.5
      ],
      [
        2051.2578125,
        1955.09130859375,
        372.5
      ],
      [
        2048.134765625,
        1951.96826171875,
        372.5
      ],
      [
        2044.9527587890625,
        1950.2005615234375,
        372.5
      ],
      [
        2045.659912109375,
        1949.493408203125,
        372.5
      ],
      [
        2040.710205078125,
        1955.8572998046875,
        372.5
      ],
      [
        2040.0030517578125,
        1955.1502685546875,
        372.5
      ],
      [
        2042.4779052734375,
        1957.6251220703125,
        372.5
      ],
      [
        2040.710205078125,
        1955.8572998046875,
        372.5
      ],
      [
        2045.60107421875,
        1960.7481689453125,
        372.5
      ],
      [
        2042.4779052734375,
        1957.6251220703125,
        372.5
      ],
      [
        2039.2958984375,
        1955.8572998046875,
        372.5
      ],
      [
        2040.0030517578125,
        1955.1502685546875,
        372.5
      ],
      [
        2031.517822265625,
        1963.635498046875,
        372.5
      ],
      [
        2032.224853515625,
        1964.3426513671875,
        372.5
      ],
      [
        2032.224853515625,
        1964.3426513671875,
        372.5
      ],
      [
        2033.99267578125,
        1966.1103515625,
        372.5
      ],
      [
        2033.99267578125,
        1966.1103515625,
        372.5
      ],
      [
        2037.11572265625,
        1969.2333984375,
        372.5
      ],
      [
        2032.224853515625,
        1962.928466796875,
        372.5
      ],
      [
        2032.9320068359375,
        1963.635498046875,
        372.5
      ],
      [
        2032.9320068359375,
        1963.635498046875,
        372.5
      ],
      [
        2034.69970703125,
        1965.4033203125,
        372.5
      ],
      [
        2037.82275390625,
        1968.5263671875,
        372.5
      ],
      [
        2034.69970703125,
        1965.4033203125,
        372.5
      ],
      [
        2031.517822265625,
        1963.635498046875,
        372.5
      ],
      [
        2032.224853515625,
        1962.928466796875,
        372.5
      ],
      [
        2025.8609619140625,
        1969.2923583984375,
        372.5
      ],
      [
        2026.5679931640625,
        1969.99951171875,
        372.5
      ],
      [
        2026.5679931640625,
        1969.99951171875,
        372.5
      ],
      [
        2028.3358154296875,
        1971.7672119140625,
        372.5
      ],
      [
        2028.3358154296875,
        1971.7672119140625,
        372.5
      ],
      [
        2031.4588623046875,
        1974.8902587890625,
        372.5
      ],
      [
        2026.5679931640625,
        1968.5853271484375,
        372.5
      ],
      [
        2027.275146484375,
        1969.2923583984375,
        372.5
      ],
      [
        2027.275146484375,
        1969.2923583984375,
        372.5
      ],
      [
        2029.04296875,
        1971.0601806640625,
        372.5
      ],
      [
        2032.166015625,
        1974.1832275390625,
        372.5
      ],
      [
        2029.04296875,
        1971.0601806640625,
        372.5
      ],
      [
        2025.8609619140625,
        1969.2923583984375,
        372.5
      ],
      [
        2026.5679931640625,
        1968.5853271484375,
        372.5
      ],
      [
        2066.287109375,
        1893.510986328125,
        375.0
      ],
      [
        2064.802001953125,
        1894.9959716796875,
        375.0
      ],
      [
        1989.951171875,
        1947.5247802734375,
        375.0
      ],
      [
        1990.527099609375,
        1945.272216796875,
        375.0
      ],
      [
        2001.715087890625,
        1901.5142822265625,
        375.0
      ],
      [
        2000.743408203125,
        1905.314453125,
        375.0
      ],
      [
        2064.802001953125,
        1894.9959716796875,
        375.0
      ],
      [
        2062.802001953125,
        1894.16748046875,
        375.0
      ],
      [
        2062.802001953125,
        1894.16748046875,
        372.5
      ],
      [
        2064.802001953125,
        1894.9959716796875,
        372.5
      ],
      [
        2066.873291015625,
        1892.9248046875,
        373.0
      ],
      [
        2068.84521484375,
        1890.9530029296875,
        373.0
      ],
      [
        2066.873291015625,
        1892.9248046875,
        373.0
      ],
      [
        2066.287109375,
        1893.510986328125,
        373.0
      ],
      [
        2064.287109375,
        1892.6824951171875,
        373.0
      ],
      [
        2065.68994140625,
        1891.2796630859375,
        373.0
      ],
      [
        2066.287109375,
        1893.510986328125,
        374.0
      ],
      [
        2064.287109375,
        1892.6824951171875,
        374.0
      ],
      [
        2064.287109375,
        1892.6824951171875,
        375.0
      ],
      [
        2066.287109375,
        1893.510986328125,
        375.0
      ],
      [
        2068.84521484375,
        1890.9530029296875,
        373.5
      ],
      [
        2066.873291015625,
        1892.9248046875,
        373.79107666015625
      ],
      [
        2068.84521484375,
        1890.9530029296875,
        373.0
      ],
      [
        2068.84521484375,
        1890.9530029296875,
        373.5
      ],
      [
        2065.68994140625,
        1891.2796630859375,
        373.0
      ],
      [
        2065.68994140625,
        1891.2796630859375,
        373.2529602050781
      ],
      [
        2066.873291015625,
        1892.9248046875,
        373.79107666015625
      ],
      [
        2065.68994140625,
        1891.2796630859375,
        373.5
      ],
      [
        2064.287109375,
        1892.6824951171875,
        374.0
      ],
      [
        2066.287109375,
        1893.510986328125,
        374.0
      ],
      [
        2065.68994140625,
        1891.2796630859375,
        373.5
      ],
      [
        2066.287109375,
        1893.510986328125,
        372.5
      ],
      [
        2064.287109375,
        1892.6824951171875,
        372.5
      ],
      [
        2064.287109375,
        1892.6824951171875,
        373.0
      ],
      [
        2066.287109375,
        1893.510986328125,
        373.0
      ],
      [
        1999.697998046875,
        1957.2716064453125,
        375.0
      ],
      [
        1999.697998046875,
        1957.2716064453125,
        372.5
      ],
      [
        2035.0533447265625,
        1921.916259765625,
        375.0
      ],
      [
        2035.0533447265625,
        1921.916259765625,
        372.5
      ],
      [
        2006.7689208984375,
        1896.46044921875,
        375.0
      ],
      [
        2006.7689208984375,
        1896.46044921875,
        372.5
      ],
      [
        1990.527099609375,
        1945.272216796875,
        375.0
      ],
      [
        1990.527099609375,
        1945.272216796875,
        372.5
      ],
      [
        1989.951171875,
        1947.5247802734375,
        375.0
      ],
      [
        1997.7572021484375,
        1916.9947509765625,
        372.5
      ],
      [
        1997.555419921875,
        1917.78369140625,
        372.81268310546875
      ],
      [
        2010.4443359375,
        1934.68701171875,
        375.0
      ],
      [
        1993.1810302734375,
        1934.892333984375,
        372.5
      ],
      [
        1993.8358154296875,
        1932.3311767578125,
        375.0
      ],
      [
        1997.1502685546875,
        1919.3685302734375,
        374.2461242675781
      ],
      [
        1997.555419921875,
        1917.78369140625,
        372.81268310546875
      ],
      [
        1996.6297607421875,
        1921.404052734375,
        375.0
      ],
      [
        1997.1502685546875,
        1919.3685302734375,
        374.2461242675781
      ],
      [
        2000.743408203125,
        1905.314453125,
        375.0
      ],
      [
        2000.743408203125,
        1905.314453125,
        372.5
      ],
      [
        2001.715087890625,
        1901.5142822265625,
        375.0
      ],
      [
        2016.962890625,
        1846.0794677734375,
        375.0
      ],
      [
        2041.829833984375,
        1849.496826171875,
        375.0
      ],
      [
        2043.5599365234375,
        1873.712890625,
        375.0
      ],
      [
        2043.5599365234375,
        1873.712890625,
        372.5
      ],
      [
        2016.7037353515625,
        1846.85693359375,
        375.0
      ],
      [
        2015.9613037109375,
        1849.0841064453125,
        375.0
      ],
      [
        2015.9613037109375,
        1849.0841064453125,
        372.5
      ],
      [
        2016.7037353515625,
        1846.85693359375,
        372.5
      ],
      [
        2042.73095703125,
        1871.711669921875,
        373.7911071777344
      ],
      [
        2042.73095703125,
        1871.711669921875,
        373.0
      ],
      [
        2043.5599365234375,
        1873.712890625,
        373.0
      ],
      [
        2043.5599365234375,
        1873.712890625,
        373.9999694824219
      ],
      [
        2042.73095703125,
        1871.711669921875,
        373.0
      ],
      [
        2042.73095703125,
        1871.711669921875,
        373.7911071777344
      ],
      [
        2043.20947265625,
        1870.556396484375,
        373.49993896484375
      ],
      [
        2043.20947265625,
        1870.556396484375,
        373.0
      ],
      [
        2016.962890625,
        1846.0794677734375,
        373.0
      ],
      [
        2016.962890625,
        1846.0794677734375,
        373.8153076171875
      ],
      [
        2016.7037353515625,
        1846.85693359375,
        374.00006103515625
      ],
      [
        2016.7037353515625,
        1846.85693359375,
        373.0
      ],
      [
        2045.1610107421875,
        1872.508056640625,
        375.0
      ],
      [
        2045.1610107421875,
        1872.508056640625,
        374.0
      ],
      [
        2043.20947265625,
        1870.556396484375,
        375.0
      ],
      [
        2016.962890625,
        1846.0794677734375,
        375.0
      ],
      [
        2045.1610107421875,
        1872.508056640625,
        374.0
      ],
      [
        2064.811279296875,
        1892.1583251953125,
        373.81317138671875
      ],
      [
        2051.316650390625,
        1858.9837646484375,
        373.0
      ],
      [
        2045.659912109375,
        1864.640625,
        373.0
      ],
      [
        2045.659912109375,
        1864.640625,
        373.0
      ],
      [
        2045.1611328125,
        1870.9146728515625,
        374.0
      ],
      [
        2047.8070068359375,
        1869.3167724609375,
        373.0
      ],
      [
        2012.35205078125,
        1859.912109375,
        375.0
      ],
      [
        2032.224853515625,
        1889.3892822265625,
        375.0
      ],
      [
        2028.6893310546875,
        1885.853759765625,
        375.0
      ],
      [
        2028.6893310546875,
        1885.853759765625,
        375.0
      ],
      [
        2032.224853515625,
        1882.3182373046875,
        375.0
      ],
      [
        2032.224853515625,
        1889.3892822265625,
        375.0
      ],
      [
        2035.7603759765625,
        1885.853759765625,
        375.0
      ],
      [
        2032.224853515625,
        1882.3182373046875,
        375.0
      ],
      [
        2035.7603759765625,
        1885.853759765625,
        375.0
      ],
      [
        2012.35205078125,
        1859.912109375,
        385.0
      ],
      [
        2003.869873046875,
        1938.2503662109375,
        385.0
      ],
      [
        2006.733642578125,
        1936.5650634765625,
        385.0
      ],
      [
        2018.2005615234375,
        1923.919677734375,
        385.0
      ],
      [
        2017.316650390625,
        1921.26806640625,
        385.0
      ],
      [
        2011.71875,
        1931.5799560546875,
        385.0
      ],
      [
        2013.7811279296875,
        1928.339111328125,
        385.0
      ],
      [
        2011.71875,
        1931.5799560546875,
        385.0
      ],
      [
        2006.733642578125,
        1936.5650634765625,
        385.0
      ],
      [
        2015.2542724609375,
        1916.2593994140625,
        385.0
      ],
      [
        2017.316650390625,
        1921.26806640625,
        385.0
      ],
      [
        1994.093017578125,
        1931.3251953125,
        378.9796447753906
      ],
      [
        1994.439697265625,
        1929.9696044921875,
        382.32122802734375
      ],
      [
        2015.2542724609375,
        1916.2593994140625,
        385.0
      ],
      [
        2009.1466064453125,
        1914.1087646484375,
        381.32623291015625
      ],
      [
        2010.1318359375,
        1914.45556640625,
        385.0
      ],
      [
        2009.1466064453125,
        1914.1087646484375,
        381.32623291015625
      ],
      [
        1995.7393798828125,
        1924.885986328125,
        382.4029846191406
      ],
      [
        1996.5723876953125,
        1921.628173828125,
        376.6238708496094
      ],
      [
        1993.8358154296875,
        1932.3311767578125,
        375.0
      ],
      [
        1994.093017578125,
        1931.3251953125,
        378.9796447753906
      ],
      [
        1996.5723876953125,
        1921.628173828125,
        376.6238708496094
      ],
      [
        1996.6297607421875,
        1921.404052734375,
        375.0
      ],
      [
        1995.7393798828125,
        1924.885986328125,
        382.4029846191406
      ],
      [
        1996.2811279296875,
        1922.7672119140625,
        383.1039123535156
      ],
      [
        2007.808837890625,
        1913.71533203125,
        385.0
      ],
      [
        2009.54931640625,
        1914.25048828125,
        385.0
      ],
      [
        2009.54931640625,
        1914.25048828125,
        385.0
      ],
      [
        2007.808837890625,
        1913.71533203125,
        385.0
      ],
      [
        2007.4420166015625,
        1913.465576171875,
        385.0
      ],
      [
        1998.1826171875,
        1915.3304443359375,
        384.2426452636719
      ],
      [
        1998.125732421875,
        1915.5528564453125,
        385.0
      ],
      [
        2002.230712890625,
        1911.84716796875,
        385.0
      ],
      [
        2003.6923828125,
        1910.79638671875,
        385.0
      ],
      [
        2006.365966796875,
        1912.7330322265625,
        385.0
      ],
      [
        1996.5802001953125,
        1921.5975341796875,
        383.4908752441406
      ],
      [
        1997.2950439453125,
        1918.8018798828125,
        383.7947082519531
      ],
      [
        2002.230712890625,
        1911.84716796875,
        385.0
      ],
      [
        2003.6923828125,
        1910.79638671875,
        385.0
      ],
      [
        1996.4993896484375,
        1921.9136962890625,
        383.38629150390625
      ],
      [
        1996.5802001953125,
        1921.5975341796875,
        383.4908752441406
      ],
      [
        2006.365966796875,
        1912.7330322265625,
        385.0
      ],
      [
        1997.3709716796875,
        1918.5048828125,
        383.8269958496094
      ],
      [
        1998.1826171875,
        1915.3304443359375,
        384.2426452636719
      ],
      [
        1996.4921875,
        1921.94189453125,
        383.376953125
      ],
      [
        1997.3709716796875,
        1918.5048828125,
        383.8269958496094
      ],
      [
        1994.439697265625,
        1929.9696044921875,
        382.32122802734375
      ],
      [
        1995.9100341796875,
        1932.7108154296875,
        385.0
      ],
      [
        1994.4979248046875,
        1929.7418212890625,
        385.0
      ],
      [
        1996.251220703125,
        1934.090087890625,
        385.0
      ],
      [
        1995.9100341796875,
        1932.7108154296875,
        385.0
      ],
      [
        2003.869873046875,
        1938.2503662109375,
        385.0
      ],
      [
        1998.802734375,
        1935.6036376953125,
        385.0
      ],
      [
        1996.302490234375,
        1934.2974853515625,
        385.0
      ],
      [
        1996.4837646484375,
        1935.0299072265625,
        385.0
      ],
      [
        1998.802734375,
        1935.6036376953125,
        385.0
      ],
      [
        1996.4837646484375,
        1935.0299072265625,
        385.0
      ],
      [
        2013.7811279296875,
        1928.339111328125,
        385.0
      ],
      [
        2018.2005615234375,
        1923.919677734375,
        385.0
      ],
      [
        2032.224853515625,
        1889.3892822265625,
        385.0
      ],
      [
        2028.6893310546875,
        1885.853759765625,
        385.0
      ],
      [
        2028.6893310546875,
        1885.853759765625,
        385.0
      ],
      [
        2032.224853515625,
        1882.3182373046875,
        385.0
      ],
      [
        2032.224853515625,
        1889.3892822265625,
        385.0
      ],
      [
        2035.7603759765625,
        1885.853759765625,
        385.0
      ],
      [
        2032.224853515625,
        1882.3182373046875,
        385.0
      ],
      [
        2035.7603759765625,
        1885.853759765625,
        385.0
      ],
      [
        2068.84521484375,
        1890.9530029296875,
        373.2692565917969
      ],
      [
        1974.996337890625,
        2006.0147705078125,
        385.0
      ],
      [
        2049.06591796875,
        1979.76953125,
        385.0
      ],
      [
        2042.7020263671875,
        1986.1334228515625,
        385.0
      ],
      [
        2048.35888671875,
        1980.4765625,
        385.0
      ],
      [
        2049.06591796875,
        1979.76953125,
        385.0
      ],
      [
        2048.35888671875,
        1980.4765625,
        385.0
      ],
      [
        2043.4090576171875,
        1985.4263916015625,
        385.0
      ],
      [
        2043.4090576171875,
        1985.4263916015625,
        385.0
      ],
      [
        2042.7020263671875,
        1986.1334228515625,
        385.0
      ],
      [
        2011.01171875,
        1991.212646484375,
        385.0
      ],
      [
        2014.5472412109375,
        1987.6771240234375,
        385.0
      ],
      [
        2003.8316650390625,
        1991.3216552734375,
        382.0
      ],
      [
        1996.7606201171875,
        1984.2506103515625,
        382.0
      ],
      [
        1996.7606201171875,
        1998.3927001953125,
        382.0
      ],
      [
        2003.8316650390625,
        1991.3216552734375,
        382.0
      ],
      [
        2014.5472412109375,
        1987.6771240234375,
        385.0
      ],
      [
        2018.082763671875,
        1991.212646484375,
        385.0
      ],
      [
        2014.5472412109375,
        1994.7481689453125,
        385.0
      ],
      [
        2011.01171875,
        1991.212646484375,
        385.0
      ],
      [
        2014.5472412109375,
        1994.7481689453125,
        385.0
      ],
      [
        2018.082763671875,
        1991.212646484375,
        385.0
      ],
      [
        2062.5009765625,
        1966.33447265625,
        385.0
      ],
      [
        2056.84423828125,
        1971.9912109375,
        385.0
      ],
      [
        2056.136962890625,
        1972.6983642578125,
        385.0
      ],
      [
        2056.84423828125,
        1971.9912109375,
        385.0
      ],
      [
        2056.136962890625,
        1972.6983642578125,
        385.0
      ],
      [
        2061.7939453125,
        1967.04150390625,
        385.0
      ],
      [
        2062.5009765625,
        1966.33447265625,
        385.0
      ],
      [
        2061.7939453125,
        1967.04150390625,
        385.0
      ],
      [
        2064.044677734375,
        1938.1796875,
        385.0
      ],
      [
        2067.580322265625,
        1934.6441650390625,
        385.0
      ],
      [
        2075.46728515625,
        1919.6859130859375,
        382.0
      ],
      [
        2067.689208984375,
        1927.464111328125,
        382.0
      ],
      [
        2067.689208984375,
        1927.464111328125,
        382.0
      ],
      [
        2060.6181640625,
        1920.39306640625,
        382.0
      ],
      [
        2067.580322265625,
        1941.7152099609375,
        385.0
      ],
      [
        2064.044677734375,
        1938.1796875,
        385.0
      ],
      [
        2067.580322265625,
        1934.6441650390625,
        385.0
      ],
      [
        2071.11572265625,
        1938.1796875,
        385.0
      ],
      [
        2067.580322265625,
        1941.7152099609375,
        385.0
      ],
      [
        2071.11572265625,
        1938.1796875,
        385.0
      ],
      [
        1974.996337890625,
        2006.0147705078125,
        410.0
      ],
      [
        1980.99072265625,
        1982.5692138671875,
        410.0
      ],
      [
        1980.99072265625,
        1982.5692138671875,
        410.0
      ],
      [
        1999.2861328125,
        1911.0142822265625,
        410.0
      ],
      [
        2008.5718994140625,
        1874.696533203125,
        390.8854675292969
      ],
      [
        1999.2861328125,
        1911.0142822265625,
        410.0
      ],
      [
        2008.5718994140625,
        1874.696533203125,
        390.8854675292969
      ],
      [
        2012.35205078125,
        1859.912109375,
        390.0
      ],
      [
        2027.427490234375,
        1847.517578125,
        385.0
      ],
      [
        2041.829833984375,
        1849.496826171875,
        396.58349609375
      ],
      [
        2012.35205078125,
        1859.912109375,
        385.0
      ],
      [
        2012.35205078125,
        1859.912109375,
        390.0
      ],
      [
        2034.3463134765625,
        1880.197021484375,
        408.5
      ],
      [
        2037.8818359375,
        1883.732421875,
        408.5
      ],
      [
        2037.8818359375,
        1883.732421875,
        408.5
      ],
      [
        2034.3463134765625,
        1880.197021484375,
        408.5
      ],
      [
        2034.3463134765625,
        1880.197021484375,
        410.0
      ],
      [
        2037.8818359375,
        1883.732421875,
        410.0
      ],
      [
        2034.34619140625,
        1891.5106201171875,
        408.5
      ],
      [
        2034.34619140625,
        1891.5106201171875,
        410.0
      ],
      [
        2034.34619140625,
        1891.5106201171875,
        408.5
      ],
      [
        2026.5679931640625,
        1883.732421875,
        408.5
      ],
      [
        2026.5679931640625,
        1883.732421875,
        410.0
      ],
      [
        2026.5679931640625,
        1883.732421875,
        408.5
      ],
      [
        2018.041748046875,
        1924.0784912109375,
        390.0
      ],
      [
        2016.4613037109375,
        1930.0238037109375,
        398.4321594238281
      ],
      [
        1997.9195556640625,
        1916.35888671875,
        387.7452087402344
      ],
      [
        2002.818115234375,
        1918.790771484375,
        402.1490783691406
      ],
      [
        2008.7008056640625,
        1913.9896240234375,
        385.0
      ],
      [
        2014.943115234375,
        1916.1497802734375,
        385.0
      ],
      [
        2000.952880859375,
        1914.31982421875,
        388.01995849609375
      ],
      [
        2000.784912109375,
        1913.3602294921875,
        385.9206237792969
      ],
      [
        2000.952880859375,
        1914.31982421875,
        388.01995849609375
      ],
      [
        1997.6983642578125,
        1917.2242431640625,
        388.3355407714844
      ],
      [
        1996.8558349609375,
        1920.51953125,
        388.67864990234375
      ],
      [
        1997.86181640625,
        1916.584716796875,
        388.1034240722656
      ],
      [
        1997.6983642578125,
        1917.2242431640625,
        388.3355407714844
      ],
      [
        1997.9195556640625,
        1916.35888671875,
        387.7452087402344
      ],
      [
        1997.86181640625,
        1916.584716796875,
        388.1034240722656
      ],
      [
        1998.162841796875,
        1921.90185546875,
        390.0
      ],
      [
        1998.162841796875,
        1921.90185546875,
        390.0
      ],
      [
        1996.8558349609375,
        1920.51953125,
        388.67864990234375
      ],
      [
        1996.8521728515625,
        1920.533935546875,
        388.6831970214844
      ],
      [
        1995.388671875,
        1926.25830078125,
        390.6636962890625
      ],
      [
        1995.093505859375,
        1927.4124755859375,
        390.597900390625
      ],
      [
        1995.77978515625,
        1924.7281494140625,
        390.0
      ],
      [
        1995.388671875,
        1926.25830078125,
        390.6636962890625
      ],
      [
        1995.77978515625,
        1924.7281494140625,
        390.0
      ],
      [
        2010.57568359375,
        1931.5445556640625,
        390.0
      ],
      [
        1995.0887451171875,
        1927.43115234375,
        390.5968322753906
      ],
      [
        1994.36962890625,
        1930.2437744140625,
        390.0
      ],
      [
        1995.0887451171875,
        1927.43115234375,
        390.5968322753906
      ],
      [
        1994.36962890625,
        1930.2437744140625,
        390.0
      ],
      [
        1994.5623779296875,
        1929.489990234375,
        387.9612731933594
      ],
      [
        1994.5623779296875,
        1929.489990234375,
        387.9612731933594
      ],
      [
        2001.8077392578125,
        1937.1732177734375,
        385.0
      ],
      [
        2017.8411865234375,
        1924.279052734375,
        385.0
      ],
      [
        2018.041748046875,
        1924.0784912109375,
        390.0
      ],
      [
        1973.2493896484375,
        2012.847412109375,
        410.0
      ],
      [
        1973.2493896484375,
        2012.847412109375,
        410.8990478515625
      ],
      [
        1973.2493896484375,
        2012.847412109375,
        410.0
      ],
      [
        1973.2493896484375,
        2012.847412109375,
        385.0
      ],
      [
        1973.2493896484375,
        2012.847412109375,
        410.8990478515625
      ],
      [
        1974.996337890625,
        2006.0147705078125,
        410.0
      ],
      [
        2067.580322265625,
        1934.6441650390625,
        405.0
      ],
      [
        2064.044677734375,
        1938.1796875,
        405.0
      ],
      [
        2014.5472412109375,
        1987.6771240234375,
        405.0
      ],
      [
        2011.01171875,
        1991.212646484375,
        405.0
      ],
      [
        1952.9219970703125,
        1929.09423828125,
        370.0
      ],
      [
        1990.959228515625,
        1919.3411865234375,
        370.0
      ],
      [
        1990.959228515625,
        1919.3411865234375,
        370.0
      ],
      [
        1997.5919189453125,
        1917.6405029296875,
        370.0
      ],
      [
        1990.959228515625,
        1919.3411865234375,
        410.0
      ],
      [
        1997.5919189453125,
        1917.6405029296875,
        410.0
      ],
      [
        1990.95947265625,
        1919.341064453125,
        665.0
      ],
      [
        1997.5919189453125,
        1917.6405029296875,
        665.0
      ],
      [
        1952.9219970703125,
        1929.09423828125,
        390.0
      ],
      [
        1990.959228515625,
        1919.3411865234375,
        410.0
      ],
      [
        1922.447021484375,
        1940.5953369140625,
        376.5834655761719
      ],
      [
        1923.8851318359375,
        1951.0599365234375,
        385.0
      ],
      [
        1923.8851318359375,
        1951.0599365234375,
        385.0
      ],
      [
        1925.8643798828125,
        1965.4622802734375,
        396.58349609375
      ],
      [
        1940.301025390625,
        1934.6441650390625,
        385.0
      ],
      [
        1940.301025390625,
        1934.6441650390625,
        385.0
      ],
      [
        1922.447021484375,
        1940.5953369140625,
        376.5834655761719
      ],
      [
        1952.9219970703125,
        1929.09423828125,
        385.0
      ],
      [
        1952.9219970703125,
        1929.09423828125,
        390.0
      ],
      [
        1952.9219970703125,
        1929.09423828125,
        385.0
      ],
      [
        1952.9219970703125,
        1929.09423828125,
        370.0
      ],
      [
        1956.5645751953125,
        1953.7359619140625,
        408.5
      ],
      [
        1960.10009765625,
        1950.200439453125,
        408.5
      ],
      [
        1960.10009765625,
        1950.200439453125,
        408.5
      ],
      [
        1956.5645751953125,
        1953.7359619140625,
        408.5
      ],
      [
        1956.5645751953125,
        1953.7359619140625,
        410.0
      ],
      [
        1960.10009765625,
        1950.200439453125,
        410.0
      ],
      [
        1956.5645751953125,
        1953.7359619140625,
        373.0
      ],
      [
        1960.10009765625,
        1950.200439453125,
        373.0
      ],
      [
        1960.10009765625,
        1950.200439453125,
        370.0
      ],
      [
        1956.5645751953125,
        1953.7359619140625,
        370.0
      ],
      [
        1960.10009765625,
        1950.200439453125,
        373.0
      ],
      [
        1956.5645751953125,
        1953.7359619140625,
        373.0
      ],
      [
        1967.878173828125,
        1957.9786376953125,
        408.5
      ],
      [
        1964.342529296875,
        1961.5142822265625,
        408.5
      ],
      [
        1964.342529296875,
        1961.5142822265625,
        408.5
      ],
      [
        1967.878173828125,
        1957.9786376953125,
        408.5
      ],
      [
        1967.878173828125,
        1957.9786376953125,
        410.0
      ],
      [
        1964.342529296875,
        1961.5142822265625,
        410.0
      ],
      [
        1967.878173828125,
        1957.9786376953125,
        373.0
      ],
      [
        1964.342529296875,
        1961.5142822265625,
        373.0
      ],
      [
        1964.342529296875,
        1961.5142822265625,
        370.0
      ],
      [
        1967.878173828125,
        1957.9786376953125,
        370.0
      ],
      [
        1964.342529296875,
        1961.5142822265625,
        373.0
      ],
      [
        1967.878173828125,
        1957.9786376953125,
        373.0
      ],
      [
        1985.2537841796875,
        1920.8040771484375,
        372.5
      ],
      [
        1997.5919189453125,
        1917.640380859375,
        372.5
      ],
      [
        1981.4500732421875,
        1921.779296875,
        370.0
      ],
      [
        1972.827880859375,
        1930.4014892578125,
        372.5
      ],
      [
        1981.4500732421875,
        1921.779296875,
        372.5
      ],
      [
        1981.4500732421875,
        1921.779296875,
        375.0
      ],
      [
        1985.2537841796875,
        1920.8040771484375,
        375.0
      ],
      [
        1974.2420654296875,
        1928.9873046875,
        375.0
      ],
      [
        1974.2420654296875,
        1928.9873046875,
        372.5
      ],
      [
        1985.2537841796875,
        1920.8040771484375,
        375.0
      ],
      [
        1985.2537841796875,
        1920.8040771484375,
        372.5
      ],
      [
        1981.4500732421875,
        1921.779296875,
        375.0
      ],
      [
        1996.7725830078125,
        1917.8504638671875,
        372.5
      ],
      [
        1997.592041015625,
        1917.640380859375,
        372.7558898925781
      ],
      [
        1995.206298828125,
        1918.2520751953125,
        384.7431945800781
      ],
      [
        1996.27685546875,
        1917.9776611328125,
        387.8645324707031
      ],
      [
        1995.1832275390625,
        1918.258056640625,
        384.2426452636719
      ],
      [
        1995.206298828125,
        1918.2520751953125,
        384.7431945800781
      ],
      [
        1995.2623291015625,
        1926.7523193359375,
        390.6355285644531
      ],
      [
        1994.2479248046875,
        1930.71923828125,
        380.4732360839844
      ],
      [
        1995.1832275390625,
        1918.258056640625,
        384.2426452636719
      ],
      [
        1996.7742919921875,
        1917.85009765625,
        384.0301513671875
      ],
      [
        1996.7742919921875,
        1917.85009765625,
        384.0301513671875
      ],
      [
        1997.592041015625,
        1917.640380859375,
        383.940185546875
      ],
      [
        1996.27685546875,
        1917.9776611328125,
        387.8645324707031
      ],
      [
        1997.5919189453125,
        1917.640380859375,
        388.3788757324219
      ],
      [
        1971.392578125,
        1988.5047607421875,
        370.0
      ],
      [
        1971.392578125,
        1988.5047607421875,
        375.0
      ],
      [
        1950.0802001953125,
        1967.1923828125,
        375.0
      ],
      [
        1950.0802001953125,
        1967.1923828125,
        370.0
      ],
      [
        1948.0792236328125,
        1966.363525390625,
        373.0
      ],
      [
        1948.0792236328125,
        1966.363525390625,
        373.7910461425781
      ],
      [
        1950.0802001953125,
        1967.1923828125,
        373.99993896484375
      ],
      [
        1950.0802001953125,
        1967.1923828125,
        373.0
      ],
      [
        1971.392578125,
        1988.5047607421875,
        373.0
      ],
      [
        1971.392578125,
        1988.5047607421875,
        373.9999694824219
      ],
      [
        1972.2213134765625,
        1990.505615234375,
        373.7911071777344
      ],
      [
        1972.2213134765625,
        1990.505615234375,
        373.0
      ],
      [
        1972.2213134765625,
        1990.505615234375,
        373.0
      ],
      [
        1972.2213134765625,
        1990.505615234375,
        373.7911071777344
      ],
      [
        1971.7427978515625,
        1991.6607666015625,
        373.4999694824219
      ],
      [
        1971.7427978515625,
        1991.6607666015625,
        373.0
      ],
      [
        1948.0792236328125,
        1966.363525390625,
        373.7910461425781
      ],
      [
        1948.0792236328125,
        1966.363525390625,
        373.0
      ],
      [
        1946.9241943359375,
        1966.8419189453125,
        373.0
      ],
      [
        1946.9241943359375,
        1966.8419189453125,
        373.4999694824219
      ],
      [
        1969.7916259765625,
        1989.7095947265625,
        375.0
      ],
      [
        1969.7916259765625,
        1989.7095947265625,
        374.0
      ],
      [
        1971.7427978515625,
        1991.6607666015625,
        375.0
      ],
      [
        1948.8756103515625,
        1968.79345703125,
        374.0
      ],
      [
        1948.8756103515625,
        1968.79345703125,
        375.0
      ],
      [
        1946.9241943359375,
        1966.8419189453125,
        375.0
      ],
      [
        1969.7916259765625,
        1989.7095947265625,
        374.0
      ],
      [
        1948.8756103515625,
        1968.79345703125,
        374.0
      ],
      [
        1941.008056640625,
        1969.2923583984375,
        373.0
      ],
      [
        1935.351318359375,
        1974.94921875,
        373.0
      ],
      [
        1941.008056640625,
        1969.2923583984375,
        373.0
      ],
      [
        1969.2923583984375,
        1997.57666015625,
        373.0
      ],
      [
        1969.79150390625,
        1991.3018798828125,
        374.0
      ],
      [
        1947.2822265625,
        1968.7935791015625,
        374.0
      ],
      [
        1967.1455078125,
        1992.9002685546875,
        373.0
      ],
      [
        1945.684326171875,
        1971.4393310546875,
        373.0
      ],
      [
        1970.70654296875,
        2010.3045654296875,
        375.0
      ],
      [
        1974.996337890625,
        2006.0147705078125,
        375.0
      ],
      [
        2010.38427734375,
        1865.8155517578125,
        385.88720703125
      ],
      [
        2010.38427734375,
        1865.8155517578125,
        390.0
      ],
      [
        2010.38427734375,
        1865.8155517578125,
        390.0
      ],
      [
        2011.0001220703125,
        1865.19970703125,
        390.3166809082031
      ],
      [
        2011.0001220703125,
        1865.19970703125,
        370.0
      ],
      [
        2010.38427734375,
        1865.8155517578125,
        370.0
      ],
      [
        2010.38427734375,
        1865.8155517578125,
        385.0
      ],
      [
        2010.38427734375,
        1865.8155517578125,
        370.0
      ],
      [
        2010.38427734375,
        1865.8155517578125,
        385.0
      ],
      [
        1910.0,
        1830.0,
        370.0
      ],
      [
        1910.0,
        1896.0,
        1059.422119140625
      ],
      [
        1910.0,
        1895.4892578125,
        1060.0
      ],
      [
        1975.4892578125,
        1830.0,
        1060.0
      ],
      [
        1975.800048828125,
        1830.0,
        1059.6484375
      ],
      [
        1968.064697265625,
        1837.4246826171875,
        1060.0
      ],
      [
        1975.4892578125,
        1830.0,
        1060.0
      ],
      [
        1917.3707275390625,
        1888.118408203125,
        1060.0
      ],
      [
        1910.0,
        1895.4891357421875,
        1060.0
      ],
      [
        1968.0645751953125,
        1837.4246826171875,
        1060.0
      ],
      [
        1917.3707275390625,
        1888.118408203125,
        1060.0
      ],
      [
        1913.6175537109375,
        1830.0,
        1130.0
      ],
      [
        1961.243408203125,
        1830.0,
        1130.0
      ],
      [
        1910.0,
        1881.243408203125,
        1130.0
      ],
      [
        1910.0,
        1833.6175537109375,
        1130.0
      ],
      [
        1975.800048828125,
        1830.0,
        1059.6484375
      ],
      [
        1975.800048828125,
        1830.0,
        1060.0
      ],
      [
        1956.5875244140625,
        1830.0,
        1060.0
      ],
      [
        1910.0,
        1876.693359375,
        1060.0
      ],
      [
        1910.0,
        1830.0,
        1060.0
      ],
      [
        1956.5875244140625,
        1830.0,
        1060.0
      ],
      [
        1910.0,
        1876.693359375,
        1060.0
      ],
      [
        1910.0,
        1830.0,
        1130.0
      ],
      [
        1940.753173828125,
        1830.0,
        375.0
      ],
      [
        1910.0,
        1860.753173828125,
        375.0
      ],
      [
        1910.0,
        1860.753173828125,
        370.0
      ],
      [
        1940.753173828125,
        1830.0,
        370.0
      ],
      [
        1910.0,
        1860.753173828125,
        375.0
      ],
      [
        1940.753173828125,
        1830.0,
        375.0
      ],
      [
        1912.4688720703125,
        1830.0,
        375.0
      ],
      [
        1910.0,
        1832.4688720703125,
        375.0
      ],
      [
        1910.0,
        1832.4688720703125,
        375.0
      ],
      [
        1912.4688720703125,
        1830.0,
        375.0
      ],
      [
        1912.4688720703125,
        1830.0,
        380.0
      ],
      [
        1910.0,
        1832.4688720703125,
        380.0
      ],
      [
        1910.0,
        1832.4688720703125,
        380.0
      ],
      [
        1912.4688720703125,
        1830.0,
        380.0
      ],
      [
        1910.0,
        1830.0,
        380.0
      ],
      [
        1840.0,
        1830.0,
        370.0
      ],
      [
        1840.0,
        1830.0,
        370.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1060.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1060.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1130.0
      ],
      [
        1880.41455078125,
        1830.0,
        1130.0
      ],
      [
        1799.58544921875,
        1830.0,
        1130.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1130.0
      ],
      [
        1880.41455078125,
        1830.0,
        1130.0
      ],
      [
        1840.0001220703125,
        1830.0,
        1130.0
      ],
      [
        1840.0001220703125,
        1830.0,
        1130.0
      ],
      [
        1799.58544921875,
        1830.0,
        1130.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1130.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1130.0
      ],
      [
        1872.5001220703125,
        1841.2918701171875,
        1110.0
      ],
      [
        1852.5001220703125,
        1846.6510009765625,
        1110.0
      ],
      [
        1872.5001220703125,
        1841.2918701171875,
        1115.0
      ],
      [
        1872.5001220703125,
        1841.2918701171875,
        1110.0
      ],
      [
        1787.0576171875,
        1830.0,
        1106.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1130.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1060.0
      ],
      [
        1787.0576171875,
        1830.0,
        1106.0
      ],
      [
        1784.6409912109375,
        1830.0,
        1115.0
      ],
      [
        1784.6409912109375,
        1830.0,
        1110.0
      ],
      [
        1784.6409912109375,
        1830.0,
        1110.0
      ],
      [
        1784.3255615234375,
        1830.0,
        1110.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1060.0
      ],
      [
        1892.9427490234375,
        1830.0,
        1106.0
      ],
      [
        1869.4744873046875,
        1830.0,
        1110.0
      ],
      [
        1848.03857421875,
        1830.0,
        1110.0
      ],
      [
        1869.4744873046875,
        1830.0,
        1115.0
      ],
      [
        1869.4744873046875,
        1830.0,
        1110.0
      ],
      [
        1795.8153076171875,
        1830.0,
        383.0
      ],
      [
        1884.1846923828125,
        1830.0,
        383.0
      ],
      [
        1788.7442626953125,
        1830.0,
        380.0
      ],
      [
        1891.2557373046875,
        1830.0,
        380.0
      ],
      [
        1884.3826904296875,
        1836.873046875,
        383.0
      ],
      [
        1839.9998779296875,
        1848.76513671875,
        383.0
      ],
      [
        1839.9998779296875,
        1848.76513671875,
        383.0
      ],
      [
        1795.6173095703125,
        1836.873046875,
        383.0
      ],
      [
        1788.7442626953125,
        1830.0,
        380.0
      ],
      [
        1795.6173095703125,
        1836.873046875,
        383.0
      ],
      [
        1788.7442626953125,
        1830.0,
        383.0
      ],
      [
        1891.2557373046875,
        1830.0,
        380.0
      ],
      [
        1891.2557373046875,
        1830.0,
        383.0
      ],
      [
        1884.3826904296875,
        1836.873046875,
        383.0
      ],
      [
        1795.8153076171875,
        1830.0,
        385.0
      ],
      [
        1884.1846923828125,
        1830.0,
        385.0
      ],
      [
        1884.3826904296875,
        1836.873046875,
        385.0
      ],
      [
        1839.9998779296875,
        1848.76513671875,
        385.0
      ],
      [
        1839.9998779296875,
        1848.76513671875,
        385.0
      ],
      [
        1795.6173095703125,
        1836.873046875,
        385.0
      ],
      [
        1795.6173095703125,
        1836.873046875,
        385.0
      ],
      [
        1788.7442626953125,
        1830.0,
        385.0
      ],
      [
        1891.2557373046875,
        1830.0,
        385.0
      ],
      [
        1884.3826904296875,
        1836.873046875,
        385.0
      ],
      [
        1795.8153076171875,
        1830.0,
        385.0
      ],
      [
        1795.8153076171875,
        1830.0,
        383.0
      ],
      [
        1884.1846923828125,
        1830.0,
        385.0
      ],
      [
        1884.1846923828125,
        1830.0,
        383.0
      ],
      [
        1788.7442626953125,
        1830.0,
        390.0
      ],
      [
        1795.8153076171875,
        1830.0,
        390.0
      ],
      [
        1891.2557373046875,
        1830.0,
        390.0
      ],
      [
        1884.1846923828125,
        1830.0,
        390.0
      ],
      [
        1788.7442626953125,
        1830.0,
        390.0
      ],
      [
        1891.2557373046875,
        1830.0,
        390.0
      ],
      [
        1795.8153076171875,
        1830.0,
        390.0
      ],
      [
        1795.8153076171875,
        1830.0,
        385.0
      ],
      [
        1884.1846923828125,
        1830.0,
        390.0
      ],
      [
        1884.1846923828125,
        1830.0,
        385.0
      ],
      [
        1144.2117919921875,
        1390.0,
        775.0
      ],
      [
        1144.2117919921875,
        1390.0,
        440.0
      ],
      [
        1520.0,
        1390.0,
        700.1072387695312
      ],
      [
        1520.0,
        1390.0,
        490.0
      ],
      [
        1520.0,
        1390.0,
        490.0
      ],
      [
        1520.0,
        1390.0,
        160.0
      ],
      [
        1630.0,
        1390.0,
        490.0
      ],
      [
        1630.0,
        1390.0,
        777.8890380859375
      ],
      [
        1630.0,
        1390.0,
        160.0
      ],
      [
        1630.0,
        1390.0,
        490.0
      ],
      [
        1510.0,
        1100.0,
        465.0
      ],
      [
        1510.0,
        1100.0,
        515.0
      ],
      [
        1590.0,
        1100.0,
        465.0
      ],
      [
        1590.0,
        1100.0,
        515.0
      ],
      [
        1740.0,
        1166.75390625,
        430.0
      ],
      [
        1745.0,
        1135.0,
        425.0
      ],
      [
        1740.0,
        1103.24609375,
        430.0
      ],
      [
        1745.0,
        1135.0,
        425.0
      ],
      [
        1734.7652587890625,
        1200.0,
        420.0
      ],
      [
        1733.1905517578125,
        1210.0,
        410.0
      ],
      [
        1420.0,
        1390.0,
        490.0
      ],
      [
        1420.0,
        1390.0,
        629.3965454101562
      ],
      [
        1420.0,
        1390.0,
        160.5279998779297
      ],
      [
        1420.0,
        1390.0,
        490.0
      ],
      [
        1430.0,
        1400.0,
        490.0
      ],
      [
        1430.0,
        1400.0,
        643.5386962890625
      ],
      [
        1430.0,
        1400.0,
        160.0
      ],
      [
        1430.0,
        1400.0,
        490.0
      ],
      [
        1480.0,
        1540.0,
        490.0
      ],
      [
        1480.0,
        1540.0,
        777.8890380859375
      ],
      [
        1480.0,
        1540.0,
        490.0
      ],
      [
        1480.0,
        1540.0,
        160.0
      ],
      [
        1342.0,
        1630.0,
        395.0
      ],
      [
        1342.0,
        1690.0,
        395.0
      ],
      [
        1325.0,
        1685.0,
        429.0
      ],
      [
        1342.0,
        1685.0,
        395.0
      ],
      [
        1184.2298583984375,
        1685.0,
        415.0
      ],
      [
        1319.5,
        1661.207275390625,
        440.0
      ],
      [
        1320.0,
        1660.0,
        438.9999084472656
      ],
      [
        1319.5,
        1658.792724609375,
        440.0
      ],
      [
        1320.0,
        1660.0,
        438.9999084472656
      ],
      [
        1332.0,
        1690.0,
        415.0
      ],
      [
        1332.0,
        1685.0,
        415.0
      ],
      [
        1735.0,
        1490.0,
        392.0
      ],
      [
        1735.0,
        1530.5,
        392.0
      ],
      [
        1735.0,
        1530.5,
        370.0
      ],
      [
        1735.0,
        1490.0,
        370.0
      ],
      [
        1735.0,
        1490.0,
        392.0
      ],
      [
        1735.0,
        1490.0,
        382.0
      ],
      [
        1735.0,
        1490.0,
        382.0
      ],
      [
        1735.0,
        1490.0,
        370.0
      ],
      [
        1735.0,
        1511.5,
        392.0
      ],
      [
        1735.0,
        1511.5,
        391.5
      ],
      [
        1735.0,
        1512.5,
        391.5
      ],
      [
        1735.0,
        1512.5,
        392.0
      ],
      [
        1735.0,
        1511.5,
        391.5
      ],
      [
        1735.0,
        1512.5,
        391.5
      ],
      [
        1735.0,
        1503.5,
        392.0
      ],
      [
        1735.0,
        1503.5,
        391.5
      ],
      [
        1735.0,
        1504.5001220703125,
        391.5
      ],
      [
        1735.0,
        1504.5001220703125,
        392.0
      ],
      [
        1735.0,
        1503.5,
        391.5
      ],
      [
        1735.0,
        1504.5001220703125,
        391.5
      ],
      [
        1735.0,
        1495.5,
        392.0
      ],
      [
        1735.0,
        1495.5,
        391.5
      ],
      [
        1735.0,
        1496.5,
        391.5
      ],
      [
        1735.0,
        1496.5,
        392.0
      ],
      [
        1735.0,
        1495.5,
        391.5
      ],
      [
        1735.0,
        1496.5,
        391.5
      ],
      [
        1735.0,
        1530.5,
        391.5
      ],
      [
        1767.9998779296875,
        1530.4998779296875,
        391.5
      ],
      [
        1770.0001220703125,
        1689.9998779296875,
        370.0
      ],
      [
        1770.0001220703125,
        1624.0001220703125,
        1059.4224853515625
      ],
      [
        1770.0001220703125,
        1624.5106201171875,
        1060.0
      ],
      [
        1704.5108642578125,
        1689.9998779296875,
        1060.0
      ],
      [
        1704.1998291015625,
        1689.9998779296875,
        1059.6480712890625
      ],
      [
        1711.935546875,
        1682.575439453125,
        1060.0
      ],
      [
        1704.5111083984375,
        1689.9998779296875,
        1060.0
      ],
      [
        1762.6292724609375,
        1631.881591796875,
        1060.0
      ],
      [
        1770.0001220703125,
        1624.5108642578125,
        1060.0
      ],
      [
        1711.935546875,
        1682.575439453125,
        1060.0
      ],
      [
        1762.6292724609375,
        1631.881591796875,
        1060.0
      ],
      [
        1766.3829345703125,
        1689.9998779296875,
        1130.0
      ],
      [
        1718.75634765625,
        1689.9998779296875,
        1130.0
      ],
      [
        1770.0001220703125,
        1638.7567138671875,
        1130.0
      ],
      [
        1770.0001220703125,
        1686.3826904296875,
        1130.0
      ],
      [
        1706.639892578125,
        1689.9998779296875,
        1130.0
      ],
      [
        1718.75634765625,
        1689.9998779296875,
        1130.0
      ],
      [
        1770.0001220703125,
        1638.7567138671875,
        1130.0
      ],
      [
        1770.0001220703125,
        1626.6397705078125,
        1130.0
      ],
      [
        1770.0001220703125,
        1624.0001220703125,
        1060.0
      ],
      [
        1770.0001220703125,
        1624.0001220703125,
        1059.4224853515625
      ],
      [
        1723.4122314453125,
        1689.9998779296875,
        1060.0
      ],
      [
        1770.0001220703125,
        1643.3067626953125,
        1060.0
      ],
      [
        1770.0001220703125,
        1689.9998779296875,
        1060.0
      ],
      [
        1723.4122314453125,
        1689.9998779296875,
        1060.0
      ],
      [
        1770.0001220703125,
        1643.3067626953125,
        1060.0
      ],
      [
        1770.0001220703125,
        1689.9998779296875,
        1130.0
      ],
      [
        1739.2469482421875,
        1689.9998779296875,
        375.0
      ],
      [
        1770.0001220703125,
        1659.2467041015625,
        375.0
      ],
      [
        1770.0001220703125,
        1659.2467041015625,
        370.0
      ],
      [
        1739.2469482421875,
        1689.9998779296875,
        370.0
      ],
      [
        1770.0001220703125,
        1659.2467041015625,
        375.0
      ],
      [
        1739.2469482421875,
        1689.9998779296875,
        375.0
      ],
      [
        1767.53125,
        1689.9998779296875,
        375.0
      ],
      [
        1770.0001220703125,
        1687.531005859375,
        375.0
      ],
      [
        1770.0001220703125,
        1687.531005859375,
        375.0
      ],
      [
        1767.53125,
        1689.9998779296875,
        375.0
      ],
      [
        1767.53125,
        1689.9998779296875,
        380.0
      ],
      [
        1770.0001220703125,
        1687.531005859375,
        380.0
      ],
      [
        1770.0001220703125,
        1687.531005859375,
        380.0
      ],
      [
        1767.53125,
        1689.9998779296875,
        380.0
      ],
      [
        1770.0001220703125,
        1689.9998779296875,
        380.0
      ],
      [
        1946.5765380859375,
        1183.4234619140625,
        436.57659912109375
      ],
      [
        1946.5765380859375,
        1176.5765380859375,
        436.57659912109375
      ],
      [
        1953.42333984375,
        1183.42333984375,
        436.5765686035156
      ],
      [
        1946.5765380859375,
        1183.4234619140625,
        436.57659912109375
      ],
      [
        1953.1932373046875,
        1183.1932373046875,
        443.19329833984375
      ],
      [
        1910.0,
        1689.9998779296875,
        370.0
      ],
      [
        1975.8001708984375,
        1689.9998779296875,
        1059.6480712890625
      ],
      [
        1975.4891357421875,
        1689.9998779296875,
        1060.0
      ],
      [
        1910.0,
        1624.5108642578125,
        1060.0
      ],
      [
        1910.0,
        1623.9998779296875,
        1059.421875
      ],
      [
        1975.4892578125,
        1689.9998779296875,
        1060.0
      ],
      [
        1968.064697265625,
        1682.5753173828125,
        1060.0
      ],
      [
        1917.370849609375,
        1631.8814697265625,
        1060.0
      ],
      [
        1910.0,
        1624.5106201171875,
        1060.0
      ],
      [
        1968.064697265625,
        1682.5753173828125,
        1060.0
      ],
      [
        1917.370849609375,
        1631.8814697265625,
        1060.0
      ],
      [
        1910.0,
        1626.639892578125,
        1130.0
      ],
      [
        1910.0,
        1638.756591796875,
        1130.0
      ],
      [
        1961.2435302734375,
        1689.9998779296875,
        1130.0
      ],
      [
        1973.3599853515625,
        1689.9998779296875,
        1130.0
      ],
      [
        1975.8001708984375,
        1689.9998779296875,
        1060.0
      ],
      [
        1975.8001708984375,
        1689.9998779296875,
        1059.6480712890625
      ],
      [
        1910.0,
        1623.9998779296875,
        1059.421875
      ],
      [
        1910.0,
        1623.9998779296875,
        1060.0
      ],
      [
        1956.5877685546875,
        1689.9998779296875,
        1060.0
      ],
      [
        1910.0,
        1643.306640625,
        1060.0
      ],
      [
        1956.5877685546875,
        1689.9998779296875,
        1060.0
      ],
      [
        1910.0,
        1689.9998779296875,
        1060.0
      ],
      [
        1910.0,
        1643.306640625,
        1060.0
      ],
      [
        1910.0,
        1659.246826171875,
        375.0
      ],
      [
        1940.7530517578125,
        1689.9998779296875,
        375.0
      ],
      [
        1940.7530517578125,
        1689.9998779296875,
        370.0
      ],
      [
        1910.0,
        1659.246826171875,
        370.0
      ],
      [
        1940.7530517578125,
        1689.9998779296875,
        375.0
      ],
      [
        1910.0,
        1659.246826171875,
        375.0
      ],
      [
        1910.0,
        1687.5311279296875,
        375.0
      ],
      [
        1912.46875,
        1689.9998779296875,
        375.0
      ],
      [
        1912.46875,
        1689.9998779296875,
        375.0
      ],
      [
        1910.0,
        1687.5311279296875,
        375.0
      ],
      [
        1910.0,
        1687.5311279296875,
        380.0
      ],
      [
        1912.46875,
        1689.9998779296875,
        380.0
      ],
      [
        1912.46875,
        1689.9998779296875,
        380.0
      ],
      [
        1910.0,
        1687.5311279296875,
        380.0
      ],
      [
        1910.0,
        1689.9998779296875,
        380.0
      ],
      [
        1840.0,
        1689.9998779296875,
        370.0
      ],
      [
        1840.0,
        1689.9998779296875,
        370.0
      ],
      [
        1787.057861328125,
        1689.9998779296875,
        1060.0
      ],
      [
        1892.942138671875,
        1689.9998779296875,
        1060.0
      ],
      [
        1787.057861328125,
        1689.9998779296875,
        1130.0
      ],
      [
        1799.58544921875,
        1689.9998779296875,
        1130.0
      ],
      [
        1880.41455078125,
        1689.9998779296875,
        1130.0
      ],
      [
        1892.942138671875,
        1689.9998779296875,
        1130.0
      ],
      [
        1840.0,
        1689.9998779296875,
        1130.0
      ],
      [
        1880.41455078125,
        1689.9998779296875,
        1130.0
      ],
      [
        1799.58544921875,
        1689.9998779296875,
        1130.0
      ],
      [
        1840.0,
        1689.9998779296875,
        1130.0
      ],
      [
        1787.057861328125,
        1689.9998779296875,
        1130.0
      ],
      [
        1807.5,
        1678.7083740234375,
        1110.0
      ],
      [
        1827.5,
        1673.349365234375,
        1110.0
      ],
      [
        1827.5,
        1673.349365234375,
        1110.0
      ],
      [
        1827.5,
        1673.349365234375,
        1115.0
      ],
      [
        1892.9423828125,
        1689.9998779296875,
        1106.0
      ],
      [
        1892.942138671875,
        1689.9998779296875,
        1130.0
      ],
      [
        1892.942138671875,
        1689.9998779296875,
        1060.0
      ],
      [
        1892.9423828125,
        1689.9998779296875,
        1106.0
      ],
      [
        1895.359130859375,
        1689.9998779296875,
        1115.0
      ],
      [
        1895.359130859375,
        1689.9998779296875,
        1110.0
      ],
      [
        1895.359130859375,
        1689.9998779296875,
        1110.0
      ],
      [
        1895.67431640625,
        1689.9998779296875,
        1110.0
      ],
      [
        1787.057861328125,
        1689.9998779296875,
        1060.0
      ],
      [
        1787.0576171875,
        1689.9998779296875,
        1106.0
      ],
      [
        1810.5255126953125,
        1689.9998779296875,
        1110.0
      ],
      [
        1831.9615478515625,
        1689.9998779296875,
        1110.0
      ],
      [
        1831.9615478515625,
        1689.9998779296875,
        1110.0
      ],
      [
        1831.9615478515625,
        1689.9998779296875,
        1115.0
      ],
      [
        1884.1845703125,
        1689.9998779296875,
        385.0
      ],
      [
        1795.815673828125,
        1689.9998779296875,
        385.0
      ],
      [
        1884.1845703125,
        1689.9998779296875,
        383.0
      ],
      [
        1795.815673828125,
        1689.9998779296875,
        383.0
      ],
      [
        1891.255615234375,
        1689.9998779296875,
        380.0
      ],
      [
        1788.74462890625,
        1689.9998779296875,
        380.0
      ],
      [
        1840.0,
        1671.2347412109375,
        383.0
      ],
      [
        1884.3828125,
        1683.1270751953125,
        383.0
      ],
      [
        1795.617431640625,
        1683.1270751953125,
        383.0
      ],
      [
        1840.0,
        1671.2347412109375,
        383.0
      ],
      [
        1891.255615234375,
        1689.9998779296875,
        380.0
      ],
      [
        1884.3828125,
        1683.1270751953125,
        383.0
      ],
      [
        1891.255615234375,
        1689.9998779296875,
        383.0
      ],
      [
        1788.74462890625,
        1689.9998779296875,
        380.0
      ],
      [
        1788.74462890625,
        1689.9998779296875,
        383.0
      ],
      [
        1795.617431640625,
        1683.1270751953125,
        383.0
      ],
      [
        1770.0,
        1510.0,
        383.0
      ],
      [
        1770.5,
        1510.0,
        383.0
      ],
      [
        1770.5,
        1512.0,
        383.0
      ],
      [
        1769.9998779296875,
        1511.9998779296875,
        383.0
      ],
      [
        1770.5,
        1510.0,
        383.0
      ],
      [
        1770.5,
        1512.0,
        383.0
      ],
      [
        1770.5,
        1500.0,
        383.0
      ],
      [
        1770.0001220703125,
        1500.0,
        383.0
      ],
      [
        1770.0,
        1498.0,
        383.0
      ],
      [
        1770.5,
        1498.0,
        383.0
      ],
      [
        1770.5,
        1498.0,
        383.0
      ],
      [
        1770.5,
        1500.0,
        383.0
      ],
      [
        1840.0,
        1671.2347412109375,
        385.0
      ],
      [
        1884.3828125,
        1683.1270751953125,
        385.0
      ],
      [
        1795.617431640625,
        1683.1270751953125,
        385.0
      ],
      [
        1840.0,
        1671.2347412109375,
        385.0
      ],
      [
        1788.74462890625,
        1689.9998779296875,
        385.0
      ],
      [
        1795.617431640625,
        1683.1270751953125,
        385.0
      ],
      [
        1884.3828125,
        1683.1270751953125,
        385.0
      ],
      [
        1891.255615234375,
        1689.9998779296875,
        385.0
      ],
      [
        1884.1845703125,
        1689.9998779296875,
        385.0
      ],
      [
        1884.1845703125,
        1689.9998779296875,
        383.0
      ],
      [
        1795.815673828125,
        1689.9998779296875,
        385.0
      ],
      [
        1795.815673828125,
        1689.9998779296875,
        383.0
      ],
      [
        1891.255615234375,
        1689.9998779296875,
        390.0
      ],
      [
        1884.1845703125,
        1689.9998779296875,
        390.0
      ],
      [
        1788.74462890625,
        1689.9998779296875,
        390.0
      ],
      [
        1795.815673828125,
        1689.9998779296875,
        390.0
      ],
      [
        1788.74462890625,
        1689.9998779296875,
        390.0
      ],
      [
        1891.255615234375,
        1689.9998779296875,
        390.0
      ],
      [
        1884.1845703125,
        1689.9998779296875,
        390.0
      ],
      [
        1884.1845703125,
        1689.9998779296875,
        385.0
      ],
      [
        1795.815673828125,
        1689.9998779296875,
        390.0
      ],
      [
        1795.815673828125,
        1689.9998779296875,
        385.0
      ],
      [
        1763.1270751953125,
        1804.3828125,
        383.0
      ],
      [
        1751.2347412109375,
        1760.0,
        383.0
      ],
      [
        1928.76513671875,
        1759.9998779296875,
        383.0
      ],
      [
        1916.873046875,
        1804.3826904296875,
        383.0
      ],
      [
        1751.2347412109375,
        1760.0,
        383.0
      ],
      [
        1763.1270751953125,
        1715.617431640625,
        383.0
      ],
      [
        1916.873046875,
        1715.6173095703125,
        383.0
      ],
      [
        1928.76513671875,
        1759.9998779296875,
        383.0
      ],
      [
        1763.1270751953125,
        1715.617431640625,
        383.0
      ],
      [
        1788.74462890625,
        1689.9998779296875,
        383.0
      ],
      [
        1891.255615234375,
        1689.9998779296875,
        383.0
      ],
      [
        1916.873046875,
        1715.6173095703125,
        383.0
      ],
      [
        1916.873046875,
        1804.3826904296875,
        383.0
      ],
      [
        1891.2557373046875,
        1830.0,
        383.0
      ],
      [
        1788.7442626953125,
        1830.0,
        383.0
      ],
      [
        1763.1270751953125,
        1804.3828125,
        383.0
      ],
      [
        1763.1270751953125,
        1804.3828125,
        385.0
      ],
      [
        1751.2347412109375,
        1760.0,
        385.0
      ],
      [
        1928.76513671875,
        1759.9998779296875,
        385.0
      ],
      [
        1916.873046875,
        1804.3826904296875,
        385.0
      ],
      [
        1751.2347412109375,
        1760.0,
        385.0
      ],
      [
        1763.1270751953125,
        1715.617431640625,
        385.0
      ],
      [
        1916.873046875,
        1715.6173095703125,
        385.0
      ],
      [
        1928.76513671875,
        1759.9998779296875,
        385.0
      ],
      [
        1916.873046875,
        1804.3826904296875,
        385.0
      ],
      [
        1909.8017578125,
        1811.4539794921875,
        385.0
      ],
      [
        1909.8017578125,
        1811.4539794921875,
        383.0
      ],
      [
        1909.802001953125,
        1708.5462646484375,
        385.0
      ],
      [
        1916.873046875,
        1715.6173095703125,
        385.0
      ],
      [
        1909.802001953125,
        1708.5462646484375,
        383.0
      ],
      [
        1763.1270751953125,
        1715.617431640625,
        385.0
      ],
      [
        1770.1981201171875,
        1708.54638671875,
        385.0
      ],
      [
        1770.1981201171875,
        1708.54638671875,
        383.0
      ],
      [
        1770.1978759765625,
        1811.45361328125,
        385.0
      ],
      [
        1763.1270751953125,
        1804.3828125,
        385.0
      ],
      [
        1770.1978759765625,
        1811.45361328125,
        383.0
      ],
      [
        1788.74462890625,
        1689.9998779296875,
        385.0
      ],
      [
        1891.255615234375,
        1689.9998779296875,
        385.0
      ],
      [
        1788.7442626953125,
        1830.0,
        385.0
      ],
      [
        1891.2557373046875,
        1830.0,
        385.0
      ],
      [
        1753.34912109375,
        1747.5,
        1110.0
      ],
      [
        1758.7081298828125,
        1727.5,
        1110.0
      ],
      [
        1753.34912109375,
        1747.5,
        1115.0
      ],
      [
        1753.34912109375,
        1747.5,
        1110.0
      ],
      [
        1758.7081298828125,
        1727.5,
        1110.0
      ],
      [
        1758.7081298828125,
        1727.4998779296875,
        1115.0
      ],
      [
        1926.6507568359375,
        1772.5001220703125,
        1110.0
      ],
      [
        1921.2918701171875,
        1792.5001220703125,
        1110.0
      ],
      [
        1926.6507568359375,
        1772.5001220703125,
        1115.0
      ],
      [
        1926.6507568359375,
        1772.5001220703125,
        1110.0
      ],
      [
        1921.2918701171875,
        1792.5001220703125,
        1110.0
      ],
      [
        1921.2918701171875,
        1792.5001220703125,
        1115.0
      ],
      [
        1894.150634765625,
        1691.2083740234375,
        1110.0
      ],
      [
        1908.7916259765625,
        1705.849365234375,
        1110.0
      ],
      [
        1908.7916259765625,
        1705.849365234375,
        1110.0
      ],
      [
        1908.7916259765625,
        1705.849365234375,
        1115.0
      ],
      [
        1894.150634765625,
        1691.2083740234375,
        1115.0
      ],
      [
        1894.150634765625,
        1691.2083740234375,
        1110.0
      ],
      [
        1785.84912109375,
        1828.7918701171875,
        1110.0
      ],
      [
        1771.208251953125,
        1814.1507568359375,
        1110.0
      ],
      [
        1771.208251953125,
        1814.1507568359375,
        1110.0
      ],
      [
        1771.2081298828125,
        1814.15087890625,
        1115.0
      ],
      [
        1785.84912109375,
        1828.7918701171875,
        1115.0
      ],
      [
        1785.84912109375,
        1828.7918701171875,
        1110.0
      ],
      [
        1909.8017578125,
        1811.4539794921875,
        390.0
      ],
      [
        1909.8017578125,
        1811.4539794921875,
        385.0
      ],
      [
        1909.802001953125,
        1708.5462646484375,
        390.0
      ],
      [
        1909.802001953125,
        1708.5462646484375,
        385.0
      ],
      [
        1770.1981201171875,
        1708.54638671875,
        390.0
      ],
      [
        1770.1981201171875,
        1708.54638671875,
        385.0
      ],
      [
        1770.1978759765625,
        1811.45361328125,
        390.0
      ],
      [
        1770.1978759765625,
        1811.45361328125,
        385.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -14119.97265625,
        -9736.5908203125,
        -300.0
      ],
      "bbox_max": [
        15055.1513671875,
        13522.390625,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34176069498062134,
        0.1286875456571579,
        0.930934488773346
      ],
      "plane_d": 470.6300048828125,
      "bbox_min": [
        -6971.595703125,
        -3700.0,
        -33.027774810791016
      ],
      "bbox_max": [
        7823.75537109375,
        7450.0,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -6821.484375,
        2758.39404296875,
        -22.699951171875
      ],
      "bbox_max": [
        -5504.7001953125,
        4729.1015625,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3910660445690155,
        0.31802985072135925,
        0.8636690974235535
      ],
      "plane_d": 372.2137451171875,
      "bbox_min": [
        -5573.556640625,
        2154.178466796875,
        -22.699951171875
      ],
      "bbox_max": [
        -4468.451171875,
        5695.4521484375,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -5532.3203125,
        4687.76513671875,
        -22.699951171875
      ],
      "bbox_max": [
        -5158.470703125,
        5234.39599609375,
        347.8642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -5174.01171875,
        5224.01171875,
        -22.699951171875
      ],
      "bbox_max": [
        -5158.470703125,
        5234.39599609375,
        -11.8392333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18346190452575684,
        0.3073110282421112,
        0.9337567090988159
      ],
      "plane_d": -694.5667724609375,
      "bbox_min": [
        -5573.556640625,
        2154.178466796875,
        -22.699951171875
      ],
      "bbox_max": [
        -4468.451171875,
        5695.4521484375,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -5342.2373046875,
        4972.24462890625,
        -22.699951171875
      ],
      "bbox_max": [
        -5020.71826171875,
        5326.439453125,
        157.0411834716797
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -5174.01171875,
        5224.01171875,
        -22.699951171875
      ],
      "bbox_max": [
        -5020.71826171875,
        5326.439453125,
        41.1290283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -5573.556640625,
        4626.0498046875,
        -22.699951171875
      ],
      "bbox_max": [
        -4468.451171875,
        5695.4521484375,
        901.1133422851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -4912.15185546875,
        -3123.862548828125,
        0.0
      ],
      "bbox_max": [
        -200.806640625,
        3191.2431640625,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -1201.24462890625,
        -3123.862548828125,
        0.0
      ],
      "bbox_max": [
        -200.806640625,
        -2021.68505859375,
        202.6451416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -4901.68505859375,
        5405.974609375,
        -22.699951171875
      ],
      "bbox_max": [
        -3662.578857421875,
        6233.91845703125,
        546.6460571289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.054435841739177704,
        0.9979904890060425,
        0.032430119812488556
      ],
      "plane_d": 3654.259033203125,
      "bbox_min": [
        -1156.463623046875,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        4526.4208984375,
        -796.68505859375,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.41241455078125,
      "bbox_min": [
        -1156.463623046875,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        4526.4208984375,
        -796.68505859375,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.016502970829606056,
        0.5776039958000183,
        0.8161502480506897
      ],
      "plane_d": 497.69219970703125,
      "bbox_min": [
        -1156.463623046875,
        -3672.376220703125,
        0.0
      ],
      "bbox_max": [
        2400.0,
        -796.68505859375,
        892.7235717773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -1156.463623046875,
        -3672.376220703125,
        0.0
      ],
      "bbox_max": [
        650.0,
        -1371.68505859375,
        892.7235717773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -158.70806884765625,
        -3672.376220703125,
        0.0
      ],
      "bbox_max": [
        334.5896301269531,
        -3106.798095703125,
        892.7235717773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        -681.8506469726562,
        -1625.7083740234375,
        0.0
      ],
      "bbox_max": [
        650.0,
        -1371.68505859375,
        252.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -681.8506469726562,
        -1625.7083740234375,
        0.0
      ],
      "bbox_max": [
        -504.59906005859375,
        -1371.68505859375,
        150.77035522460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.4764099121094,
      "bbox_min": [
        -1145.6080322265625,
        -3684.182861328125,
        114.45515441894531
      ],
      "bbox_max": [
        2400.0,
        -1150.0,
        1302.984619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -1143.6485595703125,
        -3680.16650390625,
        252.5999755859375
      ],
      "bbox_max": [
        353.0361328125,
        -2061.22412109375,
        1163.4200439453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -236.0840606689453,
        -3680.16650390625,
        670.1329956054688
      ],
      "bbox_max": [
        353.0361328125,
        -3010.201904296875,
        1163.4200439453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.022904695942997932,
        0.8625975847244263,
        0.5053718686103821
      ],
      "plane_d": 1267.3873291015625,
      "bbox_min": [
        -1145.6080322265625,
        -3684.182861328125,
        114.45515441894531
      ],
      "bbox_max": [
        2400.0,
        -1467.1614990234375,
        1302.984619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -1145.6080322265625,
        -3684.182861328125,
        137.07241821289062
      ],
      "bbox_max": [
        1019.5870971679688,
        -1565.9052734375,
        1302.984619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -317.6634521484375,
        -3684.182861328125,
        790.0326538085938
      ],
      "bbox_max": [
        362.54669189453125,
        -2908.3583984375,
        1302.984619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        -900.0,
        -2110.8046875,
        137.07241821289062
      ],
      "bbox_max": [
        1019.5870971679688,
        -1565.9052734375,
        530.965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -900.0,
        -2110.8046875,
        137.07241821289062
      ],
      "bbox_max": [
        -436.79736328125,
        -1565.9052734375,
        530.965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        544.5404052734375,
        -1746.0208740234375,
        252.5999755859375
      ],
      "bbox_max": [
        1019.5870971679688,
        -1600.0,
        431.5646057128906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        -614.9921264648438,
        -1691.1807861328125,
        114.45515441894531
      ],
      "bbox_max": [
        650.0,
        -1467.1614990234375,
        376.3770446777344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -614.9921264648438,
        -1689.80029296875,
        114.45515441894531
      ],
      "bbox_max": [
        -411.2253723144531,
        -1467.1614990234375,
        356.6197509765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06764065474271774,
        0.8608478903770447,
        0.5043467879295349
      ],
      "plane_d": 1372.294189453125,
      "bbox_min": [
        -1088.6651611328125,
        -3700.0,
        343.56805419921875
      ],
      "bbox_max": [
        4526.4208984375,
        -1556.87548828125,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -1088.6651611328125,
        -3700.0,
        444.72637939453125
      ],
      "bbox_max": [
        1109.866455078125,
        -1902.55712890625,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -1088.6651611328125,
        -2908.3583984375,
        509.4501647949219
      ],
      "bbox_max": [
        -317.6634216308594,
        -2097.481689453125,
        1292.895263671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -778.3905029296875,
        -2403.4306640625,
        444.72637939453125
      ],
      "bbox_max": [
        -166.50140380859375,
        -1902.55712890625,
        1148.7313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -476.1238708496094,
        -2318.3291015625,
        595.6365356445312
      ],
      "bbox_max": [
        360.59381103515625,
        -1980.497314453125,
        1087.8885498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        -164.90321350097656,
        -2234.21533203125,
        742.3642578125
      ],
      "bbox_max": [
        360.59381103515625,
        -2000.71630859375,
        1027.7520751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.022904695942997932,
        0.8625975847244263,
        0.5053718686103821
      ],
      "plane_d": 1267.3873291015625,
      "bbox_min": [
        -1025.829345703125,
        -2286.437255859375,
        343.56805419921875
      ],
      "bbox_max": [
        2400.0,
        -1658.283447265625,
        1065.087646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -1025.829345703125,
        -2286.437255859375,
        356.6197509765625
      ],
      "bbox_max": [
        -164.90322875976562,
        -1689.80029296875,
        1065.087646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -1025.829345703125,
        -2286.437255859375,
        793.7977294921875
      ],
      "bbox_max": [
        -869.4028930664062,
        -2139.787109375,
        1065.087646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -987.384765625,
        -2188.843505859375,
        967.7686767578125
      ],
      "bbox_max": [
        -963.9840698242188,
        -2165.6708984375,
        995.313720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -436.79736328125,
        -1732.939208984375,
        343.56805419921875
      ],
      "bbox_max": [
        -374.75189208984375,
        -1658.283447265625,
        433.06378173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04072042927145958,
        0.6873272061347961,
        0.7252056002616882
      ],
      "plane_d": 709.0238037109375,
      "bbox_min": [
        -4249.0625,
        -3334.0634765625,
        252.5999755859375
      ],
      "bbox_max": [
        7600.0,
        -1150.0,
        2100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.027883131057024002,
        0.7254633903503418,
        0.6876956224441528
      ],
      "plane_d": 797.6544189453125,
      "bbox_min": [
        -984.6701049804688,
        -3334.0634765625,
        260.1967468261719
      ],
      "bbox_max": [
        7600.0,
        -1158.5028076171875,
        2100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06764065474271774,
        0.8608478903770447,
        0.5043467879295349
      ],
      "plane_d": 1372.294189453125,
      "bbox_min": [
        -984.6701049804688,
        -3334.0634765625,
        384.7739562988281
      ],
      "bbox_max": [
        6992.103515625,
        -1334.87353515625,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        -869.4028930664062,
        -3334.0634765625,
        873.7589111328125
      ],
      "bbox_max": [
        2400.0,
        -2018.822998046875,
        1814.080322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -713.9907836914062,
        -3334.0634765625,
        1087.888427734375
      ],
      "bbox_max": [
        85.42291259765625,
        -2318.328857421875,
        1814.080322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -869.4028930664062,
        -2604.275634765625,
        1018.544921875
      ],
      "bbox_max": [
        0.0,
        -2221.337158203125,
        1411.13330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -602.8601684570312,
        -2604.275634765625,
        1347.8153076171875
      ],
      "bbox_max": [
        -556.1371459960938,
        -2552.319091796875,
        1411.13330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -841.7437133789062,
        -2962.61669921875,
        1113.056884765625
      ],
      "bbox_max": [
        -233.89097595214844,
        -2312.367919921875,
        1774.980712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -841.7437133789062,
        -2552.319091796875,
        1113.056884765625
      ],
      "bbox_max": [
        -602.8601684570312,
        -2312.367919921875,
        1385.6551513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.41241455078125,
      "bbox_min": [
        -984.6701049804688,
        -2375.986083984375,
        384.7739562988281
      ],
      "bbox_max": [
        6992.103515625,
        -1334.87353515625,
        1230.7451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.022904695942997932,
        0.8625975847244263,
        0.5053718686103821
      ],
      "plane_d": 1267.3873291015625,
      "bbox_min": [
        1721.035888671875,
        -2050.0,
        749.0462646484375
      ],
      "bbox_max": [
        2400.0,
        -1844.385986328125,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -984.6701049804688,
        -2375.986083984375,
        980.0532836914062
      ],
      "bbox_max": [
        -773.8844604492188,
        -2167.49853515625,
        1230.7451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.02753951959311962,
        0.7068385481834412,
        0.7068385481834412
      ],
      "plane_d": 737.5914916992188,
      "bbox_min": [
        2400.0,
        -2050.0,
        260.1967468261719
      ],
      "bbox_max": [
        7600.0,
        -1158.5028076171875,
        1152.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.41241455078125,
      "bbox_min": [
        2455.532470703125,
        -1350.0,
        260.1967468261719
      ],
      "bbox_max": [
        7600.0,
        -1158.5028076171875,
        602.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600966572761536,
        0.2609225809574127,
        0.10066688805818558
      ],
      "plane_d": 4053.39990234375,
      "bbox_min": [
        -3766.849609375,
        -2329.10009765625,
        1171.234130859375
      ],
      "bbox_max": [
        -3714.042724609375,
        -2126.165771484375,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -973.9005126953125,
        -2530.34375,
        1028.788330078125
      ],
      "bbox_max": [
        -620.4629516601562,
        -2174.74951171875,
        1547.9334716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.41241455078125,
      "bbox_min": [
        2400.0,
        -1160.625732421875,
        252.5999755859375
      ],
      "bbox_max": [
        2621.07421875,
        -1150.0,
        267.47998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1430054008960724,
        0.10372365266084671,
        0.9842716455459595
      ],
      "plane_d": -505.2467041015625,
      "bbox_min": [
        -5704.54443359375,
        -2564.65576171875,
        -33.027774810791016
      ],
      "bbox_max": [
        6811.5068359375,
        7450.0,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600966572761536,
        0.2609225809574127,
        0.10066688805818558
      ],
      "plane_d": 4053.39990234375,
      "bbox_min": [
        -5331.83203125,
        -2237.329345703125,
        -22.699951171875
      ],
      "bbox_max": [
        1615.0,
        7117.23486328125,
        1293.859130859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -5331.83203125,
        960.0,
        -22.699951171875
      ],
      "bbox_max": [
        1615.0,
        7117.23486328125,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3932375907897949,
        -0.4582340121269226,
        0.797110915184021
      ],
      "plane_d": 2052.83154296875,
      "bbox_min": [
        -2582.97119140625,
        6956.2158203125,
        150.0
      ],
      "bbox_max": [
        -2579.824462890625,
        6957.4052734375,
        151.5449981689453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18346190452575684,
        0.3073110282421112,
        0.9337567090988159
      ],
      "plane_d": -694.5667724609375,
      "bbox_min": [
        -5331.83203125,
        960.0,
        -22.699951171875
      ],
      "bbox_max": [
        1615.0,
        7117.23486328125,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877842307090759,
        0.8090178370475769,
        -0.0
      ],
      "plane_d": -1500.44677734375,
      "bbox_min": [
        647.2877197265625,
        1346.4150390625,
        160.0
      ],
      "bbox_max": [
        699.5303955078125,
        1384.3714599609375,
        163.2774658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -5331.83203125,
        960.0,
        -22.699951171875
      ],
      "bbox_max": [
        1615.0,
        7117.23486328125,
        762.3635864257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3932375907897949,
        -0.4582340121269226,
        0.797110915184021
      ],
      "plane_d": 2052.83154296875,
      "bbox_min": [
        -2581.58544921875,
        6907.90576171875,
        150.0
      ],
      "bbox_max": [
        -2522.372314453125,
        6957.392578125,
        154.18719482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1389.9998779296875,
      "bbox_min": [
        -2525.29052734375,
        960.0,
        84.70588684082031
      ],
      "bbox_max": [
        1615.0,
        6908.486328125,
        282.77117919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1384.3714599609375,
      "bbox_min": [
        582.7122802734375,
        960.0,
        97.64706420898438
      ],
      "bbox_max": [
        1615.0,
        1390.0,
        282.77117919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877842307090759,
        0.8090178370475769,
        -0.0
      ],
      "plane_d": -1500.44677734375,
      "bbox_min": [
        647.2877197265625,
        960.0,
        97.64706420898438
      ],
      "bbox_max": [
        1615.0,
        1384.3714599609375,
        273.3889465332031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1535.0,
      "bbox_min": [
        1180.0,
        960.0,
        97.64706420898438
      ],
      "bbox_max": [
        1615.0,
        1384.3714599609375,
        196.97845458984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1180.0,
      "bbox_min": [
        1180.0,
        960.0,
        97.64706420898438
      ],
      "bbox_max": [
        1535.0,
        1384.3714599609375,
        196.97845458984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 91.9239501953125,
      "bbox_min": [
        1350.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        1535.0,
        1375.0,
        191.60336303710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": -1414.94287109375,
      "bbox_min": [
        1475.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        1535.0,
        1130.0,
        191.60336303710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        1475.0,
        1130.0,
        140.0
      ],
      "bbox_max": [
        1535.0,
        1130.0,
        179.9361114501953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -21.2132568359375,
      "bbox_min": [
        1350.0,
        1320.0,
        160.0
      ],
      "bbox_max": [
        1405.0,
        1375.0,
        178.07501220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -21.2132568359375,
      "bbox_min": [
        1405.0,
        1375.0,
        160.0
      ],
      "bbox_max": [
        1414.3714599609375,
        1384.3714599609375,
        164.28807067871094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1615.0,
      "bbox_min": [
        1555.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        1615.0,
        1130.0,
        179.98013305664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": -1494.5458984375,
      "bbox_min": [
        1555.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        1615.0,
        1130.0,
        179.98013305664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        1555.0,
        1130.0,
        140.0
      ],
      "bbox_max": [
        1615.0,
        1130.0,
        168.3128662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1180.0,
      "bbox_min": [
        1180.0,
        1384.3714599609375,
        97.64706420898438
      ],
      "bbox_max": [
        1420.0,
        1390.0,
        195.99087524414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -21.2132568359375,
      "bbox_min": [
        1414.3714599609375,
        1384.3714599609375,
        160.0
      ],
      "bbox_max": [
        1420.0,
        1390.0,
        161.9389190673828
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1539.9998779296875,
      "bbox_min": [
        -2525.29052734375,
        1390.0,
        84.70588684082031
      ],
      "bbox_max": [
        1422.1063232421875,
        6908.486328125,
        198.3035888671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1160.0,
      "bbox_min": [
        1160.0,
        1390.0,
        95.29411315917969
      ],
      "bbox_max": [
        1422.1063232421875,
        1540.0,
        198.3035888671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1180.0,
        1390.0,
        97.64706420898438
      ],
      "bbox_max": [
        1422.1063232421875,
        1540.0,
        188.02108764648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1180.0,
      "bbox_min": [
        1180.0,
        1460.0,
        97.64706420898438
      ],
      "bbox_max": [
        1200.0,
        1540.0,
        188.02108764648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1524.9998779296875,
      "bbox_min": [
        1180.0,
        1525.0,
        97.64706420898438
      ],
      "bbox_max": [
        1200.0,
        1525.0,
        181.17129516601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -21.2132568359375,
      "bbox_min": [
        1420.0,
        1390.0,
        160.0
      ],
      "bbox_max": [
        1422.1063232421875,
        1392.1063232421875,
        160.5279998779297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1549.9998779296875,
      "bbox_min": [
        -2525.29052734375,
        1540.0,
        87.05882263183594
      ],
      "bbox_max": [
        1160.0,
        6908.486328125,
        191.61289978027344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1160.0,
      "bbox_min": [
        1160.0,
        1540.0,
        95.29411315917969
      ],
      "bbox_max": [
        1160.0,
        1550.0,
        182.49642944335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3932375907897949,
        -0.4582340121269226,
        0.797110915184021
      ],
      "plane_d": 2052.83154296875,
      "bbox_min": [
        -2525.29052734375,
        6872.57568359375,
        150.0
      ],
      "bbox_max": [
        -2484.12060546875,
        6908.486328125,
        151.7732696533203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        -3381.2060546875,
        5224.01171875,
        -22.699951171875
      ],
      "bbox_max": [
        5574.01171875,
        7450.0,
        680.7955932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -3381.2060546875,
        5684.36474609375,
        -22.699951171875
      ],
      "bbox_max": [
        200.0,
        7450.0,
        680.7955932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3932375907897949,
        -0.4582340121269226,
        0.797110915184021
      ],
      "plane_d": 2052.83154296875,
      "bbox_min": [
        -2574.443359375,
        6908.486328125,
        151.7732696533203
      ],
      "bbox_max": [
        -2282.542236328125,
        6957.37060546875,
        297.5124206542969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8558866381645203,
        -0.018606234341859818,
        0.5168285369873047
      ],
      "plane_d": 228.55836486816406,
      "bbox_min": [
        -450.0968933105469,
        5684.36474609375,
        150.0
      ],
      "bbox_max": [
        -202.00167846679688,
        7158.4658203125,
        557.4569091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4204522669315338,
        0.06168942153453827,
        0.9052150249481201
      ],
      "plane_d": 665.100341796875,
      "bbox_min": [
        -5704.54443359375,
        -2564.65576171875,
        0.0
      ],
      "bbox_max": [
        6811.5068359375,
        7450.0,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7007350325584412,
        0.5362348556518555,
        0.4705556631088257
      ],
      "plane_d": 762.2274780273438,
      "bbox_min": [
        2638.3466796875,
        660.0,
        0.0
      ],
      "bbox_max": [
        6166.06201171875,
        6577.16845703125,
        1783.6749267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5601329803466797,
        0.06843777745962143,
        0.8255710005760193
      ],
      "plane_d": 1309.8272705078125,
      "bbox_min": [
        2780.0,
        716.4630737304688,
        60.0
      ],
      "bbox_max": [
        5574.01171875,
        5398.9755859375,
        1031.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7398530840873718,
        -0.055298302322626114,
        0.6704919338226318
      ],
      "plane_d": 2182.15185546875,
      "bbox_min": [
        2780.0,
        716.4630737304688,
        60.0
      ],
      "bbox_max": [
        5574.01171875,
        5398.9755859375,
        831.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4713583290576935,
        -0.3486906588077545,
        0.8100841641426086
      ],
      "plane_d": 1743.849609375,
      "bbox_min": [
        2939.5361328125,
        816.188232421875,
        89.7060775756836
      ],
      "bbox_max": [
        5574.01171875,
        5398.9755859375,
        831.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5706354975700378,
        0.03875378891825676,
        0.8202885389328003
      ],
      "plane_d": 1400.6068115234375,
      "bbox_min": [
        3206.5634765625,
        1830.0,
        435.9788818359375
      ],
      "bbox_max": [
        3240.0,
        1846.1043701171875,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.836047887802124,
        0.0,
        0.5486564636230469
      ],
      "plane_d": 2456.4130859375,
      "bbox_min": [
        2950.0,
        1690.0,
        140.0
      ],
      "bbox_max": [
        3240.0,
        1830.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1690.0,
      "bbox_min": [
        2950.0,
        1690.0,
        140.0
      ],
      "bbox_max": [
        3210.02099609375,
        1690.0,
        414.3177185058594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26363566517829895,
        -0.09646245092153549,
        0.9597871899604797
      ],
      "plane_d": 575.6990966796875,
      "bbox_min": [
        3437.258056640625,
        816.188232421875,
        495.7249755859375
      ],
      "bbox_max": [
        4077.6171875,
        1506.344482421875,
        611.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5706354975700378,
        0.03875378891825676,
        0.8202885389328003
      ],
      "plane_d": 1400.6068115234375,
      "bbox_min": [
        2780.0,
        716.4630737304688,
        60.0
      ],
      "bbox_max": [
        3211.68603515625,
        2051.553955078125,
        440.30340576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7753851413726807,
        -0.028329361230134964,
        0.6308528780937195
      ],
      "plane_d": 2269.93212890625,
      "bbox_min": [
        2950.0,
        716.4630737304688,
        60.0
      ],
      "bbox_max": [
        3023.2666015625,
        965.0643920898438,
        161.0574951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5660791993141174,
        0.06026303768157959,
        0.8221452236175537
      ],
      "plane_d": 1356.604248046875,
      "bbox_min": [
        2780.0,
        1830.0,
        127.25813293457031
      ],
      "bbox_max": [
        4157.6171875,
        3150.14306640625,
        1031.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5706354975700378,
        0.03875378891825676,
        0.8202885389328003
      ],
      "plane_d": 1400.6068115234375,
      "bbox_min": [
        2780.0,
        1830.0,
        127.25813293457031
      ],
      "bbox_max": [
        3249.21630859375,
        2461.31005859375,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5134666562080383,
        0.06992331147193909,
        0.8552559614181519
      ],
      "plane_d": 1142.2545166015625,
      "bbox_min": [
        3066.83935546875,
        1830.0,
        316.9542236328125
      ],
      "bbox_max": [
        3249.21630859375,
        2461.31005859375,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3825902044773102,
        0.0,
        0.9239181876182556
      ],
      "plane_d": 814.5899047851562,
      "bbox_min": [
        2963.558349609375,
        660.0,
        76.50570678710938
      ],
      "bbox_max": [
        4137.6171875,
        1830.0,
        831.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26363566517829895,
        -0.09646245092153549,
        0.9597871899604797
      ],
      "plane_d": 575.6990966796875,
      "bbox_min": [
        2963.558349609375,
        660.0,
        76.50570678710938
      ],
      "bbox_max": [
        4137.6171875,
        1830.0,
        831.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7753851413726807,
        -0.028329361230134964,
        0.6308528780937195
      ],
      "plane_d": 2269.93212890625,
      "bbox_min": [
        2963.558349609375,
        660.0,
        76.50570678710938
      ],
      "bbox_max": [
        3240.0,
        1830.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.836047887802124,
        0.0,
        0.5486564636230469
      ],
      "plane_d": 2456.4130859375,
      "bbox_min": [
        3197.37939453125,
        1690.0,
        407.6151123046875
      ],
      "bbox_max": [
        3240.0,
        1830.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1690.0,
      "bbox_min": [
        3197.37939453125,
        1690.0,
        407.6151123046875
      ],
      "bbox_max": [
        3240.0,
        1690.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7398530840873718,
        -0.055298302322626114,
        0.6704919338226318
      ],
      "plane_d": 2182.15185546875,
      "bbox_min": [
        3023.2666015625,
        965.064453125,
        161.0574951171875
      ],
      "bbox_max": [
        3240.0,
        1690.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1690.0,
      "bbox_min": [
        3188.037109375,
        1690.0,
        402.6617126464844
      ],
      "bbox_max": [
        3240.0,
        1690.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4713583290576935,
        -0.3486906588077545,
        0.8100841641426086
      ],
      "plane_d": 1743.849609375,
      "bbox_min": [
        3240.0,
        1340.1431884765625,
        460.0
      ],
      "bbox_max": [
        4137.6171875,
        1690.0,
        831.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        4024.158203125,
        5224.01171875,
        138.28363037109375
      ],
      "bbox_max": [
        5574.01171875,
        6259.5908203125,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238755941390991,
        -0.5008544921875,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        2638.3466796875,
        2099.70263671875,
        0.0
      ],
      "bbox_max": [
        6113.75048828125,
        6577.16845703125,
        1755.698974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        3323.18310546875,
        4951.876953125,
        0.0
      ],
      "bbox_max": [
        4978.5498046875,
        6577.16845703125,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        3548.869140625,
        5621.88623046875,
        377.2276611328125
      ],
      "bbox_max": [
        4978.5498046875,
        6577.16845703125,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.028518805280327797,
        -0.31919899582862854,
        0.947258472442627
      ],
      "plane_d": 1693.8587646484375,
      "bbox_min": [
        3323.18310546875,
        4951.876953125,
        0.0
      ],
      "bbox_max": [
        3970.173828125,
        6257.458984375,
        423.1058654785156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.028518805280327797,
        -0.31919899582862854,
        0.947258472442627
      ],
      "plane_d": 1693.8587646484375,
      "bbox_min": [
        2638.3466796875,
        2099.70263671875,
        0.0
      ],
      "bbox_max": [
        4157.6171875,
        6163.4072265625,
        981.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4462890625,
      "bbox_min": [
        2638.3466796875,
        5034.5224609375,
        0.0
      ],
      "bbox_max": [
        3045.157470703125,
        5852.611328125,
        275.3160400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5660791993141174,
        0.06026303768157959,
        0.8221452236175537
      ],
      "plane_d": 1356.604248046875,
      "bbox_min": [
        2780.0,
        2099.70263671875,
        80.0
      ],
      "bbox_max": [
        4157.6171875,
        3200.0,
        981.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5134666562080383,
        0.06992331147193909,
        0.8552559614181519
      ],
      "plane_d": 1142.2545166015625,
      "bbox_min": [
        2780.0,
        2308.073974609375,
        80.0
      ],
      "bbox_max": [
        3662.360107421875,
        3200.0,
        667.953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5601329803466797,
        0.06843777745962143,
        0.8255710005760193
      ],
      "plane_d": 1309.8272705078125,
      "bbox_min": [
        3249.21630859375,
        2461.31005859375,
        360.0
      ],
      "bbox_max": [
        3662.360107421875,
        3200.0,
        667.953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4106284976005554,
        0.01650269143283367,
        0.9116533994674683
      ],
      "plane_d": 760.2809448242188,
      "bbox_min": [
        -5704.54443359375,
        -2564.65576171875,
        119.09219360351562
      ],
      "bbox_max": [
        6811.5068359375,
        7450.0,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7007350325584412,
        0.5362348556518555,
        0.4705556631088257
      ],
      "plane_d": 762.2274780273438,
      "bbox_min": [
        2459.022216796875,
        3150.14306640625,
        119.09219360351562
      ],
      "bbox_max": [
        6306.5068359375,
        6762.83544921875,
        1913.5762939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        3270.9990234375,
        5907.82958984375,
        465.40106201171875
      ],
      "bbox_max": [
        4550.60546875,
        6762.83544921875,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.028518805280327797,
        -0.31919899582862854,
        0.947258472442627
      ],
      "plane_d": 1693.8587646484375,
      "bbox_min": [
        3173.411865234375,
        6163.4072265625,
        388.7722473144531
      ],
      "bbox_max": [
        3410.9013671875,
        6567.68212890625,
        523.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4462890625,
      "bbox_min": [
        2459.022216796875,
        5070.96826171875,
        119.09219360351562
      ],
      "bbox_max": [
        6306.5068359375,
        6443.86376953125,
        1913.5762939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.028518805280327797,
        -0.31919899582862854,
        0.947258472442627
      ],
      "plane_d": 1693.8587646484375,
      "bbox_min": [
        3027.2626953125,
        5852.611328125,
        275.3160400390625
      ],
      "bbox_max": [
        3323.18310546875,
        6443.86376953125,
        478.7689208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6118655800819397,
        -0.1958032250404358,
        0.7663430571556091
      ],
      "plane_d": 3398.80615234375,
      "bbox_min": [
        6113.75048828125,
        5070.96826171875,
        1755.698974609375
      ],
      "bbox_max": [
        6306.5068359375,
        5140.50634765625,
        1913.5762939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -5704.54443359375,
        -2564.65576171875,
        150.0
      ],
      "bbox_max": [
        6306.5068359375,
        7450.0,
        1954.7119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        -5704.54443359375,
        -2564.65576171875,
        150.0
      ],
      "bbox_max": [
        6306.5068359375,
        7450.0,
        1954.7119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        1489.97119140625,
        6480.25146484375,
        619.3140258789062
      ],
      "bbox_max": [
        5075.25439453125,
        7193.40869140625,
        1954.7119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238755941390991,
        -0.5008544921875,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        4910.861328125,
        6480.25146484375,
        1850.077880859375
      ],
      "bbox_max": [
        5075.25439453125,
        6601.240234375,
        1954.7119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4462890625,
      "bbox_min": [
        1489.97119140625,
        6862.900390625,
        619.3140258789062
      ],
      "bbox_max": [
        3151.548095703125,
        7193.40869140625,
        723.3372802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.028518805280327797,
        -0.31919899582862854,
        0.947258472442627
      ],
      "plane_d": 1693.8587646484375,
      "bbox_min": [
        3014.04736328125,
        6862.900390625,
        619.3140258789062
      ],
      "bbox_max": [
        3151.548095703125,
        7183.8857421875,
        723.3372802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -5704.54443359375,
        -2564.65576171875,
        150.0
      ],
      "bbox_max": [
        6306.5068359375,
        7196.82421875,
        1951.3048095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4462890625,
      "bbox_min": [
        -750.0,
        4955.25732421875,
        150.0
      ],
      "bbox_max": [
        6306.5068359375,
        7196.82421875,
        1951.3048095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.028518805280327797,
        -0.31919899582862854,
        0.947258472442627
      ],
      "plane_d": 1693.8587646484375,
      "bbox_min": [
        3018.309814453125,
        6270.8603515625,
        416.07177734375
      ],
      "bbox_max": [
        3394.5791015625,
        6889.4033203125,
        624.2333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        3108.39404296875,
        6689.4287109375,
        516.9502563476562
      ],
      "bbox_max": [
        3380.85986328125,
        6871.484375,
        620.9073486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        3108.39404296875,
        6561.953125,
        523.6412353515625
      ],
      "bbox_max": [
        3394.5791015625,
        6871.484375,
        623.078369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        3151.548095703125,
        6830.28955078125,
        610.11962890625
      ],
      "bbox_max": [
        3170.047119140625,
        6862.900390625,
        622.4671630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        3163.701416015625,
        6561.953125,
        523.6412353515625
      ],
      "bbox_max": [
        3288.431884765625,
        6834.52880859375,
        612.5286254882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238755941390991,
        -0.5008544921875,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        -750.0,
        4955.25732421875,
        150.0
      ],
      "bbox_max": [
        6306.5068359375,
        7064.0869140625,
        1951.3048095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        3170.046630859375,
        6099.232421875,
        574.108154296875
      ],
      "bbox_max": [
        4264.15087890625,
        6830.28955078125,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        3108.39404296875,
        6189.9765625,
        612.5287475585938
      ],
      "bbox_max": [
        4128.3427734375,
        6871.484375,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        3108.39404296875,
        6297.02197265625,
        740.1891479492188
      ],
      "bbox_max": [
        3968.1376953125,
        6871.484375,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -5704.54443359375,
        -2564.65576171875,
        159.59542846679688
      ],
      "bbox_max": [
        2130.0,
        5224.01171875,
        1733.090087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1830.0,
      "bbox_min": [
        -903.2229614257812,
        -2564.65576171875,
        159.59542846679688
      ],
      "bbox_max": [
        2130.0,
        2307.40087890625,
        1733.090087890625
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1770.0,
      "bbox_min": [
        1148.2298583984375,
        1830.0,
        261.0
      ],
      "bbox_max": [
        2129.0986328125,
        2307.40087890625,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9688339829444885,
        -0.24771107733249664,
        0.0
      ],
      "plane_d": -1154.953125,
      "bbox_min": [
        1148.2298583984375,
        1830.0,
        261.0
      ],
      "bbox_max": [
        1770.0,
        2307.40087890625,
        1150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5877799987792969,
        -0.8090208172798157,
        0.0
      ],
      "plane_d": 2357.28662109375,
      "bbox_min": [
        1148.2298583984375,
        1830.0,
        261.0
      ],
      "bbox_max": [
        1630.0,
        2307.40087890625,
        590.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9510562419891357,
        -0.30901798605918884,
        0.0
      ],
      "plane_d": 2075.712646484375,
      "bbox_min": [
        1312.1885986328125,
        1960.4049072265625,
        270.0
      ],
      "bbox_max": [
        1630.0,
        2307.40087890625,
        590.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510562419891357,
        -0.30901798605918884,
        0.0
      ],
      "plane_d": -853.5406494140625,
      "bbox_min": [
        1467.1885986328125,
        2168.905029296875,
        270.0
      ],
      "bbox_max": [
        1630.0,
        2307.40087890625,
        590.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510568976402283,
        0.30901601910591125,
        -0.0
      ],
      "plane_d": -2246.8994140625,
      "bbox_min": [
        1467.1885986328125,
        2168.905029296875,
        270.0
      ],
      "bbox_max": [
        1630.0,
        2307.40087890625,
        590.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877814888954163,
        -0.8090198040008545,
        0.0
      ],
      "plane_d": 833.1566162109375,
      "bbox_min": [
        1467.1885986328125,
        2168.905029296875,
        270.0
      ],
      "bbox_max": [
        1612.8114013671875,
        2276.4990234375,
        590.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877814888954163,
        -0.8090198040008545,
        0.0
      ],
      "plane_d": 2643.523681640625,
      "bbox_min": [
        1467.1885986328125,
        2168.905029296875,
        270.0
      ],
      "bbox_max": [
        1577.4268798828125,
        2276.4990234375,
        590.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2168.905029296875,
      "bbox_min": [
        1512.1885986328125,
        2168.905029296875,
        270.0
      ],
      "bbox_max": [
        1577.4268798828125,
        2276.4990234375,
        590.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.951056182384491,
        0.3090183138847351,
        -0.0
      ],
      "plane_d": -2196.9033203125,
      "bbox_min": [
        1570.2789306640625,
        2232.5009765625,
        570.0
      ],
      "bbox_max": [
        1577.4268798828125,
        2276.4990234375,
        590.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.951056182384491,
        -0.3090183138847351,
        0.0
      ],
      "plane_d": -803.539794921875,
      "bbox_min": [
        1570.2789306640625,
        2232.5009765625,
        570.0
      ],
      "bbox_max": [
        1577.4268798828125,
        2254.5,
        590.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510568976402283,
        0.30901601910591125,
        -0.0
      ],
      "plane_d": -1992.258056640625,
      "bbox_min": [
        1312.1885986328125,
        1960.4049072265625,
        270.0
      ],
      "bbox_max": [
        1429.9998779296875,
        2098.90087890625,
        570.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877822637557983,
        -0.8090192675590515,
        0.0
      ],
      "plane_d": 782.0301513671875,
      "bbox_min": [
        1312.1885986328125,
        1960.4049072265625,
        270.0
      ],
      "bbox_max": [
        1429.9998779296875,
        2046.0,
        570.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510572552680969,
        -0.3090146780014038,
        0.0
      ],
      "plane_d": -727.7677001953125,
      "bbox_min": [
        1312.1885986328125,
        1960.4049072265625,
        270.0
      ],
      "bbox_max": [
        1429.9998779296875,
        2046.0,
        570.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -4.389228251966415e-06,
        -1.0,
        0.0
      ],
      "plane_d": 1960.410888671875,
      "bbox_min": [
        1312.1885986328125,
        1960.4049072265625,
        270.0
      ],
      "bbox_max": [
        1367.811279296875,
        1960.4051513671875,
        570.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1890.0,
      "bbox_min": [
        1148.2298583984375,
        1830.0,
        261.0
      ],
      "bbox_max": [
        1350.0,
        1890.0,
        440.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1350.0,
      "bbox_min": [
        1169.199951171875,
        1830.0,
        261.0
      ],
      "bbox_max": [
        1350.0,
        1890.0,
        440.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1834.9998779296875,
      "bbox_min": [
        1169.199951171875,
        1830.0,
        379.0
      ],
      "bbox_max": [
        1350.0,
        1890.0,
        440.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.0,
        0.44721364974975586
      ],
      "plane_d": -1376.9708251953125,
      "bbox_min": [
        1300.0,
        1835.0,
        379.0
      ],
      "bbox_max": [
        1350.0,
        1890.0,
        440.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826870620250702,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1202.4425048828125,
      "bbox_min": [
        1300.0,
        1840.0,
        429.0
      ],
      "bbox_max": [
        1320.0,
        1880.0,
        440.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826870620250702,
        0.9238780736923218,
        -0.0
      ],
      "plane_d": -2234.384033203125,
      "bbox_min": [
        1300.0,
        1845.85791015625,
        429.0
      ],
      "bbox_max": [
        1320.0,
        1880.0,
        440.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        -0.3826870620250702,
        0.0
      ],
      "plane_d": -507.72113037109375,
      "bbox_min": [
        1314.14208984375,
        1845.85791015625,
        429.0
      ],
      "bbox_max": [
        1320.0,
        1874.14208984375,
        440.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        0.3826870620250702,
        -0.0
      ],
      "plane_d": -1931.31689453125,
      "bbox_min": [
        1314.14208984375,
        1860.0,
        429.0
      ],
      "bbox_max": [
        1320.0,
        1874.14208984375,
        440.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        -0.3826870620250702,
        0.0
      ],
      "plane_d": -507.72113037109375,
      "bbox_min": [
        1319.5,
        1858.792724609375,
        438.9999084472656
      ],
      "bbox_max": [
        1320.0,
        1861.207275390625,
        440.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        0.3826870620250702,
        -0.0
      ],
      "plane_d": -1931.31689453125,
      "bbox_min": [
        1319.5,
        1860.0,
        438.9999084472656
      ],
      "bbox_max": [
        1320.0,
        1861.207275390625,
        440.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 415.0,
      "bbox_min": [
        1184.2298583984375,
        1830.0,
        379.0
      ],
      "bbox_max": [
        1350.0,
        1835.0,
        429.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.0,
        0.44721364974975586
      ],
      "plane_d": -1376.9708251953125,
      "bbox_min": [
        1325.0,
        1830.0,
        415.0
      ],
      "bbox_max": [
        1332.0,
        1835.0,
        429.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.0,
        0.44721364974975586
      ],
      "plane_d": -1376.9708251953125,
      "bbox_min": [
        1332.0,
        1830.0,
        379.0
      ],
      "bbox_max": [
        1350.0,
        1835.0,
        415.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2483755201101303,
        -0.9686638712882996,
        0.0
      ],
      "plane_d": 1439.6800537109375,
      "bbox_min": [
        1660.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        1770.0,
        1940.0999755859375,
        1150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 138.734375,
      "bbox_min": [
        1660.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        1770.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1660.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        1770.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1660.0,
        1830.0,
        980.0
      ],
      "bbox_max": [
        1770.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1706.639892578125,
        1830.0,
        1130.0
      ],
      "bbox_max": [
        1770.0,
        1893.3599853515625,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2499.056640625,
      "bbox_min": [
        1668.9998779296875,
        1830.0,
        980.0
      ],
      "bbox_max": [
        1770.0,
        1931.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2592.253662109375,
      "bbox_min": [
        1734.9000244140625,
        1896.0,
        980.0
      ],
      "bbox_max": [
        1770.0,
        1931.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1766.382568359375,
        1830.0,
        1130.0
      ],
      "bbox_max": [
        1770.0,
        1833.617431640625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -44.1722412109375,
      "bbox_min": [
        1767.5311279296875,
        1830.0,
        375.0
      ],
      "bbox_max": [
        1770.0,
        1832.4688720703125,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -379.9999694824219,
      "bbox_min": [
        1767.5311279296875,
        1830.0,
        380.0
      ],
      "bbox_max": [
        1770.0,
        1832.4688720703125,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1770.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        2129.0986328125,
        2052.73095703125,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9688333868980408,
        -0.24771343171596527,
        0.0
      ],
      "plane_d": 2410.359130859375,
      "bbox_min": [
        1910.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        2129.0986328125,
        2052.73095703125,
        1150.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2875.0,
      "bbox_min": [
        1973.2493896484375,
        1846.0794677734375,
        370.0
      ],
      "bbox_max": [
        2129.0986328125,
        2052.73095703125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3162274956703186,
        -0.3162274956703186,
        -0.8944273591041565
      ],
      "plane_d": 1652.4532470703125,
      "bbox_min": [
        1973.2493896484375,
        1846.0794677734375,
        370.0
      ],
      "bbox_max": [
        2129.0986328125,
        2052.73095703125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071062922477722,
        0.7071073651313782,
        -0.0
      ],
      "plane_d": -2815.0,
      "bbox_min": [
        1982.4197998046875,
        1881.502197265625,
        420.0
      ],
      "bbox_max": [
        2097.0341796875,
        2019.95947265625,
        665.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 665.0,
      "bbox_min": [
        1982.4197998046875,
        1881.502197265625,
        635.0
      ],
      "bbox_max": [
        2062.739501953125,
        1986.3719482421875,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070762515068054,
        -0.7071372866630554,
        0.0
      ],
      "plane_d": -86.3785400390625,
      "bbox_min": [
        1997.22314453125,
        1920.8555908203125,
        635.0
      ],
      "bbox_max": [
        2058.741455078125,
        1982.3739013671875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071372866630554,
        -0.7070762515068054,
        0.0
      ],
      "plane_d": -11.62158203125,
      "bbox_min": [
        1997.22314453125,
        1973.8885498046875,
        635.0
      ],
      "bbox_max": [
        2005.7083740234375,
        1982.3739013671875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 21.5001220703125,
      "bbox_min": [
        1997.22314453125,
        1973.8885498046875,
        635.0
      ],
      "bbox_max": [
        2005.7083740234375,
        1982.3739013671875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1997.22314453125,
        1973.8885498046875,
        650.0
      ],
      "bbox_max": [
        2005.7083740234375,
        1982.3739013671875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        0.7071372866630554,
        0.0
      ],
      "plane_d": 96.3785400390625,
      "bbox_min": [
        2050.256103515625,
        1920.8555908203125,
        635.0
      ],
      "bbox_max": [
        2058.741455078125,
        1929.3408203125,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        2050.256103515625,
        1920.8555908203125,
        650.0
      ],
      "bbox_max": [
        2058.741455078125,
        1929.3408203125,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071062922477722,
        -0.7071073651313782,
        0.0
      ],
      "plane_d": 2855.0,
      "bbox_min": [
        1989.689453125,
        1912.614990234375,
        420.0
      ],
      "bbox_max": [
        2097.0341796875,
        2019.95947265625,
        660.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 640.0,
      "bbox_min": [
        2017.9737548828125,
        1940.899169921875,
        640.0
      ],
      "bbox_max": [
        2097.0341796875,
        2019.95947265625,
        645.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -8.845947265625,
      "bbox_min": [
        2025.044677734375,
        1948.677490234375,
        640.0
      ],
      "bbox_max": [
        2089.255859375,
        2012.888427734375,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707109808921814,
        0.7071037888526917,
        0.0
      ],
      "plane_d": 99.1661376953125,
      "bbox_min": [
        2088.90234375,
        1948.677490234375,
        640.0
      ],
      "bbox_max": [
        2089.255859375,
        1949.031005859375,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        1989.689453125,
        1912.614990234375,
        420.0
      ],
      "bbox_max": [
        2096.6806640625,
        2019.60595703125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -19.0,
      "bbox_min": [
        1989.689453125,
        1912.614990234375,
        420.0
      ],
      "bbox_max": [
        2096.6806640625,
        2019.60595703125,
        660.0
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 14.0,
      "bbox_min": [
        1989.689453125,
        1984.2506103515625,
        420.0
      ],
      "bbox_max": [
        2032.224853515625,
        2019.60595703125,
        660.0
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": 2830.0,
      "bbox_min": [
        2011.01171875,
        1987.6771240234375,
        429.9999694824219
      ],
      "bbox_max": [
        2032.224853515625,
        2008.890380859375,
        660.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": -2835.0,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        429.9999694824219
      ],
      "bbox_max": [
        2032.224853515625,
        2008.890380859375,
        660.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 525.0,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        460.0
      ],
      "bbox_max": [
        2032.224853515625,
        2008.890380859375,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 585.0,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        580.0
      ],
      "bbox_max": [
        2032.224853515625,
        2008.890380859375,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 645.0,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        640.0
      ],
      "bbox_max": [
        2032.224853515625,
        2008.890380859375,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000008344650269,
        0.5000008344650269,
        -0.7071056962013245
      ],
      "plane_d": -1552.103515625,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        640.0
      ],
      "bbox_max": [
        2021.6182861328125,
        1998.2838134765625,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000008344650269,
        0.5000008344650269,
        -0.7071056962013245
      ],
      "plane_d": -1594.52978515625,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        580.0
      ],
      "bbox_max": [
        2021.6182861328125,
        1998.2838134765625,
        585.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 465.0,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        460.0
      ],
      "bbox_max": [
        2032.224853515625,
        2008.890380859375,
        525.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000008344650269,
        0.5000008344650269,
        -0.7071056962013245
      ],
      "plane_d": -1636.9561767578125,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        520.0
      ],
      "bbox_max": [
        2021.6182861328125,
        1998.2838134765625,
        525.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000008344650269,
        0.5000008344650269,
        -0.7071056962013245
      ],
      "plane_d": -1679.382568359375,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        460.0
      ],
      "bbox_max": [
        2021.6182861328125,
        1998.2838134765625,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1.1541748046875,
      "bbox_min": [
        1989.689453125,
        1984.2506103515625,
        420.0
      ],
      "bbox_max": [
        2025.044677734375,
        2019.60595703125,
        650.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -8.845947265625,
      "bbox_min": [
        1996.7606201171875,
        1984.2506103515625,
        640.0
      ],
      "bbox_max": [
        2025.044677734375,
        2012.53466796875,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070946097373962,
        0.7071189880371094,
        0.0
      ],
      "plane_d": 88.951171875,
      "bbox_min": [
        2011.01171875,
        1912.614990234375,
        420.0
      ],
      "bbox_max": [
        2096.6806640625,
        1998.2838134765625,
        660.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.7071189880371094,
        -0.7070945501327515,
        0.0
      ],
      "plane_d": -94.0489501953125,
      "bbox_min": [
        2060.6181640625,
        1912.614990234375,
        420.0
      ],
      "bbox_max": [
        2096.6806640625,
        1955.8572998046875,
        660.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        -0.7070946097373962,
        -0.7071189880371094,
        0.0
      ],
      "plane_d": 2829.99853515625,
      "bbox_min": [
        2064.044677734375,
        1934.6441650390625,
        429.9999694824219
      ],
      "bbox_max": [
        2085.2578125,
        1955.8572998046875,
        660.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.7071189880371094,
        0.7070945501327515,
        0.0
      ],
      "plane_d": -2835.00146484375,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        429.9999694824219
      ],
      "bbox_max": [
        2085.2578125,
        1955.8572998046875,
        660.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 525.0,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        460.0
      ],
      "bbox_max": [
        2085.2578125,
        1955.8572998046875,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 585.0,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        580.0
      ],
      "bbox_max": [
        2085.2578125,
        1955.8572998046875,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 645.0,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        640.0
      ],
      "bbox_max": [
        2085.2578125,
        1955.8572998046875,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999879002571106,
        0.5000051259994507,
        -0.7071117162704468
      ],
      "plane_d": -1552.0810546875,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        640.0
      ],
      "bbox_max": [
        2074.6513671875,
        1945.250732421875,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999879002571106,
        0.5000051259994507,
        -0.7071117162704468
      ],
      "plane_d": -1594.5078125,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        580.0
      ],
      "bbox_max": [
        2074.6513671875,
        1945.250732421875,
        585.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 465.0,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        460.0
      ],
      "bbox_max": [
        2085.2578125,
        1955.8572998046875,
        525.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999879002571106,
        0.5000051259994507,
        -0.7071117162704468
      ],
      "plane_d": -1636.9344482421875,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        520.0
      ],
      "bbox_max": [
        2074.6513671875,
        1945.250732421875,
        525.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999879002571106,
        0.5000051259994507,
        -0.7071117162704468
      ],
      "plane_d": -1679.3612060546875,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        460.0
      ],
      "bbox_max": [
        2074.6513671875,
        1945.250732421875,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071037888526917,
        0.7071098685264587,
        0.0
      ],
      "plane_d": 110.141845703125,
      "bbox_min": [
        2060.6181640625,
        1912.614990234375,
        420.0
      ],
      "bbox_max": [
        2096.6806640625,
        1948.677490234375,
        650.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.707109808921814,
        0.7071037888526917,
        0.0
      ],
      "plane_d": 99.1661376953125,
      "bbox_min": [
        2060.6181640625,
        1920.39306640625,
        640.0
      ],
      "bbox_max": [
        2088.90234375,
        1948.677490234375,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24828201532363892,
        0.24828201532363892,
        -0.9363291263580322
      ],
      "plane_d": -454.705810546875,
      "bbox_min": [
        2011.01171875,
        1934.6441650390625,
        450.0
      ],
      "bbox_max": [
        2074.6513671875,
        1998.2838134765625,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2482801079750061,
        0.24828295409679413,
        -0.9363293051719666
      ],
      "plane_d": -398.52392578125,
      "bbox_min": [
        2011.01171875,
        1934.6441650390625,
        570.0
      ],
      "bbox_max": [
        2074.6513671875,
        1998.2838134765625,
        650.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -79.0,
      "bbox_min": [
        2011.01171875,
        1934.6441650390625,
        630.0
      ],
      "bbox_max": [
        2074.6513671875,
        1998.2838134765625,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071083188056946,
        0.707105278968811,
        0.0
      ],
      "plane_d": 29.006103515625,
      "bbox_min": [
        2011.01171875,
        1969.99951171875,
        630.0
      ],
      "bbox_max": [
        2039.2958984375,
        1998.2838134765625,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        2035.7603759765625,
        1945.250732421875,
        570.0
      ],
      "bbox_max": [
        2064.044677734375,
        1973.5350341796875,
        590.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24828201532363892,
        0.24828201532363892,
        -0.9363291263580322
      ],
      "plane_d": -567.0653076171875,
      "bbox_min": [
        2011.01171875,
        1934.6441650390625,
        450.0
      ],
      "bbox_max": [
        2074.6513671875,
        1998.2838134765625,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2482801079750061,
        0.24828295409679413,
        -0.9363293051719666
      ],
      "plane_d": -510.8834228515625,
      "bbox_min": [
        2011.01171875,
        1934.6441650390625,
        450.0
      ],
      "bbox_max": [
        2074.6513671875,
        1998.2838134765625,
        530.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 64.0,
      "bbox_min": [
        2011.01171875,
        1934.6441650390625,
        510.0
      ],
      "bbox_max": [
        2074.6513671875,
        1998.2838134765625,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -79.0,
      "bbox_min": [
        2046.3670654296875,
        1934.6441650390625,
        510.0
      ],
      "bbox_max": [
        2074.6513671875,
        1962.928466796875,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071083188056946,
        0.707105278968811,
        0.0
      ],
      "plane_d": 29.006103515625,
      "bbox_min": [
        2011.01171875,
        1959.3929443359375,
        510.0
      ],
      "bbox_max": [
        2049.902587890625,
        1998.2838134765625,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.707105278968811,
        -0.7071083784103394,
        0.0
      ],
      "plane_d": -43.9937744140625,
      "bbox_min": [
        2021.6182861328125,
        1959.3929443359375,
        510.0
      ],
      "bbox_max": [
        2049.902587890625,
        1987.6771240234375,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        2021.6182861328125,
        1945.250732421875,
        450.0
      ],
      "bbox_max": [
        2064.044677734375,
        1987.6771240234375,
        470.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707105278968811,
        0.7071083188056946,
        0.0
      ],
      "plane_d": 43.993896484375,
      "bbox_min": [
        2021.6182861328125,
        1959.3929443359375,
        450.0
      ],
      "bbox_max": [
        2049.902587890625,
        1987.6771240234375,
        470.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -385.0,
      "bbox_min": [
        1973.2493896484375,
        1846.0794677734375,
        370.0
      ],
      "bbox_max": [
        2129.0986328125,
        2052.73095703125,
        440.00006103515625
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        -0.7071062922477722,
        -0.7071073651313782,
        0.0
      ],
      "plane_d": 2855.0,
      "bbox_min": [
        1974.996337890625,
        1846.0794677734375,
        370.0
      ],
      "bbox_max": [
        2096.6806640625,
        2019.60595703125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1974.996337890625,
        1846.0794677734375,
        370.0
      ],
      "bbox_max": [
        2096.6806640625,
        2019.60595703125,
        385.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 136.0,
      "bbox_min": [
        1974.996337890625,
        1846.0794677734375,
        370.0
      ],
      "bbox_max": [
        2096.6806640625,
        2019.60595703125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -372.5,
      "bbox_min": [
        1974.996337890625,
        1846.0794677734375,
        370.0
      ],
      "bbox_max": [
        2096.6806640625,
        2019.60595703125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2800.000244140625,
      "bbox_min": [
        1974.996337890625,
        1846.0794677734375,
        370.0
      ],
      "bbox_max": [
        2096.6806640625,
        2019.60595703125,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1989.951171875,
        1846.0794677734375,
        370.0
      ],
      "bbox_max": [
        2066.287109375,
        1958.685791015625,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 30.0,
      "bbox_min": [
        1989.951171875,
        1895.046142578125,
        370.0
      ],
      "bbox_max": [
        2008.1832275390625,
        1958.685791015625,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 118.0001220703125,
      "bbox_min": [
        2012.35205078125,
        1846.0794677734375,
        370.0
      ],
      "bbox_max": [
        2066.287109375,
        1894.9959716796875,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071037888526917,
        -0.7071098685264587,
        0.0
      ],
      "plane_d": -120.088134765625,
      "bbox_min": [
        2015.9613037109375,
        1846.0794677734375,
        370.0
      ],
      "bbox_max": [
        2066.287109375,
        1894.9959716796875,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870620250702,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -960.5721435546875,
      "bbox_min": [
        2059.802001953125,
        1892.9248046875,
        370.0
      ],
      "bbox_max": [
        2064.802001953125,
        1894.9959716796875,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238780736923218,
        -0.3826870620250702,
        0.0
      ],
      "plane_d": 2603.51416015625,
      "bbox_min": [
        2042.73095703125,
        1860.46875,
        370.0
      ],
      "bbox_max": [
        2066.287109375,
        1893.510986328125,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2767.100341796875,
      "bbox_min": [
        2042.73095703125,
        1860.46875,
        370.0
      ],
      "bbox_max": [
        2066.287109375,
        1893.510986328125,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238812923431396,
        -0.382679283618927,
        0.0
      ],
      "plane_d": -1172.9158935546875,
      "bbox_min": [
        2042.73095703125,
        1866.1256103515625,
        370.0
      ],
      "bbox_max": [
        2066.287109375,
        1893.510986328125,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238753318786621,
        0.3826935589313507,
        0.0
      ],
      "plane_d": -2605.4609375,
      "bbox_min": [
        2044.8310546875,
        1866.1256103515625,
        370.0
      ],
      "bbox_max": [
        2066.287109375,
        1893.510986328125,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38269656896591187,
        -0.9238741993904114,
        0.0
      ],
      "plane_d": 958.6049194335938,
      "bbox_min": [
        2061.287109375,
        1891.4398193359375,
        370.0
      ],
      "bbox_max": [
        2066.287109375,
        1893.510986328125,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486849308013916,
        0.3162228763103485,
        -0.0
      ],
      "plane_d": -2497.23486328125,
      "bbox_min": [
        2016.7037353515625,
        1846.0794677734375,
        370.0
      ],
      "bbox_max": [
        2016.962890625,
        1846.85693359375,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2765.0,
      "bbox_min": [
        2024.4466552734375,
        1878.0755615234375,
        370.0
      ],
      "bbox_max": [
        2040.0030517578125,
        1893.6319580078125,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -109.0001220703125,
      "bbox_min": [
        2032.224853515625,
        1878.0755615234375,
        370.0
      ],
      "bbox_max": [
        2040.0030517578125,
        1893.6319580078125,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2776.000244140625,
      "bbox_min": [
        2032.224853515625,
        1885.853759765625,
        370.0
      ],
      "bbox_max": [
        2040.0030517578125,
        1893.6319580078125,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071047425270081,
        0.7071087956428528,
        0.0
      ],
      "plane_d": 110.14599609375,
      "bbox_min": [
        1974.996337890625,
        1885.7830810546875,
        370.0
      ],
      "bbox_max": [
        2096.6806640625,
        2019.60595703125,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2815.000244140625,
      "bbox_min": [
        2064.802001953125,
        1885.7830810546875,
        370.0
      ],
      "bbox_max": [
        2086.672119140625,
        1912.614990234375,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2805.0,
      "bbox_min": [
        2064.802001953125,
        1885.7830810546875,
        370.0
      ],
      "bbox_max": [
        2079.60107421875,
        1895.853759765625,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826734721660614,
        0.9238837361335754,
        0.0
      ],
      "plane_d": -2542.48583984375,
      "bbox_min": [
        2064.802001953125,
        1885.7830810546875,
        370.0
      ],
      "bbox_max": [
        2078.115966796875,
        1895.853759765625,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2802.900146484375,
      "bbox_min": [
        2064.802001953125,
        1885.7830810546875,
        370.0
      ],
      "bbox_max": [
        2078.115966796875,
        1895.853759765625,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3827107846736908,
        -0.9238681793212891,
        0.0
      ],
      "plane_d": 2540.593505859375,
      "bbox_min": [
        2064.802001953125,
        1891.4398193359375,
        370.0
      ],
      "bbox_max": [
        2072.459228515625,
        1895.853759765625,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870620250702,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -960.5721435546875,
      "bbox_min": [
        2064.802001953125,
        1894.9959716796875,
        370.0
      ],
      "bbox_max": [
        2066.873046875,
        1895.853759765625,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38269656896591187,
        -0.9238741993904114,
        0.0
      ],
      "plane_d": 958.6049194335938,
      "bbox_min": [
        2066.287109375,
        1893.510986328125,
        370.0
      ],
      "bbox_max": [
        2066.873291015625,
        1893.7537841796875,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2815.0,
      "bbox_min": [
        1974.996337890625,
        1991.3216552734375,
        370.0
      ],
      "bbox_max": [
        1989.689453125,
        2006.0147705078125,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2815.000244140625,
      "bbox_min": [
        2049.902587890625,
        1912.614990234375,
        370.0
      ],
      "bbox_max": [
        2075.46728515625,
        1931.108642578125,
        372.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071123719215393,
        0.7071012854576111,
        0.0
      ],
      "plane_d": -2825.0009765625,
      "bbox_min": [
        2060.6181640625,
        1919.6859130859375,
        370.0
      ],
      "bbox_max": [
        2075.46728515625,
        1930.999755859375,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 99.154052734375,
      "bbox_min": [
        2060.6181640625,
        1920.39306640625,
        370.0
      ],
      "bbox_max": [
        2067.689208984375,
        1927.464111328125,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071312069892883,
        -0.7070823311805725,
        0.0
      ],
      "plane_d": -99.251708984375,
      "bbox_min": [
        2067.689208984375,
        1927.464111328125,
        370.0
      ],
      "bbox_max": [
        2071.224609375,
        1930.999755859375,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070946097373962,
        0.7071189880371094,
        0.0
      ],
      "plane_d": 88.951171875,
      "bbox_min": [
        2064.044677734375,
        1934.6441650390625,
        370.0
      ],
      "bbox_max": [
        2071.11572265625,
        1941.7152099609375,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071189880371094,
        -0.7070945501327515,
        0.0
      ],
      "plane_d": -94.0489501953125,
      "bbox_min": [
        2067.580322265625,
        1934.6441650390625,
        370.0
      ],
      "bbox_max": [
        2071.11572265625,
        1941.7152099609375,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071189880371094,
        0.7070945501327515,
        -0.0
      ],
      "plane_d": -2835.00146484375,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        370.0
      ],
      "bbox_max": [
        2071.11572265625,
        1941.7152099609375,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -24.0,
      "bbox_min": [
        1989.689453125,
        1949.493408203125,
        370.0
      ],
      "bbox_max": [
        2054.003662109375,
        1998.3927001953125,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2830.000244140625,
      "bbox_min": [
        1989.689453125,
        1973.5350341796875,
        370.0
      ],
      "bbox_max": [
        2018.082763671875,
        1998.3927001953125,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2815.000244140625,
      "bbox_min": [
        1989.689453125,
        1973.5350341796875,
        370.0
      ],
      "bbox_max": [
        2007.4761962890625,
        1998.3927001953125,
        372.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -8.845947265625,
      "bbox_min": [
        1996.7606201171875,
        1984.2506103515625,
        370.0
      ],
      "bbox_max": [
        2007.3671875,
        1998.3927001953125,
        372.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2825.000244140625,
      "bbox_min": [
        1996.7606201171875,
        1991.3216552734375,
        370.0
      ],
      "bbox_max": [
        2003.8316650390625,
        1998.3927001953125,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 14.0001220703125,
      "bbox_min": [
        2011.01171875,
        1987.6771240234375,
        370.0
      ],
      "bbox_max": [
        2018.082763671875,
        1994.7481689453125,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -19.0,
      "bbox_min": [
        2014.5472412109375,
        1987.6771240234375,
        370.0
      ],
      "bbox_max": [
        2018.082763671875,
        1994.7481689453125,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2835.0,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        370.0
      ],
      "bbox_max": [
        2018.082763671875,
        1994.7481689453125,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3483176529407501,
        -0.3483176529407501,
        0.8702583312988281
      ],
      "plane_d": 1071.3109130859375,
      "bbox_min": [
        2025.8609619140625,
        1949.493408203125,
        370.0
      ],
      "bbox_max": [
        2054.003662109375,
        1977.6363525390625,
        372.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.3554038107395172,
        0.3554038107395172,
        -0.8645093441009521
      ],
      "plane_d": -1104.296630859375,
      "bbox_min": [
        2029.04296875,
        1952.6754150390625,
        370.0
      ],
      "bbox_max": [
        2054.003662109375,
        1977.6363525390625,
        372.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071189880371094,
        -0.7070945501327515,
        -3.0492372388835065e-05
      ],
      "plane_d": -48.03766632080078,
      "bbox_min": [
        2029.04296875,
        1952.6754150390625,
        370.0
      ],
      "bbox_max": [
        2054.003662109375,
        1977.6363525390625,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071090936660767,
        0.7071044445037842,
        0.0
      ],
      "plane_d": 41.0093994140625,
      "bbox_min": [
        2029.04296875,
        1971.0601806640625,
        370.0
      ],
      "bbox_max": [
        2035.6190185546875,
        1977.6363525390625,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071011066436768,
        0.7071124911308289,
        0.0
      ],
      "plane_d": 59.9771728515625,
      "bbox_min": [
        2042.4779052734375,
        1952.6754150390625,
        370.0
      ],
      "bbox_max": [
        2054.003662109375,
        1964.201171875,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071189880371094,
        -0.7070945501327515,
        -4.352215910330415e-05
      ],
      "plane_d": -67.03279113769531,
      "bbox_min": [
        2047.427734375,
        1952.6754150390625,
        370.0
      ],
      "bbox_max": [
        2054.003662109375,
        1959.25146484375,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 59.0,
      "bbox_min": [
        2025.8609619140625,
        1949.493408203125,
        370.0
      ],
      "bbox_max": [
        2051.2578125,
        1974.8902587890625,
        372.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071044445037842,
        0.7071090936660767,
        0.0
      ],
      "plane_d": 66.99072265625,
      "bbox_min": [
        2039.2958984375,
        1949.493408203125,
        370.0
      ],
      "bbox_max": [
        2051.2578125,
        1960.7481689453125,
        372.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071067094802856,
        -0.7071067094802856,
        0.0
      ],
      "plane_d": -68.0,
      "bbox_min": [
        2044.9527587890625,
        1949.493408203125,
        370.0
      ],
      "bbox_max": [
        2051.2578125,
        1955.09130859375,
        372.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2825.000244140625,
      "bbox_min": [
        2044.9527587890625,
        1949.493408203125,
        370.0
      ],
      "bbox_max": [
        2045.659912109375,
        1950.2005615234375,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071021199226379,
        -0.7071112990379333,
        0.0
      ],
      "plane_d": -59.9815673828125,
      "bbox_min": [
        2039.2958984375,
        1955.1502685546875,
        370.0
      ],
      "bbox_max": [
        2045.60107421875,
        1960.7481689453125,
        372.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7070457339286804,
        -0.7071678042411804,
        -0.0
      ],
      "plane_d": 2824.99462890625,
      "bbox_min": [
        2039.2958984375,
        1955.1502685546875,
        370.0
      ],
      "bbox_max": [
        2040.0030517578125,
        1955.8572998046875,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067094802856,
        0.7071067094802856,
        0.0
      ],
      "plane_d": 48.0,
      "bbox_min": [
        2025.8609619140625,
        1962.928466796875,
        370.0
      ],
      "bbox_max": [
        2037.82275390625,
        1974.8902587890625,
        372.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071067094802856,
        -0.7071067094802856,
        0.0
      ],
      "plane_d": -49.0,
      "bbox_min": [
        2031.517822265625,
        1962.928466796875,
        370.0
      ],
      "bbox_max": [
        2037.82275390625,
        1968.5263671875,
        372.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2825.000244140625,
      "bbox_min": [
        2031.517822265625,
        1962.928466796875,
        370.0
      ],
      "bbox_max": [
        2032.224853515625,
        1963.635498046875,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067094802856,
        0.7071067094802856,
        0.0
      ],
      "plane_d": 40.0,
      "bbox_min": [
        2025.8609619140625,
        1968.5853271484375,
        370.0
      ],
      "bbox_max": [
        2032.166015625,
        1974.8902587890625,
        372.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071090936660767,
        -0.7071044445037842,
        0.0
      ],
      "plane_d": -41.0093994140625,
      "bbox_min": [
        2025.8609619140625,
        1968.5853271484375,
        370.0
      ],
      "bbox_max": [
        2032.166015625,
        1974.1832275390625,
        372.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2825.000244140625,
      "bbox_min": [
        2025.8609619140625,
        1968.5853271484375,
        370.0
      ],
      "bbox_max": [
        2026.5679931640625,
        1969.2923583984375,
        372.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2800.000244140625,
      "bbox_min": [
        1974.996337890625,
        1846.0794677734375,
        372.5
      ],
      "bbox_max": [
        2096.6806640625,
        2019.60595703125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -374.9999694824219,
      "bbox_min": [
        1989.951171875,
        1846.0794677734375,
        372.5
      ],
      "bbox_max": [
        2068.84521484375,
        1958.685791015625,
        385.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.7071055173873901,
        -0.7071081399917603,
        -0.0
      ],
      "plane_d": 2798.0,
      "bbox_min": [
        1989.951171875,
        1846.0794677734375,
        372.5
      ],
      "bbox_max": [
        2068.84521484375,
        1958.685791015625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870620250702,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -960.5721435546875,
      "bbox_min": [
        1999.697998046875,
        1890.9530029296875,
        372.5
      ],
      "bbox_max": [
        2068.84521484375,
        1958.685791015625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 373.0,
      "bbox_min": [
        2064.287109375,
        1890.9530029296875,
        372.5
      ],
      "bbox_max": [
        2068.84521484375,
        1893.510986328125,
        375.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.38269656896591187,
        -0.9238741993904114,
        0.0
      ],
      "plane_d": 958.6049194335938,
      "bbox_min": [
        2064.287109375,
        1890.9530029296875,
        373.0
      ],
      "bbox_max": [
        2068.84521484375,
        1893.510986328125,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10071714222431183,
        -0.24314017593860626,
        0.9647481441497803
      ],
      "plane_d": 307.8013916015625,
      "bbox_min": [
        2064.287109375,
        1890.9530029296875,
        373.0
      ],
      "bbox_max": [
        2068.84521484375,
        1893.510986328125,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38270023465156555,
        -0.9238725900650024,
        0.0
      ],
      "plane_d": 2538.7470703125,
      "bbox_min": [
        2065.68994140625,
        1890.9530029296875,
        373.0
      ],
      "bbox_max": [
        2068.84521484375,
        1891.769775390625,
        373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826812207698822,
        -0.9238805770874023,
        0.0
      ],
      "plane_d": 956.8157958984375,
      "bbox_min": [
        2065.68994140625,
        1891.2796630859375,
        373.0
      ],
      "bbox_max": [
        2066.873291015625,
        1891.769775390625,
        373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10070779919624329,
        -0.24313180148601532,
        0.9647512435913086
      ],
      "plane_d": -108.53544616699219,
      "bbox_min": [
        2064.287109375,
        1891.2796630859375,
        373.2529602050781
      ],
      "bbox_max": [
        2066.873291015625,
        1893.510986328125,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826812207698822,
        -0.9238805770874023,
        0.0
      ],
      "plane_d": 956.8157958984375,
      "bbox_min": [
        2065.68994140625,
        1891.2796630859375,
        373.2529602050781
      ],
      "bbox_max": [
        2066.873291015625,
        1891.769775390625,
        373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38269656896591187,
        -0.9238741993904114,
        0.0
      ],
      "plane_d": 958.6049194335938,
      "bbox_min": [
        2064.287109375,
        1892.6824951171875,
        372.5
      ],
      "bbox_max": [
        2066.287109375,
        1893.510986328125,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 30.0,
      "bbox_min": [
        1999.697998046875,
        1921.916259765625,
        372.5
      ],
      "bbox_max": [
        2036.467529296875,
        1958.685791015625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071051001548767,
        0.7071084976196289,
        0.0
      ],
      "plane_d": 77.9932861328125,
      "bbox_min": [
        1989.951171875,
        1895.046142578125,
        372.5
      ],
      "bbox_max": [
        2033.63916015625,
        1957.2716064453125,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2760.000244140625,
      "bbox_min": [
        2006.7689208984375,
        1895.046142578125,
        372.5
      ],
      "bbox_max": [
        2008.1832275390625,
        1896.46044921875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -32.0,
      "bbox_min": [
        1989.951171875,
        1896.46044921875,
        372.5
      ],
      "bbox_max": [
        2021.7950439453125,
        1957.2716064453125,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 30.0,
      "bbox_min": [
        1989.951171875,
        1947.5247802734375,
        372.5
      ],
      "bbox_max": [
        1999.697998046875,
        1957.2716064453125,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3637884259223938,
        0.748203456401825,
        0.5548419952392578
      ],
      "plane_d": -2387.54150390625,
      "bbox_min": [
        1993.1810302734375,
        1896.46044921875,
        372.5
      ],
      "bbox_max": [
        2021.7950439453125,
        1941.39697265625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5045856833457947,
        0.35952863097190857,
        0.7849410772323608
      ],
      "plane_d": -2004.36962890625,
      "bbox_min": [
        1993.1810302734375,
        1896.46044921875,
        372.5
      ],
      "bbox_max": [
        2021.7950439453125,
        1941.39697265625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3670535981655121,
        -0.42233195900917053,
        0.828798770904541
      ],
      "plane_d": 1234.16455078125,
      "bbox_min": [
        1993.1810302734375,
        1896.46044921875,
        372.5
      ],
      "bbox_max": [
        2021.7950439453125,
        1941.39697265625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35740771889686584,
        0.6073290109634399,
        0.7095147967338562
      ],
      "plane_d": -2159.60791015625,
      "bbox_min": [
        1993.1810302734375,
        1909.9306640625,
        372.5
      ],
      "bbox_max": [
        2021.7950439453125,
        1941.39697265625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5137051939964294,
        -0.31225311756134033,
        0.7991275191307068
      ],
      "plane_d": -735.439697265625,
      "bbox_min": [
        1993.1810302734375,
        1915.19873046875,
        372.5
      ],
      "bbox_max": [
        2021.7950439453125,
        1941.39697265625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3783653676509857,
        0.7669463157653809,
        0.5182982683181763
      ],
      "plane_d": -924.5274047851562,
      "bbox_min": [
        1993.1810302734375,
        1932.3311767578125,
        372.5
      ],
      "bbox_max": [
        2003.12744140625,
        1941.39697265625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21750731766223907,
        0.6525018215179443,
        0.7259007096290588
      ],
      "plane_d": -1101.71435546875,
      "bbox_min": [
        1993.1810302734375,
        1932.3311767578125,
        372.5
      ],
      "bbox_max": [
        2003.12744140625,
        1941.39697265625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8233370780944824,
        0.2744414806365967,
        0.4967876970767975
      ],
      "plane_d": 924.9917602539062,
      "bbox_min": [
        1993.1810302734375,
        1932.3311767578125,
        372.5
      ],
      "bbox_max": [
        1995.1724853515625,
        1937.4725341796875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.83591228723526,
        -0.2786460220813751,
        0.47287097573280334
      ],
      "plane_d": -1327.9442138671875,
      "bbox_min": [
        2015.2542724609375,
        1915.19873046875,
        372.5
      ],
      "bbox_max": [
        2017.906005859375,
        1924.21435546875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3097217381000519,
        -0.6131924986839294,
        0.7266825437545776
      ],
      "plane_d": 279.1996765136719,
      "bbox_min": [
        2005.8851318359375,
        1909.9306640625,
        372.5
      ],
      "bbox_max": [
        2016.31494140625,
        1915.19873046875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4231410324573517,
        -0.6649239659309387,
        0.6154899597167969
      ],
      "plane_d": 1890.965576171875,
      "bbox_min": [
        1996.6297607421875,
        1896.46044921875,
        372.5
      ],
      "bbox_max": [
        2008.1832275390625,
        1921.404052734375,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6814059615135193,
        -0.40099161863327026,
        0.6122840046882629
      ],
      "plane_d": 1901.3759765625,
      "bbox_min": [
        1996.6297607421875,
        1919.3685302734375,
        374.2461242675781
      ],
      "bbox_max": [
        1997.57666015625,
        1921.404052734375,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2762.000244140625,
      "bbox_min": [
        2000.743408203125,
        1896.46044921875,
        372.5
      ],
      "bbox_max": [
        2008.1832275390625,
        1905.314453125,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2760.000244140625,
      "bbox_min": [
        2001.715087890625,
        1896.46044921875,
        372.5
      ],
      "bbox_max": [
        2006.7689208984375,
        1901.5142822265625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.592004656791687,
        0.3767370283603668,
        0.7124602198600769
      ],
      "plane_d": -2186.705078125,
      "bbox_min": [
        2010.4443359375,
        1924.21435546875,
        372.5
      ],
      "bbox_max": [
        2017.906005859375,
        1935.775634765625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35740771889686584,
        0.6073290109634399,
        0.7095147967338562
      ],
      "plane_d": -2159.60791015625,
      "bbox_min": [
        2010.4443359375,
        1933.93701171875,
        372.5
      ],
      "bbox_max": [
        2013.557373046875,
        1935.775634765625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 118.0001220703125,
      "bbox_min": [
        2012.35205078125,
        1846.0794677734375,
        372.5
      ],
      "bbox_max": [
        2065.68994140625,
        1894.16748046875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071037888526917,
        -0.7071098685264587,
        0.0
      ],
      "plane_d": -120.088134765625,
      "bbox_min": [
        2015.9613037109375,
        1846.0794677734375,
        372.5
      ],
      "bbox_max": [
        2065.68994140625,
        1894.16748046875,
        375.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826870620250702,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -960.5721435546875,
      "bbox_min": [
        2059.802001953125,
        1892.9248046875,
        372.5
      ],
      "bbox_max": [
        2062.802001953125,
        1894.16748046875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486849308013916,
        0.3162228763103485,
        -0.0
      ],
      "plane_d": -2497.23486328125,
      "bbox_min": [
        2015.9613037109375,
        1846.85693359375,
        372.5
      ],
      "bbox_max": [
        2016.7037353515625,
        1849.0841064453125,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 373.0,
      "bbox_min": [
        2016.7037353515625,
        1846.0794677734375,
        372.5
      ],
      "bbox_max": [
        2065.68994140625,
        1892.6824951171875,
        375.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -122.0841064453125,
      "bbox_min": [
        2016.7037353515625,
        1846.0794677734375,
        373.0
      ],
      "bbox_max": [
        2065.68994140625,
        1892.6824951171875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17280015349388123,
        -0.17280015349388123,
        0.9696804881095886
      ],
      "plane_d": -392.0101013183594,
      "bbox_min": [
        2016.7037353515625,
        1846.0794677734375,
        373.0
      ],
      "bbox_max": [
        2064.811279296875,
        1892.6824951171875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238780736923218,
        0.3826870620250702,
        0.0
      ],
      "plane_d": 1170.95458984375,
      "bbox_min": [
        2016.7037353515625,
        1846.0794677734375,
        373.0
      ],
      "bbox_max": [
        2043.5599365234375,
        1873.712890625,
        374.00006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238780736923218,
        -0.3826870620250702,
        0.0
      ],
      "plane_d": 2603.51416015625,
      "bbox_min": [
        2042.73095703125,
        1870.556396484375,
        373.0
      ],
      "bbox_max": [
        2043.20947265625,
        1871.711669921875,
        373.7911071777344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486849308013916,
        0.3162228763103485,
        -0.0
      ],
      "plane_d": -2497.23486328125,
      "bbox_min": [
        2016.7037353515625,
        1846.0794677734375,
        373.0
      ],
      "bbox_max": [
        2016.962890625,
        1846.85693359375,
        374.00006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238812923431396,
        -0.382679283618927,
        0.0
      ],
      "plane_d": -1172.9158935546875,
      "bbox_min": [
        2016.7037353515625,
        1846.0794677734375,
        373.49993896484375
      ],
      "bbox_max": [
        2064.811279296875,
        1892.6824951171875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486849308013916,
        0.3162228763103485,
        -0.0
      ],
      "plane_d": -2497.23486328125,
      "bbox_min": [
        2016.7037353515625,
        1846.0794677734375,
        373.8153076171875
      ],
      "bbox_max": [
        2016.962890625,
        1846.85693359375,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2431306689977646,
        -0.10070673376321793,
        0.9647516012191772
      ],
      "plane_d": -669.4842529296875,
      "bbox_min": [
        2045.1610107421875,
        1872.508056640625,
        373.5
      ],
      "bbox_max": [
        2064.811279296875,
        1892.6824951171875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38269656896591187,
        -0.9238741993904114,
        0.0
      ],
      "plane_d": 958.6049194335938,
      "bbox_min": [
        2061.287109375,
        1891.4398193359375,
        374.0
      ],
      "bbox_max": [
        2064.287109375,
        1892.6824951171875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071144580841064,
        -0.707099199295044,
        -0.0
      ],
      "plane_d": 2765.00146484375,
      "bbox_min": [
        2043.20947265625,
        1858.9837646484375,
        373.0
      ],
      "bbox_max": [
        2065.68994140625,
        1892.1583251953125,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238780736923218,
        -0.3826870620250702,
        0.0
      ],
      "plane_d": 2603.51416015625,
      "bbox_min": [
        2043.20947265625,
        1860.46875,
        373.0
      ],
      "bbox_max": [
        2065.68994140625,
        1892.1583251953125,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238753318786621,
        0.3826935589313507,
        0.0
      ],
      "plane_d": -2605.4609375,
      "bbox_min": [
        2044.8310546875,
        1860.46875,
        373.0
      ],
      "bbox_max": [
        2065.68994140625,
        1892.1583251953125,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2769.083984375,
      "bbox_min": [
        2044.8310546875,
        1860.46875,
        373.0
      ],
      "bbox_max": [
        2065.68994140625,
        1892.1583251953125,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1728072166442871,
        0.1728072166442871,
        0.9696779847145081
      ],
      "plane_d": -1038.90087890625,
      "bbox_min": [
        2045.1611328125,
        1860.46875,
        373.5
      ],
      "bbox_max": [
        2054.20458984375,
        1870.9146728515625,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24314559996128082,
        0.10071732848882675,
        0.9647466540336609
      ],
      "plane_d": -1046.520751953125,
      "bbox_min": [
        2045.1611328125,
        1866.1256103515625,
        373.5
      ],
      "bbox_max": [
        2048.5478515625,
        1870.9146728515625,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10070779919624329,
        -0.24313180148601532,
        0.9647512435913086
      ],
      "plane_d": -108.53544616699219,
      "bbox_min": [
        2062.68994140625,
        1890.0369873046875,
        373.5
      ],
      "bbox_max": [
        2065.68994140625,
        1892.1583251953125,
        373.81317138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238812923431396,
        -0.382679283618927,
        0.0
      ],
      "plane_d": -1172.9158935546875,
      "bbox_min": [
        2044.8310546875,
        1867.5283203125,
        373.0
      ],
      "bbox_max": [
        2048.5478515625,
        1875.8948974609375,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2431306689977646,
        -0.10070673376321793,
        0.9647516012191772
      ],
      "plane_d": -669.4842529296875,
      "bbox_min": [
        2044.8310546875,
        1867.5283203125,
        373.0
      ],
      "bbox_max": [
        2048.5478515625,
        1875.8948974609375,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238670468330383,
        0.3827137351036072,
        0.0
      ],
      "plane_d": -2607.314453125,
      "bbox_min": [
        2046.81494140625,
        1867.5283203125,
        373.0
      ],
      "bbox_max": [
        2048.5478515625,
        1871.7115478515625,
        373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2767.100341796875,
      "bbox_min": [
        2042.73095703125,
        1860.46875,
        372.5
      ],
      "bbox_max": [
        2064.287109375,
        1892.6824951171875,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238812923431396,
        -0.382679283618927,
        0.0
      ],
      "plane_d": -1172.9158935546875,
      "bbox_min": [
        2042.73095703125,
        1866.1256103515625,
        372.5
      ],
      "bbox_max": [
        2064.287109375,
        1892.6824951171875,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238780736923218,
        0.3826870620250702,
        0.0
      ],
      "plane_d": 1170.95458984375,
      "bbox_min": [
        2042.73095703125,
        1871.711669921875,
        372.5
      ],
      "bbox_max": [
        2043.5599365234375,
        1873.712890625,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238753318786621,
        0.3826935589313507,
        0.0
      ],
      "plane_d": -2605.4609375,
      "bbox_min": [
        2044.8310546875,
        1866.1256103515625,
        372.5
      ],
      "bbox_max": [
        2064.287109375,
        1892.6824951171875,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38269656896591187,
        -0.9238741993904114,
        0.0
      ],
      "plane_d": 958.6049194335938,
      "bbox_min": [
        2061.287109375,
        1891.4398193359375,
        372.5
      ],
      "bbox_max": [
        2064.287109375,
        1892.6824951171875,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        2024.4466552734375,
        1878.0755615234375,
        372.5
      ],
      "bbox_max": [
        2040.0030517578125,
        1893.6319580078125,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2765.0,
      "bbox_min": [
        2024.4466552734375,
        1878.0755615234375,
        372.5
      ],
      "bbox_max": [
        2040.0030517578125,
        1893.6319580078125,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -109.0001220703125,
      "bbox_min": [
        2024.4466552734375,
        1878.0755615234375,
        372.5
      ],
      "bbox_max": [
        2040.0030517578125,
        1893.6319580078125,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2776.000244140625,
      "bbox_min": [
        2024.4466552734375,
        1878.0755615234375,
        372.5
      ],
      "bbox_max": [
        2040.0030517578125,
        1893.6319580078125,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -372.9999694824219,
      "bbox_min": [
        2024.4466552734375,
        1878.0755615234375,
        373.0
      ],
      "bbox_max": [
        2040.0030517578125,
        1893.6319580078125,
        375.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 101.0,
      "bbox_min": [
        2028.6893310546875,
        1882.3182373046875,
        373.0
      ],
      "bbox_max": [
        2035.7603759765625,
        1889.3892822265625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2768.000244140625,
      "bbox_min": [
        2028.6893310546875,
        1882.3182373046875,
        373.0
      ],
      "bbox_max": [
        2035.7603759765625,
        1889.3892822265625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2773.000244140625,
      "bbox_min": [
        2032.224853515625,
        1882.3182373046875,
        373.0
      ],
      "bbox_max": [
        2035.7603759765625,
        1889.3892822265625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -106.0,
      "bbox_min": [
        2032.224853515625,
        1882.3182373046875,
        373.0
      ],
      "bbox_max": [
        2035.7603759765625,
        1885.853759765625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1361461579799652,
        0.9906888008117676,
        0.0
      ],
      "plane_d": -1554.28857421875,
      "bbox_min": [
        1993.8358154296875,
        1846.0794677734375,
        375.0
      ],
      "bbox_max": [
        2041.829833984375,
        1938.992919921875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486849308013916,
        0.3162228763103485,
        -0.0
      ],
      "plane_d": -2497.23486328125,
      "bbox_min": [
        1993.8358154296875,
        1846.0794677734375,
        375.0
      ],
      "bbox_max": [
        2035.7603759765625,
        1938.992919921875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9480223059654236,
        -0.31601718068122864,
        -0.03724071383476257
      ],
      "plane_d": -1290.9697265625,
      "bbox_min": [
        1993.8358154296875,
        1882.3182373046875,
        375.0
      ],
      "bbox_max": [
        2035.7603759765625,
        1938.992919921875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8369823098182678,
        0.5326346755027771,
        0.1255428045988083
      ],
      "plane_d": -2760.933349609375,
      "bbox_min": [
        1993.8358154296875,
        1910.6024169921875,
        375.0
      ],
      "bbox_max": [
        2018.2005615234375,
        1938.992919921875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6974859237670898,
        0.6974859237670898,
        0.16439847648143768
      ],
      "plane_d": -2813.688720703125,
      "bbox_min": [
        1993.8358154296875,
        1910.6024169921875,
        375.0
      ],
      "bbox_max": [
        2017.316650390625,
        1938.992919921875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9246753454208374,
        -0.3807566165924072,
        0.0
      ],
      "plane_d": -1133.8275146484375,
      "bbox_min": [
        1993.8358154296875,
        1910.6024169921875,
        375.0
      ],
      "bbox_max": [
        2017.316650390625,
        1938.992919921875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3069612383842468,
        0.9208554029464722,
        0.24041666090488434
      ],
      "plane_d": -1260.805908203125,
      "bbox_min": [
        1993.8358154296875,
        1910.6024169921875,
        375.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1938.992919921875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8867204189300537,
        0.3890087604522705,
        0.24979832768440247
      ],
      "plane_d": 922.2320556640625,
      "bbox_min": [
        1993.8358154296875,
        1910.6024169921875,
        375.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1936.3411865234375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5239430665969849,
        -0.8233242630958557,
        0.2182219922542572
      ],
      "plane_d": 2545.39697265625,
      "bbox_min": [
        1993.8358154296875,
        1910.6024169921875,
        375.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1936.3411865234375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33213669061660767,
        -0.9432312250137329,
        0.0
      ],
      "plane_d": 1138.1357421875,
      "bbox_min": [
        1993.8358154296875,
        1913.607666015625,
        375.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1936.3411865234375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9393597841262817,
        0.3131151497364044,
        0.1398642510175705
      ],
      "plane_d": 1215.43798828125,
      "bbox_min": [
        1993.8358154296875,
        1919.794921875,
        375.0
      ],
      "bbox_max": [
        1997.57666015625,
        1936.3411865234375,
        378.9796447753906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8611680269241333,
        -0.5067774653434753,
        0.039574895054101944
      ],
      "plane_d": 2678.3173828125,
      "bbox_min": [
        1996.5723876953125,
        1919.794921875,
        375.0
      ],
      "bbox_max": [
        1997.57666015625,
        1921.628173828125,
        376.6238708496094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22026322782039642,
        -0.35666319727897644,
        -0.9078961610794067
      ],
      "plane_d": 1473.30615234375,
      "bbox_min": [
        1995.7393798828125,
        1920.7672119140625,
        382.4029846191406
      ],
      "bbox_max": [
        1999.432861328125,
        1924.885986328125,
        383.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6735929846763611,
        -0.7391019463539124,
        -0.0008805884863249958
      ],
      "plane_d": 2766.7841796875,
      "bbox_min": [
        1996.2811279296875,
        1910.6024169921875,
        375.0
      ],
      "bbox_max": [
        2010.1318359375,
        1922.7672119140625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29355043172836304,
        -0.954705536365509,
        0.04863692820072174
      ],
      "plane_d": 1218.916259765625,
      "bbox_min": [
        2007.29931640625,
        1913.465576171875,
        375.0
      ],
      "bbox_max": [
        2010.1318359375,
        1914.45556640625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3161897659301758,
        -0.9485400915145874,
        -0.017200971022248268
      ],
      "plane_d": 1186.896484375,
      "bbox_min": [
        2007.29931640625,
        1913.4971923828125,
        375.0
      ],
      "bbox_max": [
        2010.1318359375,
        1914.45556640625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33213669061660767,
        -0.9432312250137329,
        0.0
      ],
      "plane_d": 1138.1357421875,
      "bbox_min": [
        2007.409912109375,
        1913.4971923828125,
        381.32623291015625
      ],
      "bbox_max": [
        2010.1318359375,
        1914.45556640625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5626384019851685,
        -0.8263674378395081,
        -0.023555507883429527
      ],
      "plane_d": 460.8305969238281,
      "bbox_min": [
        2007.409912109375,
        1913.465576171875,
        383.125
      ],
      "bbox_max": [
        2007.808837890625,
        1913.71533203125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.660870373249054,
        -0.732067346572876,
        0.1653110682964325
      ],
      "plane_d": 2659.171142578125,
      "bbox_min": [
        1996.2811279296875,
        1910.6024169921875,
        383.1039123535156
      ],
      "bbox_max": [
        2007.4420166015625,
        1922.7672119140625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5866062045097351,
        -0.80986487865448,
        -0.0034851343370974064
      ],
      "plane_d": 373.4503479003906,
      "bbox_min": [
        1996.4993896484375,
        1910.6024169921875,
        383.125
      ],
      "bbox_max": [
        2007.4420166015625,
        1921.9136962890625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1683286428451538,
        -0.14894074201583862,
        -0.9744137525558472
      ],
      "plane_d": 995.964599609375,
      "bbox_min": [
        1996.4993896484375,
        1910.6024169921875,
        383.125
      ],
      "bbox_max": [
        2003.6923828125,
        1921.9136962890625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5385398268699646,
        -0.7492015957832336,
        0.3855798542499542
      ],
      "plane_d": 2362.191650390625,
      "bbox_min": [
        2002.230712890625,
        1910.6024169921875,
        384.2426452636719
      ],
      "bbox_max": [
        2003.6923828125,
        1911.84716796875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22026322782039642,
        -0.35666319727897644,
        -0.9078961610794067
      ],
      "plane_d": 1473.30615234375,
      "bbox_min": [
        1996.4993896484375,
        1920.7672119140625,
        383.125
      ],
      "bbox_max": [
        1999.432861328125,
        1921.9136962890625,
        383.4908752441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5626384019851685,
        -0.8263674378395081,
        -0.023555507883429527
      ],
      "plane_d": 460.8305969238281,
      "bbox_min": [
        2006.365966796875,
        1912.7330322265625,
        383.125
      ],
      "bbox_max": [
        2007.4420166015625,
        1913.4971923828125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14978842437267303,
        -0.16592545807361603,
        -0.9746959805488586
      ],
      "plane_d": 991.62646484375,
      "bbox_min": [
        1996.2811279296875,
        1910.6024169921875,
        383.1039123535156
      ],
      "bbox_max": [
        2003.4200439453125,
        1922.7672119140625,
        384.2426452636719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22026322782039642,
        -0.35666319727897644,
        -0.9078961610794067
      ],
      "plane_d": 1473.30615234375,
      "bbox_min": [
        1996.4921875,
        1918.5048828125,
        383.125
      ],
      "bbox_max": [
        1999.432861328125,
        1921.94189453125,
        383.8269958496094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1683286428451538,
        -0.14894074201583862,
        -0.9744137525558472
      ],
      "plane_d": 995.964599609375,
      "bbox_min": [
        1997.2950439453125,
        1918.5048828125,
        383.125
      ],
      "bbox_max": [
        1999.432861328125,
        1920.7672119140625,
        383.8269958496094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22026322782039642,
        -0.35666319727897644,
        -0.9078961610794067
      ],
      "plane_d": 1473.30615234375,
      "bbox_min": [
        1996.2811279296875,
        1920.7672119140625,
        383.1039123535156
      ],
      "bbox_max": [
        1999.432861328125,
        1922.7672119140625,
        383.376953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9016419649124146,
        0.4288327395915985,
        0.056074608117341995
      ],
      "plane_d": 949.1978759765625,
      "bbox_min": [
        1994.439697265625,
        1929.7418212890625,
        382.32122802734375
      ],
      "bbox_max": [
        1996.763427734375,
        1934.750244140625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9552825093269348,
        0.23633833229541779,
        -0.17770637571811676
      ],
      "plane_d": 1518.30126953125,
      "bbox_min": [
        1995.9100341796875,
        1932.7108154296875,
        383.125
      ],
      "bbox_max": [
        1996.763427734375,
        1934.750244140625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.460689902305603,
        0.8819450736045837,
        0.09968864917755127
      ],
      "plane_d": -824.6478881835938,
      "bbox_min": [
        1996.251220703125,
        1934.090087890625,
        375.0
      ],
      "bbox_max": [
        2003.869873046875,
        1938.992919921875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9552825093269348,
        0.23633833229541779,
        -0.17770637571811676
      ],
      "plane_d": 1518.30126953125,
      "bbox_min": [
        1996.251220703125,
        1934.090087890625,
        383.125
      ],
      "bbox_max": [
        1996.763427734375,
        1934.750244140625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23633833229541779,
        0.9552825093269348,
        -0.17770637571811676
      ],
      "plane_d": -1308.237548828125,
      "bbox_min": [
        1996.302490234375,
        1934.2974853515625,
        383.125
      ],
      "bbox_max": [
        1998.802734375,
        1935.6036376953125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9552825093269348,
        0.23633833229541779,
        -0.17770637571811676
      ],
      "plane_d": 1518.30126953125,
      "bbox_min": [
        1996.302490234375,
        1934.2974853515625,
        383.125
      ],
      "bbox_max": [
        1996.763427734375,
        1935.0299072265625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071067094802856,
        5.753044661105378e-06
      ],
      "plane_d": -2787.502197265625,
      "bbox_min": [
        2013.7811279296875,
        1923.919677734375,
        375.0
      ],
      "bbox_max": [
        2018.2005615234375,
        1928.339111328125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 101.0,
      "bbox_min": [
        2028.6893310546875,
        1882.3182373046875,
        375.0
      ],
      "bbox_max": [
        2035.7603759765625,
        1889.3892822265625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2768.000244140625,
      "bbox_min": [
        2028.6893310546875,
        1882.3182373046875,
        375.0
      ],
      "bbox_max": [
        2035.7603759765625,
        1889.3892822265625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2773.000244140625,
      "bbox_min": [
        2032.224853515625,
        1882.3182373046875,
        375.0
      ],
      "bbox_max": [
        2035.7603759765625,
        1889.3892822265625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -106.0,
      "bbox_min": [
        2032.224853515625,
        1882.3182373046875,
        375.0
      ],
      "bbox_max": [
        2035.7603759765625,
        1885.853759765625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071047425270081,
        0.7071087956428528,
        0.0
      ],
      "plane_d": 110.14599609375,
      "bbox_min": [
        1974.996337890625,
        1884.3802490234375,
        372.5
      ],
      "bbox_max": [
        2096.6806640625,
        2019.60595703125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2815.000244140625,
      "bbox_min": [
        2064.802001953125,
        1884.3802490234375,
        372.5
      ],
      "bbox_max": [
        2086.672119140625,
        1912.614990234375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -375.0,
      "bbox_min": [
        2064.802001953125,
        1884.3802490234375,
        372.5
      ],
      "bbox_max": [
        2079.60107421875,
        1895.853759765625,
        375.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2805.0,
      "bbox_min": [
        2064.802001953125,
        1884.3802490234375,
        372.5
      ],
      "bbox_max": [
        2079.60107421875,
        1895.853759765625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826734721660614,
        0.9238837361335754,
        0.0
      ],
      "plane_d": -2542.48583984375,
      "bbox_min": [
        2064.802001953125,
        1884.3802490234375,
        372.5
      ],
      "bbox_max": [
        2078.115966796875,
        1895.853759765625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2802.900146484375,
      "bbox_min": [
        2064.802001953125,
        1884.3802490234375,
        372.5
      ],
      "bbox_max": [
        2078.115966796875,
        1895.853759765625,
        375.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3827107846736908,
        -0.9238681793212891,
        0.0
      ],
      "plane_d": 2540.593505859375,
      "bbox_min": [
        2064.802001953125,
        1884.3802490234375,
        372.5
      ],
      "bbox_max": [
        2078.115966796875,
        1895.853759765625,
        375.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826870620250702,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -960.5721435546875,
      "bbox_min": [
        2064.802001953125,
        1894.9959716796875,
        372.5
      ],
      "bbox_max": [
        2066.873046875,
        1895.853759765625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 373.0,
      "bbox_min": [
        2066.287109375,
        1884.3802490234375,
        372.5
      ],
      "bbox_max": [
        2078.115966796875,
        1893.7537841796875,
        375.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.1728072166442871,
        -0.1728072166442871,
        0.9696779847145081
      ],
      "plane_d": 322.3307800292969,
      "bbox_min": [
        2066.287109375,
        1884.3802490234375,
        373.0
      ],
      "bbox_max": [
        2078.115966796875,
        1893.7537841796875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2800.916015625,
      "bbox_min": [
        2068.84521484375,
        1884.3802490234375,
        373.0
      ],
      "bbox_max": [
        2076.713134765625,
        1890.9530029296875,
        373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38270023465156555,
        -0.9238725900650024,
        0.0
      ],
      "plane_d": 2538.7470703125,
      "bbox_min": [
        2068.84521484375,
        1890.0369873046875,
        373.0
      ],
      "bbox_max": [
        2071.056396484375,
        1890.9530029296875,
        373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10071714222431183,
        -0.24314017593860626,
        0.9647481441497803
      ],
      "plane_d": 307.8013916015625,
      "bbox_min": [
        2066.287109375,
        1890.0369873046875,
        373.2692565917969
      ],
      "bbox_max": [
        2072.459228515625,
        1893.7537841796875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38270023465156555,
        -0.9238725900650024,
        0.0
      ],
      "plane_d": 2538.7470703125,
      "bbox_min": [
        2068.84521484375,
        1890.0369873046875,
        373.2692565917969
      ],
      "bbox_max": [
        2071.056396484375,
        1890.9530029296875,
        373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38269656896591187,
        -0.9238741993904114,
        0.0
      ],
      "plane_d": 958.6049194335938,
      "bbox_min": [
        2066.287109375,
        1892.9248046875,
        373.79107666015625
      ],
      "bbox_max": [
        2066.873291015625,
        1893.7537841796875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10070779919624329,
        -0.24313180148601532,
        0.9647512435913086
      ],
      "plane_d": -108.53544616699219,
      "bbox_min": [
        2066.287109375,
        1892.9248046875,
        373.79107666015625
      ],
      "bbox_max": [
        2066.873291015625,
        1893.7537841796875,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38269656896591187,
        -0.9238741993904114,
        0.0
      ],
      "plane_d": 958.6049194335938,
      "bbox_min": [
        2066.287109375,
        1893.510986328125,
        372.5
      ],
      "bbox_max": [
        2066.873291015625,
        1893.7537841796875,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2815.0,
      "bbox_min": [
        1974.996337890625,
        1991.3216552734375,
        372.5
      ],
      "bbox_max": [
        1989.689453125,
        2006.0147705078125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067094802856,
        -0.7071067094802856,
        0.0
      ],
      "plane_d": -49.0,
      "bbox_min": [
        1989.689453125,
        1912.614990234375,
        372.5
      ],
      "bbox_max": [
        2075.46728515625,
        1998.3927001953125,
        385.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067094802856,
        0.7071067094802856,
        0.0
      ],
      "plane_d": 40.0,
      "bbox_min": [
        1989.689453125,
        1962.928466796875,
        372.5
      ],
      "bbox_max": [
        2053.438232421875,
        1998.3927001953125,
        385.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.3483176529407501,
        -0.3483176529407501,
        0.8702583312988281
      ],
      "plane_d": 1071.3109130859375,
      "bbox_min": [
        2025.8609619140625,
        1962.928466796875,
        372.5
      ],
      "bbox_max": [
        2053.438232421875,
        1990.5057373046875,
        385.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071189880371094,
        -0.7070945501327515,
        -3.0492372388835065e-05
      ],
      "plane_d": -48.03766632080078,
      "bbox_min": [
        2032.166015625,
        1969.2333984375,
        372.5
      ],
      "bbox_max": [
        2052.731201171875,
        1989.7987060546875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071090936660767,
        0.7071044445037842,
        0.0
      ],
      "plane_d": 41.0093994140625,
      "bbox_min": [
        2032.166015625,
        1972.6865234375,
        372.5
      ],
      "bbox_max": [
        2052.731201171875,
        1989.7987060546875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3554038107395172,
        0.3554038107395172,
        -0.8645093441009521
      ],
      "plane_d": -1104.296630859375,
      "bbox_min": [
        2035.6190185546875,
        1972.6865234375,
        372.5
      ],
      "bbox_max": [
        2052.731201171875,
        1989.7987060546875,
        382.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067094802856,
        0.7071067094802856,
        0.0
      ],
      "plane_d": 48.0,
      "bbox_min": [
        2025.8609619140625,
        1962.928466796875,
        372.5
      ],
      "bbox_max": [
        2052.731201171875,
        1989.7987060546875,
        385.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -373.5,
      "bbox_min": [
        2031.517822265625,
        1962.928466796875,
        372.5
      ],
      "bbox_max": [
        2034.69970703125,
        1966.1103515625,
        373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31623297929763794,
        -0.31623297929763794,
        0.8944236040115356
      ],
      "plane_d": 929.7791748046875,
      "bbox_min": [
        2031.517822265625,
        1962.928466796875,
        372.5
      ],
      "bbox_max": [
        2032.9320068359375,
        1964.3426513671875,
        373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2825.000244140625,
      "bbox_min": [
        2031.517822265625,
        1962.928466796875,
        372.5
      ],
      "bbox_max": [
        2032.224853515625,
        1963.635498046875,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071090936660767,
        -0.7071044445037842,
        0.0
      ],
      "plane_d": -41.0093994140625,
      "bbox_min": [
        2025.8609619140625,
        1968.5853271484375,
        372.5
      ],
      "bbox_max": [
        2047.7813720703125,
        1989.7987060546875,
        385.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -373.5,
      "bbox_min": [
        2025.8609619140625,
        1968.5853271484375,
        372.5
      ],
      "bbox_max": [
        2029.04296875,
        1971.7672119140625,
        373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31623297929763794,
        -0.31623297929763794,
        0.8944236040115356
      ],
      "plane_d": 929.7791748046875,
      "bbox_min": [
        2025.8609619140625,
        1968.5853271484375,
        372.5
      ],
      "bbox_max": [
        2027.275146484375,
        1969.99951171875,
        373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2825.000244140625,
      "bbox_min": [
        2025.8609619140625,
        1968.5853271484375,
        372.5
      ],
      "bbox_max": [
        2026.5679931640625,
        1969.2923583984375,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2830.000244140625,
      "bbox_min": [
        1989.689453125,
        1973.5350341796875,
        372.5
      ],
      "bbox_max": [
        2018.082763671875,
        1998.3927001953125,
        385.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2815.000244140625,
      "bbox_min": [
        1989.689453125,
        1973.5350341796875,
        372.5
      ],
      "bbox_max": [
        2018.082763671875,
        1998.3927001953125,
        385.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -382.0,
      "bbox_min": [
        1996.7606201171875,
        1973.5350341796875,
        372.5
      ],
      "bbox_max": [
        2018.082763671875,
        1998.3927001953125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -24.0,
      "bbox_min": [
        1996.7606201171875,
        1973.5350341796875,
        372.5
      ],
      "bbox_max": [
        2018.082763671875,
        1998.3927001953125,
        382.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -8.845947265625,
      "bbox_min": [
        1996.7606201171875,
        1984.2506103515625,
        372.5
      ],
      "bbox_max": [
        2007.3671875,
        1998.3927001953125,
        382.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2825.000244140625,
      "bbox_min": [
        1996.7606201171875,
        1991.3216552734375,
        372.5
      ],
      "bbox_max": [
        2003.8316650390625,
        1998.3927001953125,
        382.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2825.000244140625,
      "bbox_min": [
        1996.7606201171875,
        1976.3634033203125,
        382.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1998.3927001953125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -8.845947265625,
      "bbox_min": [
        1996.7606201171875,
        1976.3634033203125,
        382.0
      ],
      "bbox_max": [
        2008.890380859375,
        1991.3216552734375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        0.7071372866630554,
        0.0
      ],
      "plane_d": 19.87841796875,
      "bbox_min": [
        1999.697998046875,
        1976.3634033203125,
        382.0
      ],
      "bbox_max": [
        2008.890380859375,
        1985.5557861328125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2817.0,
      "bbox_min": [
        2006.0618896484375,
        1976.3634033203125,
        382.0
      ],
      "bbox_max": [
        2008.890380859375,
        1979.19189453125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071372866630554,
        -0.7070762515068054,
        0.0
      ],
      "plane_d": -22.1217041015625,
      "bbox_min": [
        2007.4761962890625,
        1976.3634033203125,
        382.0
      ],
      "bbox_max": [
        2008.890380859375,
        1979.19189453125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2819.000244140625,
      "bbox_min": [
        2007.4761962890625,
        1977.7777099609375,
        382.0
      ],
      "bbox_max": [
        2008.890380859375,
        1979.19189453125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2817.000244140625,
      "bbox_min": [
        1999.697998046875,
        1982.7274169921875,
        382.0
      ],
      "bbox_max": [
        2002.5263671875,
        1985.5557861328125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -13.0,
      "bbox_min": [
        1999.697998046875,
        1982.7274169921875,
        382.0
      ],
      "bbox_max": [
        2002.5263671875,
        1985.5557861328125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 11.0,
      "bbox_min": [
        1999.697998046875,
        1984.1416015625,
        382.0
      ],
      "bbox_max": [
        2002.5263671875,
        1985.5557861328125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2819.000244140625,
      "bbox_min": [
        2001.1121826171875,
        1984.1416015625,
        382.0
      ],
      "bbox_max": [
        2002.5263671875,
        1985.5557861328125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -13.0,
      "bbox_min": [
        2006.0618896484375,
        1982.7274169921875,
        382.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1991.9197998046875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        -0.7071372866630554,
        0.0
      ],
      "plane_d": 2825.99951171875,
      "bbox_min": [
        2006.0618896484375,
        1989.0914306640625,
        382.0
      ],
      "bbox_max": [
        2008.890380859375,
        1991.9197998046875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        0.7071372866630554,
        0.0
      ],
      "plane_d": 10.8779296875,
      "bbox_min": [
        2006.0618896484375,
        1990.505615234375,
        382.0
      ],
      "bbox_max": [
        2008.890380859375,
        1991.9197998046875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2828.000244140625,
      "bbox_min": [
        2007.4761962890625,
        1990.505615234375,
        382.0
      ],
      "bbox_max": [
        2008.890380859375,
        1991.9197998046875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2826.000244140625,
      "bbox_min": [
        2012.4259033203125,
        1982.7274169921875,
        382.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1985.5557861328125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -22.0,
      "bbox_min": [
        2012.4259033203125,
        1982.7274169921875,
        382.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1985.5557861328125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 20.0,
      "bbox_min": [
        2012.4259033203125,
        1984.1416015625,
        382.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1985.5557861328125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2828.0,
      "bbox_min": [
        2013.840087890625,
        1984.1416015625,
        382.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1985.5557861328125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -19.0,
      "bbox_min": [
        2011.01171875,
        1987.6771240234375,
        372.5
      ],
      "bbox_max": [
        2018.082763671875,
        1994.7481689453125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 14.0001220703125,
      "bbox_min": [
        2011.01171875,
        1991.212646484375,
        372.5
      ],
      "bbox_max": [
        2018.082763671875,
        1994.7481689453125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2835.0,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        372.5
      ],
      "bbox_max": [
        2018.082763671875,
        1994.7481689453125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067094802856,
        -0.7071067094802856,
        0.0
      ],
      "plane_d": -68.0,
      "bbox_min": [
        2039.2958984375,
        1912.614990234375,
        372.5
      ],
      "bbox_max": [
        2075.46728515625,
        1977.0706787109375,
        385.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.34831249713897705,
        -0.3483211100101471,
        0.8702591061592102
      ],
      "plane_d": 1071.306884765625,
      "bbox_min": [
        2039.2958984375,
        1949.493408203125,
        372.5
      ],
      "bbox_max": [
        2066.873291015625,
        1977.0706787109375,
        385.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071189880371094,
        -0.7070945501327515,
        -4.352215910330415e-05
      ],
      "plane_d": -67.03279113769531,
      "bbox_min": [
        2045.60107421875,
        1955.7984619140625,
        372.5
      ],
      "bbox_max": [
        2066.166259765625,
        1976.363525390625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071011066436768,
        0.7071124911308289,
        0.0
      ],
      "plane_d": 59.9771728515625,
      "bbox_min": [
        2045.60107421875,
        1959.25146484375,
        372.5
      ],
      "bbox_max": [
        2066.166259765625,
        1976.363525390625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35540273785591125,
        0.35540273785591125,
        -0.8645102381706238
      ],
      "plane_d": -1104.2918701171875,
      "bbox_min": [
        2049.053955078125,
        1959.25146484375,
        372.5
      ],
      "bbox_max": [
        2066.166259765625,
        1976.363525390625,
        382.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071021199226379,
        -0.7071112990379333,
        0.0
      ],
      "plane_d": -59.9815673828125,
      "bbox_min": [
        2039.2958984375,
        1949.493408203125,
        372.5
      ],
      "bbox_max": [
        2066.166259765625,
        1977.0706787109375,
        385.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 59.0,
      "bbox_min": [
        2039.2958984375,
        1955.1502685546875,
        372.5
      ],
      "bbox_max": [
        2060.50927734375,
        1977.0706787109375,
        385.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -373.5,
      "bbox_min": [
        2039.2958984375,
        1955.1502685546875,
        372.5
      ],
      "bbox_max": [
        2042.4779052734375,
        1958.332275390625,
        373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31623297929763794,
        -0.31623297929763794,
        0.8944236040115356
      ],
      "plane_d": 929.7791748046875,
      "bbox_min": [
        2039.2958984375,
        1955.1502685546875,
        372.5
      ],
      "bbox_max": [
        2040.710205078125,
        1956.564453125,
        373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070457339286804,
        -0.7071678042411804,
        -0.0
      ],
      "plane_d": 2824.99462890625,
      "bbox_min": [
        2039.2958984375,
        1955.1502685546875,
        372.5
      ],
      "bbox_max": [
        2040.0030517578125,
        1955.8572998046875,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071044445037842,
        0.7071090936660767,
        0.0
      ],
      "plane_d": 66.99072265625,
      "bbox_min": [
        2044.9527587890625,
        1949.493408203125,
        372.5
      ],
      "bbox_max": [
        2066.166259765625,
        1971.413818359375,
        385.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -373.5,
      "bbox_min": [
        2044.9527587890625,
        1949.493408203125,
        372.5
      ],
      "bbox_max": [
        2048.134765625,
        1952.6754150390625,
        373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31618380546569824,
        -0.3162384033203125,
        0.8944389820098877
      ],
      "plane_d": 929.6834716796875,
      "bbox_min": [
        2044.9527587890625,
        1949.493408203125,
        372.5
      ],
      "bbox_max": [
        2046.3670654296875,
        1950.9075927734375,
        373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2825.000244140625,
      "bbox_min": [
        2044.9527587890625,
        1949.493408203125,
        372.5
      ],
      "bbox_max": [
        2045.659912109375,
        1950.2005615234375,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071108222007751,
        0.7071027755737305,
        -0.0
      ],
      "plane_d": -2830.00048828125,
      "bbox_min": [
        2049.902587890625,
        1912.614990234375,
        372.5
      ],
      "bbox_max": [
        2075.46728515625,
        1941.7152099609375,
        385.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2815.000244140625,
      "bbox_min": [
        2049.902587890625,
        1912.614990234375,
        372.5
      ],
      "bbox_max": [
        2075.46728515625,
        1941.7152099609375,
        385.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -382.0,
      "bbox_min": [
        2049.902587890625,
        1919.6859130859375,
        372.5
      ],
      "bbox_max": [
        2075.46728515625,
        1941.7152099609375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071027159690857,
        0.7071108222007751,
        0.0
      ],
      "plane_d": 83.98388671875,
      "bbox_min": [
        2049.902587890625,
        1919.6859130859375,
        372.5
      ],
      "bbox_max": [
        2075.46728515625,
        1941.7152099609375,
        382.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071123719215393,
        0.7071012854576111,
        0.0
      ],
      "plane_d": -2825.0009765625,
      "bbox_min": [
        2060.6181640625,
        1919.6859130859375,
        372.5
      ],
      "bbox_max": [
        2075.46728515625,
        1930.999755859375,
        382.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 99.154052734375,
      "bbox_min": [
        2060.6181640625,
        1920.39306640625,
        372.5
      ],
      "bbox_max": [
        2067.689208984375,
        1927.464111328125,
        382.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071312069892883,
        -0.7070823311805725,
        0.0
      ],
      "plane_d": -99.251708984375,
      "bbox_min": [
        2067.689208984375,
        1927.464111328125,
        372.5
      ],
      "bbox_max": [
        2071.224609375,
        1930.999755859375,
        382.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071123719215393,
        0.7071012854576111,
        0.0
      ],
      "plane_d": -2825.0009765625,
      "bbox_min": [
        2052.73095703125,
        1919.6859130859375,
        382.0
      ],
      "bbox_max": [
        2075.46728515625,
        1938.88671875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 99.154052734375,
      "bbox_min": [
        2052.73095703125,
        1920.39306640625,
        382.0
      ],
      "bbox_max": [
        2067.689208984375,
        1932.5228271484375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        0.7071372866630554,
        0.0
      ],
      "plane_d": 94.87841796875,
      "bbox_min": [
        2052.73095703125,
        1923.3304443359375,
        382.0
      ],
      "bbox_max": [
        2061.92333984375,
        1932.5228271484375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        -0.7071372866630554,
        -0.0
      ],
      "plane_d": 2816.995849609375,
      "bbox_min": [
        2059.094970703125,
        1923.3304443359375,
        382.0
      ],
      "bbox_max": [
        2061.92333984375,
        1926.1588134765625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071372866630554,
        -0.7070762515068054,
        0.0
      ],
      "plane_d": -97.1217041015625,
      "bbox_min": [
        2060.50927734375,
        1923.3304443359375,
        382.0
      ],
      "bbox_max": [
        2061.92333984375,
        1926.1588134765625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071372866630554,
        0.7070762515068054,
        -0.0
      ],
      "plane_d": -2819.004150390625,
      "bbox_min": [
        2060.50927734375,
        1924.74462890625,
        382.0
      ],
      "bbox_max": [
        2061.92333984375,
        1926.1588134765625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        -0.7071372866630554,
        -0.0
      ],
      "plane_d": 2816.99609375,
      "bbox_min": [
        2052.73095703125,
        1929.6944580078125,
        382.0
      ],
      "bbox_max": [
        2055.559326171875,
        1932.5228271484375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        0.7071372866630554,
        0.0
      ],
      "plane_d": 85.8782958984375,
      "bbox_min": [
        2052.73095703125,
        1929.6944580078125,
        382.0
      ],
      "bbox_max": [
        2055.559326171875,
        1932.5228271484375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071372866630554,
        -0.7070762515068054,
        0.0
      ],
      "plane_d": -88.12158203125,
      "bbox_min": [
        2054.145263671875,
        1929.6944580078125,
        382.0
      ],
      "bbox_max": [
        2055.559326171875,
        1932.5228271484375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071372866630554,
        0.7070762515068054,
        -0.0
      ],
      "plane_d": -2819.00390625,
      "bbox_min": [
        2054.145263671875,
        1931.108642578125,
        382.0
      ],
      "bbox_max": [
        2055.559326171875,
        1932.5228271484375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071372866630554,
        0.7070762515068054,
        0.0
      ],
      "plane_d": 95.1220703125,
      "bbox_min": [
        2059.094970703125,
        1929.6944580078125,
        382.0
      ],
      "bbox_max": [
        2068.287353515625,
        1938.88671875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070762515068054,
        -0.7071372866630554,
        0.0
      ],
      "plane_d": -96.8779296875,
      "bbox_min": [
        2065.458984375,
        1929.6944580078125,
        382.0
      ],
      "bbox_max": [
        2068.287353515625,
        1932.5228271484375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070762515068054,
        0.7071372866630554,
        -0.0
      ],
      "plane_d": -2827.995849609375,
      "bbox_min": [
        2065.458984375,
        1929.6944580078125,
        382.0
      ],
      "bbox_max": [
        2068.287353515625,
        1932.5228271484375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071372866630554,
        -0.7070762515068054,
        -0.0
      ],
      "plane_d": 2826.004150390625,
      "bbox_min": [
        2065.458984375,
        1929.6944580078125,
        382.0
      ],
      "bbox_max": [
        2066.873046875,
        1931.108642578125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        -0.7071372866630554,
        -0.0
      ],
      "plane_d": 2825.99609375,
      "bbox_min": [
        2059.094970703125,
        1936.058349609375,
        382.0
      ],
      "bbox_max": [
        2061.92333984375,
        1938.88671875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        0.7071372866630554,
        0.0
      ],
      "plane_d": 85.8780517578125,
      "bbox_min": [
        2059.094970703125,
        1936.058349609375,
        382.0
      ],
      "bbox_max": [
        2061.92333984375,
        1938.88671875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071372866630554,
        -0.7070762515068054,
        0.0
      ],
      "plane_d": -88.1220703125,
      "bbox_min": [
        2060.50927734375,
        1936.058349609375,
        382.0
      ],
      "bbox_max": [
        2061.92333984375,
        1938.88671875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071372866630554,
        0.7070762515068054,
        -0.0
      ],
      "plane_d": -2828.00390625,
      "bbox_min": [
        2060.50927734375,
        1937.4725341796875,
        382.0
      ],
      "bbox_max": [
        2061.92333984375,
        1938.88671875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070946097373962,
        0.7071189880371094,
        0.0
      ],
      "plane_d": 88.951171875,
      "bbox_min": [
        2064.044677734375,
        1934.6441650390625,
        372.5
      ],
      "bbox_max": [
        2071.11572265625,
        1941.7152099609375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071189880371094,
        -0.7070945501327515,
        0.0
      ],
      "plane_d": -94.0489501953125,
      "bbox_min": [
        2067.580322265625,
        1934.6441650390625,
        372.5
      ],
      "bbox_max": [
        2071.11572265625,
        1941.7152099609375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071189880371094,
        0.7070945501327515,
        -0.0
      ],
      "plane_d": -2835.00146484375,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        372.5
      ],
      "bbox_max": [
        2071.11572265625,
        1941.7152099609375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071062922477722,
        0.7071073651313782,
        -0.0
      ],
      "plane_d": -2815.0,
      "bbox_min": [
        1973.2493896484375,
        1846.0794677734375,
        385.0
      ],
      "bbox_max": [
        2129.0986328125,
        2052.73095703125,
        440.00006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 410.0,
      "bbox_min": [
        1974.996337890625,
        1846.0794677734375,
        385.0
      ],
      "bbox_max": [
        2086.672119140625,
        2006.0147705078125,
        410.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 136.0,
      "bbox_min": [
        1994.36962890625,
        1846.0794677734375,
        385.0
      ],
      "bbox_max": [
        2086.672119140625,
        1967.878173828125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000008344650269,
        0.5000008344650269,
        -0.7071056365966797
      ],
      "plane_d": -1665.2401123046875,
      "bbox_min": [
        1994.36962890625,
        1846.0794677734375,
        385.0
      ],
      "bbox_max": [
        2044.9527587890625,
        1967.878173828125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5970848202705383,
        0.20067328214645386,
        -0.7766724228858948
      ],
      "plane_d": -1271.8546142578125,
      "bbox_min": [
        2008.5718994140625,
        1846.0794677734375,
        385.0
      ],
      "bbox_max": [
        2041.829833984375,
        1878.0755615234375,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5985074639320374,
        0.19949905574321747,
        -0.7758795022964478
      ],
      "plane_d": -1272.865478515625,
      "bbox_min": [
        2008.5718994140625,
        1846.0794677734375,
        385.0
      ],
      "bbox_max": [
        2041.829833984375,
        1878.0755615234375,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1361461579799652,
        0.9906888008117676,
        0.0
      ],
      "plane_d": -1554.28857421875,
      "bbox_min": [
        2012.35205078125,
        1846.0794677734375,
        385.0
      ],
      "bbox_max": [
        2041.829833984375,
        1859.912109375,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486849308013916,
        0.3162228763103485,
        -0.0
      ],
      "plane_d": -2497.23486328125,
      "bbox_min": [
        2012.35205078125,
        1846.0794677734375,
        385.0
      ],
      "bbox_max": [
        2016.962890625,
        1859.912109375,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2805.000244140625,
      "bbox_min": [
        1994.36962890625,
        1847.517578125,
        385.0
      ],
      "bbox_max": [
        2044.9527587890625,
        1967.878173828125,
        410.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.1361461579799652,
        0.9906888008117676,
        0.0
      ],
      "plane_d": -1554.28857421875,
      "bbox_min": [
        1994.36962890625,
        1847.517578125,
        385.0
      ],
      "bbox_max": [
        2041.829833984375,
        1938.2503662109375,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 101.0,
      "bbox_min": [
        1994.36962890625,
        1878.0755615234375,
        385.0
      ],
      "bbox_max": [
        2040.0030517578125,
        1938.2503662109375,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2768.000244140625,
      "bbox_min": [
        2026.5679931640625,
        1878.0755615234375,
        385.0
      ],
      "bbox_max": [
        2040.0030517578125,
        1891.5106201171875,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2773.000244140625,
      "bbox_min": [
        2032.224853515625,
        1880.197021484375,
        385.0
      ],
      "bbox_max": [
        2040.0030517578125,
        1891.5106201171875,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -106.0,
      "bbox_min": [
        2032.224853515625,
        1880.197021484375,
        385.0
      ],
      "bbox_max": [
        2037.8818359375,
        1885.853759765625,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31622567772865295,
        -0.31622567772865295,
        -0.8944286704063416
      ],
      "plane_d": 316.628173828125,
      "bbox_min": [
        2032.224853515625,
        1880.197021484375,
        407.0
      ],
      "bbox_max": [
        2037.8818359375,
        1885.853759765625,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -109.0,
      "bbox_min": [
        2034.3463134765625,
        1880.197021484375,
        408.5
      ],
      "bbox_max": [
        2037.8818359375,
        1883.732421875,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2776.000244140625,
      "bbox_min": [
        2032.224853515625,
        1883.732421875,
        407.0
      ],
      "bbox_max": [
        2040.0030517578125,
        1891.5106201171875,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31622567772865295,
        0.31622567772865295,
        -0.8944286704063416
      ],
      "plane_d": -876.08251953125,
      "bbox_min": [
        2032.224853515625,
        1883.732421875,
        407.0
      ],
      "bbox_max": [
        2040.0030517578125,
        1891.5106201171875,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31622567772865295,
        -0.31622567772865295,
        -0.8944286704063416
      ],
      "plane_d": 316.628173828125,
      "bbox_min": [
        2035.7603759765625,
        1883.732421875,
        407.0
      ],
      "bbox_max": [
        2040.0030517578125,
        1885.853759765625,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -109.0,
      "bbox_min": [
        2037.8818359375,
        1883.732421875,
        408.5
      ],
      "bbox_max": [
        2040.0030517578125,
        1885.853759765625,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2765.0,
      "bbox_min": [
        2026.5679931640625,
        1878.0755615234375,
        407.0
      ],
      "bbox_max": [
        2034.3463134765625,
        1885.853759765625,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31622567772865295,
        -0.31622567772865295,
        -0.8944286704063416
      ],
      "plane_d": 1601.9114990234375,
      "bbox_min": [
        2026.5679931640625,
        1878.0755615234375,
        407.0
      ],
      "bbox_max": [
        2034.3463134765625,
        1885.853759765625,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31622567772865295,
        -0.31622567772865295,
        -0.8944286704063416
      ],
      "plane_d": 316.628173828125,
      "bbox_min": [
        2032.224853515625,
        1878.0755615234375,
        407.0
      ],
      "bbox_max": [
        2034.3463134765625,
        1882.3182373046875,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -109.0,
      "bbox_min": [
        2032.224853515625,
        1878.0755615234375,
        408.5
      ],
      "bbox_max": [
        2034.3463134765625,
        1880.197021484375,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 97.9998779296875,
      "bbox_min": [
        1994.36962890625,
        1883.732421875,
        385.0
      ],
      "bbox_max": [
        2034.34619140625,
        1938.2503662109375,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31622567772865295,
        0.31622567772865295,
        -0.8944286704063416
      ],
      "plane_d": 409.20074462890625,
      "bbox_min": [
        2024.4466552734375,
        1883.732421875,
        407.0
      ],
      "bbox_max": [
        2034.34619140625,
        1893.6319580078125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31622567772865295,
        -0.31622567772865295,
        -0.8944286704063416
      ],
      "plane_d": 1601.9114990234375,
      "bbox_min": [
        2024.4466552734375,
        1883.732421875,
        407.0
      ],
      "bbox_max": [
        2034.34619140625,
        1893.6319580078125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2776.000244140625,
      "bbox_min": [
        2032.224853515625,
        1891.5106201171875,
        408.5
      ],
      "bbox_max": [
        2034.34619140625,
        1893.6319580078125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.940701425075531,
        -0.3353528082370758,
        -0.051180124282836914
      ],
      "plane_d": -1233.1693115234375,
      "bbox_min": [
        1994.36962890625,
        1910.79638671875,
        385.0
      ],
      "bbox_max": [
        2019.5936279296875,
        1938.2503662109375,
        403.8999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.646287202835083,
        0.646287202835083,
        -0.40574103593826294
      ],
      "plane_d": -2389.502685546875,
      "bbox_min": [
        1994.36962890625,
        1910.79638671875,
        385.0
      ],
      "bbox_max": [
        2019.5936279296875,
        1938.2503662109375,
        403.8999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3004606068134308,
        0.7846331000328064,
        0.542286217212677
      ],
      "plane_d": -1124.7581787109375,
      "bbox_min": [
        1995.093505859375,
        1910.79638671875,
        385.0
      ],
      "bbox_max": [
        2019.5936279296875,
        1931.5445556640625,
        403.8999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10076512396335602,
        0.9897704124450684,
        0.10099915415048599
      ],
      "plane_d": -1747.3328857421875,
      "bbox_min": [
        1995.093505859375,
        1910.79638671875,
        385.0
      ],
      "bbox_max": [
        2019.5936279296875,
        1931.5445556640625,
        403.8999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.42111504077911377,
        0.20159655809402466,
        0.8843194842338562
      ],
      "plane_d": -1590.589599609375,
      "bbox_min": [
        1995.093505859375,
        1910.79638671875,
        385.0
      ],
      "bbox_max": [
        2019.5936279296875,
        1930.4014892578125,
        403.8999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5829903483390808,
        0.7574321627616882,
        -0.2939704656600952
      ],
      "plane_d": -2520.312255859375,
      "bbox_min": [
        1995.093505859375,
        1910.79638671875,
        385.0
      ],
      "bbox_max": [
        2019.5936279296875,
        1930.4014892578125,
        403.8999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.629523754119873,
        0.5220200419425964,
        0.5754953026771545
      ],
      "plane_d": 27.739425659179688,
      "bbox_min": [
        1996.8521728515625,
        1910.79638671875,
        385.0
      ],
      "bbox_max": [
        2015.736572265625,
        1928.3155517578125,
        403.8999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.660870373249054,
        -0.732067346572876,
        0.1653110682964325
      ],
      "plane_d": 2659.171142578125,
      "bbox_min": [
        1996.8521728515625,
        1910.79638671875,
        385.0
      ],
      "bbox_max": [
        2015.736572265625,
        1923.503173828125,
        403.8999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4997924864292145,
        -0.8632915616035461,
        0.07025118172168732
      ],
      "plane_d": 2629.218017578125,
      "bbox_min": [
        2000.475830078125,
        1910.79638671875,
        385.0
      ],
      "bbox_max": [
        2015.736572265625,
        1923.3304443359375,
        403.8999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.021501023322343826,
        -0.9989307522773743,
        -0.04092758893966675
      ],
      "plane_d": 1886.8421630859375,
      "bbox_min": [
        2002.818115234375,
        1913.9896240234375,
        385.0
      ],
      "bbox_max": [
        2015.736572265625,
        1923.3304443359375,
        403.8999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16508658230304718,
        -0.3899647295475006,
        0.9059105515480042
      ],
      "plane_d": 715.6578979492188,
      "bbox_min": [
        2002.818115234375,
        1915.6700439453125,
        400.566650390625
      ],
      "bbox_max": [
        2015.736572265625,
        1923.3304443359375,
        403.8999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03916618973016739,
        -0.39953941106796265,
        0.9158790111541748
      ],
      "plane_d": 319.8699035644531,
      "bbox_min": [
        2002.818115234375,
        1915.6700439453125,
        400.566650390625
      ],
      "bbox_max": [
        2008.1832275390625,
        1923.3304443359375,
        403.8999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29355043172836304,
        -0.954705536365509,
        0.04863692820072174
      ],
      "plane_d": 1218.916259765625,
      "bbox_min": [
        2008.7008056640625,
        1913.9896240234375,
        385.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1916.2593994140625,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33213669061660767,
        -0.9432312250137329,
        0.0
      ],
      "plane_d": 1138.1357421875,
      "bbox_min": [
        2009.54931640625,
        1914.25048828125,
        385.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1916.2593994140625,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4457854926586151,
        -0.8948832154273987,
        0.021432166919112206
      ],
      "plane_d": 2600.847412109375,
      "bbox_min": [
        2000.475830078125,
        1910.79638671875,
        385.0
      ],
      "bbox_max": [
        2008.872802734375,
        1919.1585693359375,
        402.1490783691406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21224769949913025,
        -0.3666154742240906,
        0.9058387875556946
      ],
      "plane_d": 774.9124755859375,
      "bbox_min": [
        2000.475830078125,
        1910.79638671875,
        385.0
      ],
      "bbox_max": [
        2008.872802734375,
        1919.1585693359375,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26008114218711853,
        -0.3875488340854645,
        0.8844002485275269
      ],
      "plane_d": 919.1375732421875,
      "bbox_min": [
        2000.475830078125,
        1910.79638671875,
        385.0
      ],
      "bbox_max": [
        2008.872802734375,
        1919.1585693359375,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5626384019851685,
        -0.8263674378395081,
        -0.023555507883429527
      ],
      "plane_d": 460.8305969238281,
      "bbox_min": [
        2003.6923828125,
        1910.79638671875,
        385.0
      ],
      "bbox_max": [
        2008.872802734375,
        1914.2972412109375,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29355043172836304,
        -0.954705536365509,
        0.04863692820072174
      ],
      "plane_d": 1218.916259765625,
      "bbox_min": [
        2003.6923828125,
        1910.79638671875,
        385.0
      ],
      "bbox_max": [
        2008.872802734375,
        1914.2972412109375,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5866062045097351,
        -0.80986487865448,
        -0.0034851343370974064
      ],
      "plane_d": 373.4503479003906,
      "bbox_min": [
        2003.6923828125,
        1910.79638671875,
        385.0
      ],
      "bbox_max": [
        2006.365966796875,
        1912.7330322265625,
        387.9176330566406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4003014862537384,
        -0.1955672651529312,
        0.8952720165252686
      ],
      "plane_d": 826.9619140625,
      "bbox_min": [
        1996.8521728515625,
        1913.3602294921875,
        385.9206237792969
      ],
      "bbox_max": [
        2000.952880859375,
        1923.503173828125,
        392.4666442871094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26008114218711853,
        -0.3875488340854645,
        0.8844002485275269
      ],
      "plane_d": 919.1375732421875,
      "bbox_min": [
        1997.6983642578125,
        1913.3602294921875,
        385.9206237792969
      ],
      "bbox_max": [
        2000.952880859375,
        1919.1585693359375,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5385398268699646,
        -0.7492015957832336,
        0.3855798542499542
      ],
      "plane_d": 2362.191650390625,
      "bbox_min": [
        1997.86181640625,
        1913.3602294921875,
        385.9206237792969
      ],
      "bbox_max": [
        2000.952880859375,
        1916.584716796875,
        388.1034240722656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5310924053192139,
        -0.44778913259506226,
        0.7193229794502258
      ],
      "plane_d": 1641.27978515625,
      "bbox_min": [
        1996.8521728515625,
        1919.1585693359375,
        388.67864990234375
      ],
      "bbox_max": [
        2000.475830078125,
        1923.503173828125,
        392.4666442871094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47918036580085754,
        0.022650154307484627,
        0.8774241209030151
      ],
      "plane_d": -1360.2373046875,
      "bbox_min": [
        2008.1832275390625,
        1923.3304443359375,
        397.566650390625
      ],
      "bbox_max": [
        2019.5936279296875,
        1930.0238037109375,
        403.8999938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5829903483390808,
        0.7574321627616882,
        -0.2939704656600952
      ],
      "plane_d": -2520.312255859375,
      "bbox_min": [
        2016.4613037109375,
        1927.2769775390625,
        397.566650390625
      ],
      "bbox_max": [
        2019.5936279296875,
        1930.0238037109375,
        399.0249938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3431413471698761,
        0.3431413471698761,
        0.874361515045166
      ],
      "plane_d": -1693.7054443359375,
      "bbox_min": [
        2006.24267578125,
        1929.59228515625,
        390.0
      ],
      "bbox_max": [
        2011.71875,
        1931.5445556640625,
        392.4666442871094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09570713341236115,
        0.38684943318367004,
        0.9171628952026367
      ],
      "plane_d": -915.5408325195312,
      "bbox_min": [
        1994.36962890625,
        1927.4124755859375,
        385.0
      ],
      "bbox_max": [
        2010.57568359375,
        1937.879150390625,
        393.92498779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38684943318367004,
        0.09570713341236115,
        0.9171628952026367
      ],
      "plane_d": 229.089111328125,
      "bbox_min": [
        1994.36962890625,
        1927.4124755859375,
        385.0
      ],
      "bbox_max": [
        2010.57568359375,
        1937.879150390625,
        393.92498779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.28830811381340027,
        0.33647823333740234,
        0.8964713215827942
      ],
      "plane_d": -1579.516845703125,
      "bbox_min": [
        1994.36962890625,
        1928.3155517578125,
        385.0
      ],
      "bbox_max": [
        2010.57568359375,
        1937.879150390625,
        393.92498779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3431413471698761,
        0.3431413471698761,
        0.874361515045166
      ],
      "plane_d": -1693.7054443359375,
      "bbox_min": [
        1994.36962890625,
        1929.489990234375,
        385.0
      ],
      "bbox_max": [
        2010.57568359375,
        1937.879150390625,
        392.4666442871094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9552825093269348,
        0.23633833229541779,
        -0.17770637571811676
      ],
      "plane_d": 1518.30126953125,
      "bbox_min": [
        1994.36962890625,
        1929.489990234375,
        385.0
      ],
      "bbox_max": [
        1996.4837646484375,
        1935.7755126953125,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9016419649124146,
        0.4288327395915985,
        0.056074608117341995
      ],
      "plane_d": 949.1978759765625,
      "bbox_min": [
        1994.4979248046875,
        1929.489990234375,
        385.0
      ],
      "bbox_max": [
        1995.9100341796875,
        1932.7108154296875,
        387.9612731933594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.460689902305603,
        0.8819450736045837,
        0.09968864917755127
      ],
      "plane_d": -824.6478881835938,
      "bbox_min": [
        1998.802734375,
        1935.6036376953125,
        385.0
      ],
      "bbox_max": [
        2004.2410888671875,
        1937.879150390625,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6974859237670898,
        0.6974859237670898,
        0.16439847648143768
      ],
      "plane_d": -2813.688720703125,
      "bbox_min": [
        2001.8077392578125,
        1924.0784912109375,
        385.0
      ],
      "bbox_max": [
        2018.041748046875,
        1938.2503662109375,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071067094802856,
        5.753044661105378e-06
      ],
      "plane_d": -2787.502197265625,
      "bbox_min": [
        2001.8077392578125,
        1924.0784912109375,
        385.0
      ],
      "bbox_max": [
        2018.041748046875,
        1938.2503662109375,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.460689902305603,
        0.8819450736045837,
        0.09968864917755127
      ],
      "plane_d": -824.6478881835938,
      "bbox_min": [
        2001.8077392578125,
        1937.1732177734375,
        385.0
      ],
      "bbox_max": [
        2004.2410888671875,
        1938.2503662109375,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8369823098182678,
        0.5326346755027771,
        0.1255428045988083
      ],
      "plane_d": -2760.933349609375,
      "bbox_min": [
        2003.869873046875,
        1928.339111328125,
        385.0
      ],
      "bbox_max": [
        2013.7811279296875,
        1938.2503662109375,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5070080757141113,
        0.8615391254425049,
        0.026328522711992264
      ],
      "plane_d": -2695.9931640625,
      "bbox_min": [
        2003.869873046875,
        1936.5650634765625,
        385.0
      ],
      "bbox_max": [
        2006.733642578125,
        1938.2503662109375,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9244064092636108,
        -0.38064590096473694,
        0.024114737287163734
      ],
      "plane_d": -1142.90234375,
      "bbox_min": [
        2014.943115234375,
        1916.1497802734375,
        385.0
      ],
      "bbox_max": [
        2019.5936279296875,
        1927.2769775390625,
        397.566650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9246753454208374,
        -0.3807566165924072,
        0.0
      ],
      "plane_d": -1133.8275146484375,
      "bbox_min": [
        2014.943115234375,
        1916.1497802734375,
        385.0
      ],
      "bbox_max": [
        2019.5936279296875,
        1927.2769775390625,
        397.566650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9480223059654236,
        -0.31601718068122864,
        -0.03724071383476257
      ],
      "plane_d": -1290.9697265625,
      "bbox_min": [
        2014.943115234375,
        1916.1497802734375,
        385.0
      ],
      "bbox_max": [
        2019.5936279296875,
        1927.2769775390625,
        397.566650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.646287202835083,
        0.646287202835083,
        -0.40574103593826294
      ],
      "plane_d": -2389.502685546875,
      "bbox_min": [
        2014.943115234375,
        1916.1497802734375,
        385.0
      ],
      "bbox_max": [
        2019.5936279296875,
        1927.2769775390625,
        397.566650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33213669061660767,
        -0.9432312250137329,
        0.0
      ],
      "plane_d": 1138.1357421875,
      "bbox_min": [
        2014.943115234375,
        1916.1497802734375,
        385.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1916.2593994140625,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071067094802856,
        5.753044661105378e-06
      ],
      "plane_d": -2787.502197265625,
      "bbox_min": [
        2017.8411865234375,
        1923.7723388671875,
        385.0
      ],
      "bbox_max": [
        2018.347900390625,
        1924.279052734375,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071057558059692,
        -0.7071077823638916,
        0.0
      ],
      "plane_d": 28.0040283203125,
      "bbox_min": [
        1973.2493896484375,
        1894.339111328125,
        385.0
      ],
      "bbox_max": [
        2114.956298828125,
        2052.73095703125,
        440.00006103515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1.1541748046875,
      "bbox_min": [
        1973.2493896484375,
        1894.339111328125,
        385.0
      ],
      "bbox_max": [
        2114.956298828125,
        2038.5888671875,
        440.00006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17149843275547028,
        0.17149843275547028,
        -0.970142662525177
      ],
      "plane_d": -284.9786682128906,
      "bbox_min": [
        1973.2493896484375,
        1991.3216552734375,
        410.0
      ],
      "bbox_max": [
        2017.9737548828125,
        2038.5888671875,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071037292480469,
        0.7071098685264587,
        0.0
      ],
      "plane_d": 110.1417236328125,
      "bbox_min": [
        2011.01171875,
        1894.339111328125,
        385.0
      ],
      "bbox_max": [
        2114.956298828125,
        2023.032470703125,
        439.99993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17149843275547028,
        0.17149843275547028,
        -0.970142662525177
      ],
      "plane_d": -284.9786682128906,
      "bbox_min": [
        2068.396240234375,
        1894.339111328125,
        410.0
      ],
      "bbox_max": [
        2114.956298828125,
        1940.899169921875,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 89.0,
      "bbox_min": [
        2011.01171875,
        1934.6441650390625,
        385.0
      ],
      "bbox_max": [
        2099.400146484375,
        2023.032470703125,
        432.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071050405502319,
        -0.7071085572242737,
        0.0
      ],
      "plane_d": -93.9930419921875,
      "bbox_min": [
        2064.044677734375,
        1934.6441650390625,
        385.0
      ],
      "bbox_max": [
        2099.400146484375,
        1969.99951171875,
        432.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -410.0,
      "bbox_min": [
        2064.044677734375,
        1934.6441650390625,
        385.0
      ],
      "bbox_max": [
        2099.400146484375,
        1969.99951171875,
        432.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 405.0,
      "bbox_min": [
        2064.044677734375,
        1934.6441650390625,
        385.0
      ],
      "bbox_max": [
        2099.400146484375,
        1969.99951171875,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070946097373962,
        -0.7071189880371094,
        0.0
      ],
      "plane_d": 2829.99853515625,
      "bbox_min": [
        2064.044677734375,
        1934.6441650390625,
        405.0
      ],
      "bbox_max": [
        2067.580322265625,
        1938.1796875,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070946097373962,
        -0.7071189880371094,
        -0.0
      ],
      "plane_d": 2829.99853515625,
      "bbox_min": [
        2064.044677734375,
        1934.6441650390625,
        385.0
      ],
      "bbox_max": [
        2074.6513671875,
        1945.250732421875,
        405.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071189880371094,
        0.7070945501327515,
        -0.0
      ],
      "plane_d": -2835.00146484375,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        385.0
      ],
      "bbox_max": [
        2074.6513671875,
        1945.250732421875,
        405.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999879002571106,
        0.5000051259994507,
        -0.7071117162704468
      ],
      "plane_d": -1721.787841796875,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        400.0
      ],
      "bbox_max": [
        2074.6513671875,
        1945.250732421875,
        405.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070946097373962,
        -0.7071189880371094,
        0.0
      ],
      "plane_d": 2829.99853515625,
      "bbox_min": [
        2064.044677734375,
        1934.6441650390625,
        410.0
      ],
      "bbox_max": [
        2071.11572265625,
        1941.7152099609375,
        432.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071189880371094,
        0.7070945501327515,
        0.0
      ],
      "plane_d": -2835.00146484375,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        410.0
      ],
      "bbox_max": [
        2071.11572265625,
        1941.7152099609375,
        430.0001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -19.0001220703125,
      "bbox_min": [
        2011.01171875,
        1966.33447265625,
        385.0
      ],
      "bbox_max": [
        2069.27734375,
        2023.032470703125,
        432.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071050405502319,
        0.7071085572242737,
        0.0
      ],
      "plane_d": 13.992919921875,
      "bbox_min": [
        2011.01171875,
        1987.6771240234375,
        385.0
      ],
      "bbox_max": [
        2046.3670654296875,
        2023.032470703125,
        432.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -410.0,
      "bbox_min": [
        2011.01171875,
        1987.6771240234375,
        385.0
      ],
      "bbox_max": [
        2046.3670654296875,
        2023.032470703125,
        432.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 405.0,
      "bbox_min": [
        2011.01171875,
        1987.6771240234375,
        385.0
      ],
      "bbox_max": [
        2046.3670654296875,
        2023.032470703125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2830.0,
      "bbox_min": [
        2011.01171875,
        1987.6771240234375,
        405.0
      ],
      "bbox_max": [
        2014.5472412109375,
        1991.212646484375,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2830.000244140625,
      "bbox_min": [
        2011.01171875,
        1987.6771240234375,
        385.0
      ],
      "bbox_max": [
        2021.6182861328125,
        1998.2838134765625,
        405.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2835.0,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        385.0
      ],
      "bbox_max": [
        2021.6182861328125,
        1998.2838134765625,
        405.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000008344650269,
        0.5000008344650269,
        -0.7071056962013245
      ],
      "plane_d": -1721.808837890625,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        400.0
      ],
      "bbox_max": [
        2021.6182861328125,
        1998.2838134765625,
        405.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2830.0,
      "bbox_min": [
        2011.01171875,
        1987.6771240234375,
        410.0
      ],
      "bbox_max": [
        2018.082763671875,
        1994.7481689453125,
        432.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2835.0,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        410.0
      ],
      "bbox_max": [
        2018.082763671875,
        1994.7481689453125,
        430.0001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 59.0,
      "bbox_min": [
        2042.7020263671875,
        1966.33447265625,
        385.0
      ],
      "bbox_max": [
        2069.27734375,
        1992.9100341796875,
        388.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071044445037842,
        0.7071090936660767,
        0.0
      ],
      "plane_d": 66.99072265625,
      "bbox_min": [
        2056.136962890625,
        1966.33447265625,
        385.0
      ],
      "bbox_max": [
        2069.27734375,
        1979.474853515625,
        388.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071067094802856,
        -0.7071067094802856,
        0.0
      ],
      "plane_d": -68.0,
      "bbox_min": [
        2061.7939453125,
        1966.33447265625,
        385.0
      ],
      "bbox_max": [
        2069.27734375,
        1973.8179931640625,
        388.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071678042411804,
        0.7070457339286804,
        0.0
      ],
      "plane_d": -2858.40576171875,
      "bbox_min": [
        2066.166259765625,
        1970.706787109375,
        385.0
      ],
      "bbox_max": [
        2069.27734375,
        1973.8179931640625,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -388.5,
      "bbox_min": [
        2066.166259765625,
        1970.706787109375,
        388.0
      ],
      "bbox_max": [
        2069.27734375,
        1973.8179931640625,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31623297929763794,
        0.31623297929763794,
        0.8944236040115356
      ],
      "plane_d": -1625.372802734375,
      "bbox_min": [
        2067.86328125,
        1972.40380859375,
        388.0
      ],
      "bbox_max": [
        2069.27734375,
        1973.8179931640625,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071021199226379,
        -0.7071112990379333,
        0.0
      ],
      "plane_d": -59.9815673828125,
      "bbox_min": [
        2056.136962890625,
        1971.9912109375,
        385.0
      ],
      "bbox_max": [
        2063.62060546875,
        1979.474853515625,
        388.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7070457339286804,
        0.7071678042411804,
        -0.0
      ],
      "plane_d": -2858.39501953125,
      "bbox_min": [
        2060.50927734375,
        1976.363525390625,
        385.0
      ],
      "bbox_max": [
        2063.62060546875,
        1979.474853515625,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -388.5,
      "bbox_min": [
        2060.50927734375,
        1976.363525390625,
        388.0
      ],
      "bbox_max": [
        2063.62060546875,
        1979.474853515625,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31623297929763794,
        0.31623297929763794,
        0.8944236040115356
      ],
      "plane_d": -1625.372802734375,
      "bbox_min": [
        2062.206298828125,
        1978.0606689453125,
        388.0
      ],
      "bbox_max": [
        2063.62060546875,
        1979.474853515625,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067094802856,
        0.7071067094802856,
        0.0
      ],
      "plane_d": 48.0,
      "bbox_min": [
        2042.7020263671875,
        1979.76953125,
        385.0
      ],
      "bbox_max": [
        2055.84228515625,
        1992.9100341796875,
        388.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071067094802856,
        -0.7071067094802856,
        0.0
      ],
      "plane_d": -49.0,
      "bbox_min": [
        2048.35888671875,
        1979.76953125,
        385.0
      ],
      "bbox_max": [
        2055.84228515625,
        1987.2530517578125,
        388.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071678042411804,
        0.7070457339286804,
        0.0
      ],
      "plane_d": -2858.404296875,
      "bbox_min": [
        2052.731201171875,
        1984.141845703125,
        385.0
      ],
      "bbox_max": [
        2055.84228515625,
        1987.2530517578125,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -388.5,
      "bbox_min": [
        2052.731201171875,
        1984.141845703125,
        388.0
      ],
      "bbox_max": [
        2055.84228515625,
        1987.2530517578125,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31626027822494507,
        0.3162056803703308,
        0.8944236040115356
      ],
      "plane_d": -1625.374755859375,
      "bbox_min": [
        2054.42822265625,
        1985.8387451171875,
        388.0
      ],
      "bbox_max": [
        2055.84228515625,
        1987.2530517578125,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067094802856,
        0.7071067094802856,
        0.0
      ],
      "plane_d": 40.0,
      "bbox_min": [
        2042.7020263671875,
        1985.4263916015625,
        385.0
      ],
      "bbox_max": [
        2050.185546875,
        1992.9100341796875,
        388.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071090936660767,
        -0.7071044445037842,
        0.0
      ],
      "plane_d": -41.0093994140625,
      "bbox_min": [
        2042.7020263671875,
        1985.4263916015625,
        385.0
      ],
      "bbox_max": [
        2050.185546875,
        1992.9100341796875,
        388.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7072288393974304,
        0.7069846987724304,
        -0.0
      ],
      "plane_d": -2858.4072265625,
      "bbox_min": [
        2047.0743408203125,
        1989.7987060546875,
        385.0
      ],
      "bbox_max": [
        2050.185546875,
        1992.9100341796875,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -388.5,
      "bbox_min": [
        2047.0743408203125,
        1989.7987060546875,
        388.0
      ],
      "bbox_max": [
        2050.185546875,
        1992.9100341796875,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31622201204299927,
        0.3161128759384155,
        0.8944698572158813
      ],
      "plane_d": -1625.12890625,
      "bbox_min": [
        2048.771240234375,
        1991.49560546875,
        388.0
      ],
      "bbox_max": [
        2050.185546875,
        1992.9100341796875,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2483755201101303,
        -0.9686638712882996,
        0.0
      ],
      "plane_d": 2353.701904296875,
      "bbox_min": [
        1910.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        2020.0,
        2012.847412109375,
        1150.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071077823638916,
        -0.7071058750152588,
        0.0
      ],
      "plane_d": 27.9962158203125,
      "bbox_min": [
        1922.447021484375,
        1917.640380859375,
        370.0
      ],
      "bbox_max": [
        1997.592041015625,
        2012.847412109375,
        665.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1922.447021484375,
        1917.640380859375,
        370.0
      ],
      "bbox_max": [
        1997.592041015625,
        2012.847412109375,
        665.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 410.0,
      "bbox_min": [
        1922.447021484375,
        1917.640380859375,
        370.0
      ],
      "bbox_max": [
        1997.592041015625,
        2012.847412109375,
        665.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 665.0,
      "bbox_min": [
        1957.8697509765625,
        1917.6405029296875,
        410.0
      ],
      "bbox_max": [
        1997.5919189453125,
        2012.847412109375,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17149843275547028,
        0.17149843275547028,
        -0.970142662525177
      ],
      "plane_d": -284.9786682128906,
      "bbox_min": [
        1970.70654296875,
        2006.0147705078125,
        410.0
      ],
      "bbox_max": [
        1974.996337890625,
        2012.847412109375,
        410.8990478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000008344650269,
        0.5000008344650269,
        -0.7071056365966797
      ],
      "plane_d": -1665.2401123046875,
      "bbox_min": [
        1922.447021484375,
        1917.640380859375,
        370.0
      ],
      "bbox_max": [
        1997.592041015625,
        2012.847412109375,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20067326724529266,
        0.5970848202705383,
        -0.77667236328125
      ],
      "plane_d": -1241.58154296875,
      "bbox_min": [
        1922.447021484375,
        1931.108642578125,
        376.5834655761719
      ],
      "bbox_max": [
        1954.443115234375,
        1965.4622802734375,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19949905574321747,
        0.5985074639320374,
        -0.7758795022964478
      ],
      "plane_d": -1242.3941650390625,
      "bbox_min": [
        1922.447021484375,
        1931.108642578125,
        376.5834655761719
      ],
      "bbox_max": [
        1954.443115234375,
        1965.4622802734375,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9906888008117676,
        -0.1361461579799652,
        0.0
      ],
      "plane_d": -1640.342041015625,
      "bbox_min": [
        1922.447021484375,
        1931.108642578125,
        376.5834655761719
      ],
      "bbox_max": [
        1950.9075927734375,
        1965.4622802734375,
        410.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3162228763103485,
        0.9486849308013916,
        -0.0
      ],
      "plane_d": -2448.935302734375,
      "bbox_min": [
        1922.447021484375,
        1931.108642578125,
        376.5834655761719
      ],
      "bbox_max": [
        1950.9075927734375,
        1940.5953369140625,
        390.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2745.000244140625,
      "bbox_min": [
        1950.9075927734375,
        1929.09423828125,
        370.0
      ],
      "bbox_max": [
        1952.9219970703125,
        1931.108642578125,
        390.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071189880371094,
        0.7070946097373962,
        0.0
      ],
      "plane_d": 2.0477294921875,
      "bbox_min": [
        1922.447021484375,
        1917.640380859375,
        370.0
      ],
      "bbox_max": [
        1997.592041015625,
        2012.847412109375,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -7.0001220703125,
      "bbox_min": [
        1956.5645751953125,
        1917.640380859375,
        370.0
      ],
      "bbox_max": [
        1997.592041015625,
        1961.5142822265625,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071189880371094,
        0.7070946097373962,
        0.0
      ],
      "plane_d": -2773.0,
      "bbox_min": [
        1956.5645751953125,
        1950.200439453125,
        370.0
      ],
      "bbox_max": [
        1967.878173828125,
        1961.5142822265625,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2768.0,
      "bbox_min": [
        1956.5645751953125,
        1950.200439453125,
        370.0
      ],
      "bbox_max": [
        1962.2213134765625,
        1955.8572998046875,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31622567772865295,
        -0.31622567772865295,
        -0.8944286704063416
      ],
      "plane_d": 1601.9114990234375,
      "bbox_min": [
        1956.5645751953125,
        1950.200439453125,
        370.0
      ],
      "bbox_max": [
        1962.2213134765625,
        1955.8572998046875,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071012854576111,
        -0.7071123719215393,
        0.0
      ],
      "plane_d": 2765.0,
      "bbox_min": [
        1956.5645751953125,
        1950.200439453125,
        408.5
      ],
      "bbox_max": [
        1960.10009765625,
        1953.7359619140625,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071012854576111,
        -0.7071123719215393,
        -0.0
      ],
      "plane_d": 2765.0,
      "bbox_min": [
        1956.5645751953125,
        1950.200439453125,
        370.0
      ],
      "bbox_max": [
        1962.2213134765625,
        1955.8572998046875,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -372.9999694824219,
      "bbox_min": [
        1956.5645751953125,
        1950.200439453125,
        373.0
      ],
      "bbox_max": [
        1962.2213134765625,
        1955.8572998046875,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3162267804145813,
        0.3162158727645874,
        -0.8944317102432251
      ],
      "plane_d": -876.064453125,
      "bbox_min": [
        1962.2213134765625,
        1955.8572998046875,
        370.0
      ],
      "bbox_max": [
        1967.878173828125,
        1961.5142822265625,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2776.000244140625,
      "bbox_min": [
        1964.342529296875,
        1957.9786376953125,
        408.5
      ],
      "bbox_max": [
        1967.878173828125,
        1961.5142822265625,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2776.0,
      "bbox_min": [
        1962.2213134765625,
        1955.8572998046875,
        370.0
      ],
      "bbox_max": [
        1967.878173828125,
        1961.5142822265625,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -372.9999694824219,
      "bbox_min": [
        1962.2213134765625,
        1955.8572998046875,
        373.0
      ],
      "bbox_max": [
        1967.878173828125,
        1961.5142822265625,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 30.0,
      "bbox_min": [
        1960.10009765625,
        1917.640380859375,
        370.0
      ],
      "bbox_max": [
        1997.592041015625,
        1957.9786376953125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -372.5,
      "bbox_min": [
        1972.827880859375,
        1917.640380859375,
        370.0
      ],
      "bbox_max": [
        1997.592041015625,
        1947.5247802734375,
        390.6636962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -32.0,
      "bbox_min": [
        1972.827880859375,
        1917.640380859375,
        372.5
      ],
      "bbox_max": [
        1997.592041015625,
        1945.272216796875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2760.000244140625,
      "bbox_min": [
        1972.827880859375,
        1928.9873046875,
        372.5
      ],
      "bbox_max": [
        1974.2420654296875,
        1930.4014892578125,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2762.000244140625,
      "bbox_min": [
        1974.2420654296875,
        1917.640380859375,
        372.5
      ],
      "bbox_max": [
        1997.592041015625,
        1934.892333984375,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2760.000244140625,
      "bbox_min": [
        1974.2420654296875,
        1921.779296875,
        372.5
      ],
      "bbox_max": [
        1981.4500732421875,
        1928.9873046875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8942322731018066,
        -0.38324376940727234,
        0.23124225437641144
      ],
      "plane_d": 2434.102783203125,
      "bbox_min": [
        1991.3895263671875,
        1917.640380859375,
        372.5
      ],
      "bbox_max": [
        1997.592041015625,
        1934.892333984375,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6814059615135193,
        -0.40099161863327026,
        0.6122840046882629
      ],
      "plane_d": 1901.3759765625,
      "bbox_min": [
        1991.3895263671875,
        1917.640380859375,
        372.5
      ],
      "bbox_max": [
        1997.592041015625,
        1934.892333984375,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8233370780944824,
        0.2744414806365967,
        0.4967876970767975
      ],
      "plane_d": 924.9917602539062,
      "bbox_min": [
        1991.3895263671875,
        1917.640380859375,
        372.5
      ],
      "bbox_max": [
        1997.592041015625,
        1934.892333984375,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4231410324573517,
        -0.6649239659309387,
        0.6154899597167969
      ],
      "plane_d": 1890.965576171875,
      "bbox_min": [
        1996.1624755859375,
        1917.640380859375,
        372.5
      ],
      "bbox_max": [
        1997.592041015625,
        1919.3685302734375,
        374.2461242675781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3670535981655121,
        -0.42233195900917053,
        0.828798770904541
      ],
      "plane_d": 1234.16455078125,
      "bbox_min": [
        1996.1624755859375,
        1917.640380859375,
        372.5
      ],
      "bbox_max": [
        1997.592041015625,
        1918.3807373046875,
        372.81268310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38684943318367004,
        0.09570713341236115,
        0.9171628952026367
      ],
      "plane_d": 229.089111328125,
      "bbox_min": [
        1990.7186279296875,
        1917.640380859375,
        375.0
      ],
      "bbox_max": [
        1997.592041015625,
        1932.3311767578125,
        390.6636962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43799906969070435,
        -0.36929774284362793,
        0.819619357585907
      ],
      "plane_d": 1265.2958984375,
      "bbox_min": [
        1990.7186279296875,
        1917.640380859375,
        375.0
      ],
      "bbox_max": [
        1997.592041015625,
        1932.3311767578125,
        390.6636962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3752918839454651,
        -0.043156471103429794,
        0.925901472568512
      ],
      "plane_d": 470.267578125,
      "bbox_min": [
        1990.7186279296875,
        1917.640380859375,
        375.0
      ],
      "bbox_max": [
        1997.592041015625,
        1932.3311767578125,
        390.6355285644531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22026322782039642,
        -0.35666319727897644,
        -0.9078961610794067
      ],
      "plane_d": 1473.30615234375,
      "bbox_min": [
        1990.7186279296875,
        1917.640380859375,
        375.0
      ],
      "bbox_max": [
        1997.592041015625,
        1932.3311767578125,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757869124412537,
        0.6190898418426514,
        0.40004971623420715
      ],
      "plane_d": 0.8875274658203125,
      "bbox_min": [
        1990.7186279296875,
        1922.5391845703125,
        380.4732360839844
      ],
      "bbox_max": [
        1994.5623779296875,
        1930.71923828125,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9016419649124146,
        0.4288327395915985,
        0.056074608117341995
      ],
      "plane_d": 949.1978759765625,
      "bbox_min": [
        1991.4832763671875,
        1922.5391845703125,
        380.4732360839844
      ],
      "bbox_max": [
        1994.5623779296875,
        1930.71923828125,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9228197336196899,
        0.3812909722328186,
        0.05496346578001976
      ],
      "plane_d": 1083.477783203125,
      "bbox_min": [
        1991.4832763671875,
        1922.5391845703125,
        381.92498779296875
      ],
      "bbox_max": [
        1993.634521484375,
        1927.6129150390625,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9552825093269348,
        0.23633833229541779,
        -0.17770637571811676
      ],
      "plane_d": 1518.30126953125,
      "bbox_min": [
        1993.294189453125,
        1927.2725830078125,
        380.4732360839844
      ],
      "bbox_max": [
        1994.5623779296875,
        1930.71923828125,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8867204189300537,
        0.3890087604522705,
        0.24979832768440247
      ],
      "plane_d": 922.2320556640625,
      "bbox_min": [
        1993.294189453125,
        1927.6129150390625,
        380.4732360839844
      ],
      "bbox_max": [
        1994.439697265625,
        1930.71923828125,
        382.32122802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8611680269241333,
        -0.5067774653434753,
        0.039574895054101944
      ],
      "plane_d": 2678.3173828125,
      "bbox_min": [
        1990.7186279296875,
        1917.640380859375,
        375.0
      ],
      "bbox_max": [
        1997.592041015625,
        1932.3311767578125,
        384.2426452636719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7428445219993591,
        -0.623299241065979,
        0.24429495632648468
      ],
      "plane_d": 2588.885009765625,
      "bbox_min": [
        1992.5208740234375,
        1921.628173828125,
        375.0
      ],
      "bbox_max": [
        1996.5723876953125,
        1932.3311767578125,
        382.4029846191406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9393597841262817,
        0.3131151497364044,
        0.1398642510175705
      ],
      "plane_d": 1215.43798828125,
      "bbox_min": [
        1992.5208740234375,
        1927.6129150390625,
        375.0
      ],
      "bbox_max": [
        1994.2479248046875,
        1932.3311767578125,
        381.92498779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8867204189300537,
        0.3890087604522705,
        0.24979832768440247
      ],
      "plane_d": 922.2320556640625,
      "bbox_min": [
        1993.294189453125,
        1927.6129150390625,
        378.9796447753906
      ],
      "bbox_max": [
        1994.2479248046875,
        1931.3251953125,
        381.92498779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1683286428451538,
        -0.14894074201583862,
        -0.9744137525558472
      ],
      "plane_d": 995.964599609375,
      "bbox_min": [
        1990.7186279296875,
        1917.640380859375,
        383.4908752441406
      ],
      "bbox_max": [
        1997.592041015625,
        1923.3038330078125,
        384.2426452636719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14978842437267303,
        -0.16592545807361603,
        -0.9746959805488586
      ],
      "plane_d": 991.62646484375,
      "bbox_min": [
        1996.7742919921875,
        1917.640380859375,
        383.8269958496094
      ],
      "bbox_max": [
        1997.592041015625,
        1918.5048828125,
        384.0301513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5310924053192139,
        -0.44778913259506226,
        0.7193229794502258
      ],
      "plane_d": 1641.27978515625,
      "bbox_min": [
        1993.634521484375,
        1924.7281494140625,
        390.0
      ],
      "bbox_max": [
        1995.77978515625,
        1927.2725830078125,
        390.6636962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3752918839454651,
        -0.043156471103429794,
        0.925901472568512
      ],
      "plane_d": 470.267578125,
      "bbox_min": [
        1993.634521484375,
        1926.25830078125,
        390.0
      ],
      "bbox_max": [
        1995.388671875,
        1927.2725830078125,
        390.6636962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071012854576111,
        -0.7071123719215393,
        0.0
      ],
      "plane_d": -9.9783935546875,
      "bbox_min": [
        1960.10009765625,
        1948.0792236328125,
        370.0
      ],
      "bbox_max": [
        1969.99951171875,
        1957.9786376953125,
        410.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.31623297929763794,
        -0.31623297929763794,
        -0.8944234848022461
      ],
      "plane_d": 360.8998107910156,
      "bbox_min": [
        1960.10009765625,
        1948.0792236328125,
        370.0
      ],
      "bbox_max": [
        1969.99951171875,
        1957.9786376953125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3162267804145813,
        0.3162158727645874,
        -0.8944317102432251
      ],
      "plane_d": -876.064453125,
      "bbox_min": [
        1960.10009765625,
        1948.0792236328125,
        407.0
      ],
      "bbox_max": [
        1969.99951171875,
        1957.9786376953125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071012854576111,
        -0.7071123719215393,
        0.0
      ],
      "plane_d": 2765.0,
      "bbox_min": [
        1960.10009765625,
        1948.0792236328125,
        408.5
      ],
      "bbox_max": [
        1962.2213134765625,
        1950.200439453125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -372.9999694824219,
      "bbox_min": [
        1960.10009765625,
        1948.0792236328125,
        370.0
      ],
      "bbox_max": [
        1969.99951171875,
        1957.9786376953125,
        373.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2776.0,
      "bbox_min": [
        1960.10009765625,
        1948.0792236328125,
        370.0
      ],
      "bbox_max": [
        1969.99951171875,
        1957.9786376953125,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071012854576111,
        -0.7071123719215393,
        -0.0
      ],
      "plane_d": 2765.0,
      "bbox_min": [
        1960.10009765625,
        1948.0792236328125,
        370.0
      ],
      "bbox_max": [
        1962.2213134765625,
        1950.200439453125,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9906888008117676,
        -0.1361461579799652,
        0.0
      ],
      "plane_d": -1640.3421630859375,
      "bbox_min": [
        1922.447021484375,
        1940.5953369140625,
        370.0
      ],
      "bbox_max": [
        1974.996337890625,
        2012.847412109375,
        410.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071098685264587,
        -0.7071037888526917,
        0.0
      ],
      "plane_d": 9.988037109375,
      "bbox_min": [
        1935.351318359375,
        1953.7359619140625,
        370.0
      ],
      "bbox_max": [
        1974.996337890625,
        2012.847412109375,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -375.0,
      "bbox_min": [
        1935.351318359375,
        1966.363525390625,
        370.0
      ],
      "bbox_max": [
        1974.996337890625,
        2012.847412109375,
        385.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.7071098685264587,
        0.7071037888526917,
        0.0
      ],
      "plane_d": -12.088134765625,
      "bbox_min": [
        1935.351318359375,
        1966.363525390625,
        370.0
      ],
      "bbox_max": [
        1974.996337890625,
        2010.3045654296875,
        375.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238780736923218,
        -0.3826870620250702,
        0.0
      ],
      "plane_d": -1060.351318359375,
      "bbox_min": [
        1950.0802001953125,
        1967.1923828125,
        370.0
      ],
      "bbox_max": [
        1971.392578125,
        1988.5047607421875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826734721660614,
        -0.9238837361335754,
        0.0
      ],
      "plane_d": 1071.213134765625,
      "bbox_min": [
        1950.0802001953125,
        1967.1923828125,
        370.0
      ],
      "bbox_max": [
        1955.1502685546875,
        1969.2923583984375,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2805.000244140625,
      "bbox_min": [
        1935.351318359375,
        1966.363525390625,
        370.0
      ],
      "bbox_max": [
        1974.996337890625,
        2010.3045654296875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 373.0,
      "bbox_min": [
        1935.351318359375,
        1966.363525390625,
        370.0
      ],
      "bbox_max": [
        1972.2213134765625,
        2001.74853515625,
        375.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.7071098685264587,
        0.7071037888526917,
        0.0
      ],
      "plane_d": -14.072021484375,
      "bbox_min": [
        1935.351318359375,
        1966.363525390625,
        373.0
      ],
      "bbox_max": [
        1972.2213134765625,
        2001.74853515625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1728079617023468,
        0.17280647158622742,
        0.9696779847145081
      ],
      "plane_d": -365.61370849609375,
      "bbox_min": [
        1946.9241943359375,
        1966.363525390625,
        373.0
      ],
      "bbox_max": [
        1972.2213134765625,
        1991.6607666015625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826734721660614,
        -0.9238837361335754,
        0.0
      ],
      "plane_d": 1071.213134765625,
      "bbox_min": [
        1946.9241943359375,
        1966.363525390625,
        373.0
      ],
      "bbox_max": [
        1972.2213134765625,
        1991.6607666015625,
        373.9999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        -0.3826870620250702,
        0.0
      ],
      "plane_d": -1060.351318359375,
      "bbox_min": [
        1946.9241943359375,
        1966.363525390625,
        373.0
      ],
      "bbox_max": [
        1972.2213134765625,
        1991.6607666015625,
        373.9999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        0.3826870620250702,
        -0.0
      ],
      "plane_d": -2583.832763671875,
      "bbox_min": [
        1946.9241943359375,
        1966.363525390625,
        373.0
      ],
      "bbox_max": [
        1972.2213134765625,
        1991.6607666015625,
        373.7911071777344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38266777992248535,
        -0.9238860011100769,
        -0.0
      ],
      "plane_d": 2562.162841796875,
      "bbox_min": [
        1946.9241943359375,
        1966.363525390625,
        373.0
      ],
      "bbox_max": [
        1948.0792236328125,
        1966.8419189453125,
        373.7910461425781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238711595535278,
        0.38270363211631775,
        0.0
      ],
      "plane_d": 1058.364501953125,
      "bbox_min": [
        1946.9241943359375,
        1966.363525390625,
        373.4999694824219
      ],
      "bbox_max": [
        1972.2213134765625,
        1991.6607666015625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        -0.3826870620250702,
        0.0
      ],
      "plane_d": -1060.351318359375,
      "bbox_min": [
        1971.392578125,
        1988.5047607421875,
        373.4999694824219
      ],
      "bbox_max": [
        1972.2213134765625,
        1991.6607666015625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071144580841064,
        -0.707099199295044,
        0.0
      ],
      "plane_d": 2765.0,
      "bbox_min": [
        1935.351318359375,
        1966.8419189453125,
        373.0
      ],
      "bbox_max": [
        1971.7427978515625,
        2001.74853515625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38266777992248535,
        -0.9238860011100769,
        -0.0
      ],
      "plane_d": 2562.162841796875,
      "bbox_min": [
        1936.8363037109375,
        1966.8419189453125,
        373.0
      ],
      "bbox_max": [
        1971.7427978515625,
        2001.74853515625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        0.3826870620250702,
        -0.0
      ],
      "plane_d": -2583.832763671875,
      "bbox_min": [
        1936.8363037109375,
        1968.4635009765625,
        373.0
      ],
      "bbox_max": [
        1971.7427978515625,
        2001.74853515625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238711595535278,
        -0.38270363211631775,
        -0.0
      ],
      "plane_d": 2581.912109375,
      "bbox_min": [
        1936.8363037109375,
        1968.4635009765625,
        373.0
      ],
      "bbox_max": [
        1970.121337890625,
        2001.74853515625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826935589313507,
        0.9238753318786621,
        -0.0
      ],
      "plane_d": -2564.13232421875,
      "bbox_min": [
        1936.8363037109375,
        1968.4635009765625,
        373.0
      ],
      "bbox_max": [
        1970.121337890625,
        2001.74853515625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2800.916259765625,
      "bbox_min": [
        1936.8363037109375,
        1968.4635009765625,
        373.0
      ],
      "bbox_max": [
        1970.121337890625,
        2001.74853515625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1728072166442871,
        -0.1728072166442871,
        0.9696779847145081
      ],
      "plane_d": 322.3307800292969,
      "bbox_min": [
        1960.7476806640625,
        1991.3018798828125,
        373.5
      ],
      "bbox_max": [
        1969.79150390625,
        2001.74853515625,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24314555525779724,
        -0.10072041302919388,
        0.9647464752197266
      ],
      "plane_d": 318.69561767578125,
      "bbox_min": [
        1966.404541015625,
        1991.3018798828125,
        373.5
      ],
      "bbox_max": [
        1969.79150390625,
        1996.0916748046875,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.172814279794693,
        0.172814279794693,
        0.9696754217147827
      ],
      "plane_d": -1038.9276123046875,
      "bbox_min": [
        1936.8363037109375,
        1968.7935791015625,
        373.5
      ],
      "bbox_max": [
        1947.2822265625,
        1977.8370361328125,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10071741789579391,
        0.24314795434474945,
        0.9647461175918579
      ],
      "plane_d": -1035.6484375,
      "bbox_min": [
        1942.4931640625,
        1968.7935791015625,
        373.5
      ],
      "bbox_max": [
        1947.2822265625,
        1972.18017578125,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238711595535278,
        0.38270363211631775,
        0.0
      ],
      "plane_d": 1058.364501953125,
      "bbox_min": [
        1943.8958740234375,
        1968.4635009765625,
        373.0
      ],
      "bbox_max": [
        1970.121337890625,
        1994.6888427734375,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24313946068286896,
        0.10071789473295212,
        0.964748203754425
      ],
      "plane_d": -82.28109741210938,
      "bbox_min": [
        1943.8958740234375,
        1968.4635009765625,
        373.0
      ],
      "bbox_max": [
        1970.121337890625,
        1994.6888427734375,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24314555525779724,
        -0.10072041302919388,
        0.9647464752197266
      ],
      "plane_d": 318.69561767578125,
      "bbox_min": [
        1943.8958740234375,
        1968.4635009765625,
        373.0
      ],
      "bbox_max": [
        1970.121337890625,
        1994.6888427734375,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826812207698822,
        0.9238805770874023,
        0.0
      ],
      "plane_d": -1074.96484375,
      "bbox_min": [
        1945.684326171875,
        1970.4473876953125,
        373.0
      ],
      "bbox_max": [
        1952.262451171875,
        1972.18017578125,
        373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071144580841064,
        -0.707099199295044,
        0.0
      ],
      "plane_d": 2765.0,
      "bbox_min": [
        1935.351318359375,
        1966.363525390625,
        370.0
      ],
      "bbox_max": [
        1972.2213134765625,
        2001.74853515625,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38266777992248535,
        -0.9238860011100769,
        -0.0
      ],
      "plane_d": 2562.162841796875,
      "bbox_min": [
        1936.8363037109375,
        1966.363525390625,
        370.0
      ],
      "bbox_max": [
        1972.2213134765625,
        2001.74853515625,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2767.100341796875,
      "bbox_min": [
        1936.8363037109375,
        1966.363525390625,
        370.0
      ],
      "bbox_max": [
        1972.2213134765625,
        2001.74853515625,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        0.3826870620250702,
        -0.0
      ],
      "plane_d": -2583.832763671875,
      "bbox_min": [
        1942.4931640625,
        1966.363525390625,
        370.0
      ],
      "bbox_max": [
        1972.2213134765625,
        2001.74853515625,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2802.900146484375,
      "bbox_min": [
        1942.4931640625,
        1966.363525390625,
        370.0
      ],
      "bbox_max": [
        1972.2213134765625,
        2001.74853515625,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.382679283618927,
        0.9238812923431396,
        0.0
      ],
      "plane_d": -1073.1370849609375,
      "bbox_min": [
        1942.4931640625,
        1966.363525390625,
        370.0
      ],
      "bbox_max": [
        1972.2213134765625,
        1996.0916748046875,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238711595535278,
        0.38270363211631775,
        0.0
      ],
      "plane_d": 1058.364501953125,
      "bbox_min": [
        1942.4931640625,
        1968.4635009765625,
        370.0
      ],
      "bbox_max": [
        1972.2213134765625,
        1996.0916748046875,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        -0.3826870620250702,
        0.0
      ],
      "plane_d": -1060.351318359375,
      "bbox_min": [
        1971.392578125,
        1988.5047607421875,
        370.0
      ],
      "bbox_max": [
        1972.2213134765625,
        1990.505615234375,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238711595535278,
        -0.38270363211631775,
        -0.0
      ],
      "plane_d": 2581.912109375,
      "bbox_min": [
        1942.4931640625,
        1968.4635009765625,
        370.0
      ],
      "bbox_max": [
        1970.121337890625,
        1996.0916748046875,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826935589313507,
        0.9238753318786621,
        -0.0
      ],
      "plane_d": -2564.13232421875,
      "bbox_min": [
        1942.4931640625,
        1968.4635009765625,
        370.0
      ],
      "bbox_max": [
        1948.0791015625,
        1970.77734375,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2815.0,
      "bbox_min": [
        1970.70654296875,
        2006.0147705078125,
        370.0
      ],
      "bbox_max": [
        1974.996337890625,
        2010.3045654296875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -384.9999694824219,
      "bbox_min": [
        1970.70654296875,
        2006.0147705078125,
        385.0
      ],
      "bbox_max": [
        1974.996337890625,
        2012.847412109375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -1.0,
      "bbox_min": [
        1954.443115234375,
        1953.7359619140625,
        370.0
      ],
      "bbox_max": [
        1964.342529296875,
        1963.635498046875,
        410.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3162427842617035,
        0.3162318766117096,
        -0.8944204449653625
      ],
      "plane_d": 364.9449462890625,
      "bbox_min": [
        1954.443115234375,
        1953.7359619140625,
        370.0
      ],
      "bbox_max": [
        1964.342529296875,
        1963.635498046875,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31622567772865295,
        -0.31622567772865295,
        -0.8944286704063416
      ],
      "plane_d": 1601.9114990234375,
      "bbox_min": [
        1954.443115234375,
        1953.7359619140625,
        407.0
      ],
      "bbox_max": [
        1964.342529296875,
        1963.635498046875,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2776.000244140625,
      "bbox_min": [
        1962.2213134765625,
        1961.5142822265625,
        408.5
      ],
      "bbox_max": [
        1964.342529296875,
        1963.635498046875,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -372.9999694824219,
      "bbox_min": [
        1954.443115234375,
        1953.7359619140625,
        370.0
      ],
      "bbox_max": [
        1964.342529296875,
        1963.635498046875,
        373.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071012854576111,
        -0.7071123719215393,
        -0.0
      ],
      "plane_d": 2765.0,
      "bbox_min": [
        1954.443115234375,
        1953.7359619140625,
        370.0
      ],
      "bbox_max": [
        1964.342529296875,
        1963.635498046875,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2776.0,
      "bbox_min": [
        1962.2213134765625,
        1961.5142822265625,
        370.0
      ],
      "bbox_max": [
        1964.342529296875,
        1963.635498046875,
        373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2740.887451171875,
      "bbox_min": [
        1910.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.5000008344650269,
        0.5000008344650269,
        -0.7071056365966797
      ],
      "plane_d": -1665.2401123046875,
      "bbox_min": [
        1952.9219970703125,
        1865.19970703125,
        370.0
      ],
      "bbox_max": [
        2011.0001220703125,
        1929.09423828125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 665.0,
      "bbox_min": [
        1990.95947265625,
        1865.19970703125,
        385.88720703125
      ],
      "bbox_max": [
        2011.0001220703125,
        1919.341064453125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5985074639320374,
        0.19949905574321747,
        -0.7758795022964478
      ],
      "plane_d": -1272.865478515625,
      "bbox_min": [
        2007.4761962890625,
        1865.19970703125,
        390.0
      ],
      "bbox_max": [
        2011.0001220703125,
        1874.696533203125,
        390.8854675292969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1952.9219970703125,
        1865.19970703125,
        370.0
      ],
      "bbox_max": [
        2011.0001220703125,
        1929.09423828125,
        410.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2745.000244140625,
      "bbox_min": [
        1952.9219970703125,
        1865.8155517578125,
        370.0
      ],
      "bbox_max": [
        2010.38427734375,
        1929.09423828125,
        410.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 385.0,
      "bbox_min": [
        1969.212646484375,
        1865.8155517578125,
        370.0
      ],
      "bbox_max": [
        2010.38427734375,
        1909.8953857421875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486849308013916,
        0.3162228763103485,
        -0.0
      ],
      "plane_d": -2497.23486328125,
      "bbox_min": [
        2007.4761962890625,
        1865.8155517578125,
        385.0
      ],
      "bbox_max": [
        2010.38427734375,
        1874.5400390625,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486849308013916,
        0.3162228763103485,
        -0.0
      ],
      "plane_d": -2497.23486328125,
      "bbox_min": [
        1969.212646484375,
        1865.8155517578125,
        370.0
      ],
      "bbox_max": [
        2010.38427734375,
        1909.8953857421875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -44.0001220703125,
      "bbox_min": [
        1969.212646484375,
        1892.8450927734375,
        370.0
      ],
      "bbox_max": [
        1986.262939453125,
        1909.8953857421875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 64.0,
      "bbox_min": [
        1983.354736328125,
        1892.8450927734375,
        370.0
      ],
      "bbox_max": [
        1986.262939453125,
        1895.7532958984375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2760.000244140625,
      "bbox_min": [
        1981.4500732421875,
        1901.5142822265625,
        370.0
      ],
      "bbox_max": [
        2001.715087890625,
        1921.779296875,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -374.9999694824219,
      "bbox_min": [
        1981.4500732421875,
        1901.5142822265625,
        372.5
      ],
      "bbox_max": [
        2001.715087890625,
        1921.779296875,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2762.000244140625,
      "bbox_min": [
        1985.2537841796875,
        1905.314453125,
        372.5
      ],
      "bbox_max": [
        2000.743408203125,
        1920.8040771484375,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -372.5,
      "bbox_min": [
        1985.2537841796875,
        1905.314453125,
        372.5
      ],
      "bbox_max": [
        2000.743408203125,
        1920.8040771484375,
        372.7558898925781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2761.500244140625,
      "bbox_min": [
        1987.3236083984375,
        1910.9560546875,
        375.0
      ],
      "bbox_max": [
        1994.7481689453125,
        1918.3807373046875,
        381.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 377.0,
      "bbox_min": [
        1987.3236083984375,
        1910.9560546875,
        375.0
      ],
      "bbox_max": [
        1994.7481689453125,
        1918.3807373046875,
        381.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -381.0,
      "bbox_min": [
        1987.3236083984375,
        1910.9560546875,
        377.0
      ],
      "bbox_max": [
        1994.7481689453125,
        1918.3807373046875,
        381.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7072288393974304,
        0.7069846987724304,
        0.0
      ],
      "plane_d": 49.4766845703125,
      "bbox_min": [
        1987.3236083984375,
        1910.9560546875,
        377.0
      ],
      "bbox_max": [
        1994.7481689453125,
        1918.3807373046875,
        381.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -59.0,
      "bbox_min": [
        1994.3946533203125,
        1910.9560546875,
        377.0
      ],
      "bbox_max": [
        1994.7481689453125,
        1911.3095703125,
        381.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7069846987724304,
        0.7072288393974304,
        0.0
      ],
      "plane_d": 52.523193359375,
      "bbox_min": [
        1990.1519775390625,
        1913.7845458984375,
        375.0
      ],
      "bbox_max": [
        1991.9197998046875,
        1915.55224609375,
        377.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -55.0,
      "bbox_min": [
        1991.5662841796875,
        1913.7845458984375,
        375.0
      ],
      "bbox_max": [
        1991.9197998046875,
        1914.1380615234375,
        377.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 410.0,
      "bbox_min": [
        1990.959228515625,
        1911.0142822265625,
        383.940185546875
      ],
      "bbox_max": [
        1999.2861328125,
        1919.3411865234375,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7003609538078308,
        -0.6908634901046753,
        0.1794496476650238
      ],
      "plane_d": 2653.572998046875,
      "bbox_min": [
        1995.1832275390625,
        1915.3304443359375,
        383.940185546875
      ],
      "bbox_max": [
        1998.1826171875,
        1918.258056640625,
        388.3788757324219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14978842437267303,
        -0.16592545807361603,
        -0.9746959805488586
      ],
      "plane_d": 991.62646484375,
      "bbox_min": [
        1995.1832275390625,
        1915.3304443359375,
        383.940185546875
      ],
      "bbox_max": [
        1998.1826171875,
        1918.258056640625,
        388.3788757324219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4003014862537384,
        -0.1955672651529312,
        0.8952720165252686
      ],
      "plane_d": 826.9619140625,
      "bbox_min": [
        1995.1832275390625,
        1916.35888671875,
        384.2426452636719
      ],
      "bbox_max": [
        1997.9195556640625,
        1918.258056640625,
        388.3788757324219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5385398268699646,
        -0.7492015957832336,
        0.3855798542499542
      ],
      "plane_d": 2362.191650390625,
      "bbox_min": [
        1997.334716796875,
        1916.35888671875,
        387.7452087402344
      ],
      "bbox_max": [
        1997.9195556640625,
        1917.2242431640625,
        388.3355407714844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26008114218711853,
        -0.3875488340854645,
        0.8844002485275269
      ],
      "plane_d": 919.1375732421875,
      "bbox_min": [
        1997.334716796875,
        1916.584716796875,
        388.1034240722656
      ],
      "bbox_max": [
        1997.86181640625,
        1917.2242431640625,
        388.3355407714844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1910.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 2843.666748046875,
      "bbox_min": [
        1910.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1910.0,
        1830.0,
        980.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1910.0,
        1830.0,
        1130.0
      ],
      "bbox_max": [
        1971.7369384765625,
        1891.7369384765625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -103.09619140625,
      "bbox_min": [
        1975.800048828125,
        1830.0,
        980.0
      ],
      "bbox_max": [
        2011.0,
        1865.199951171875,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2710.887451171875,
      "bbox_min": [
        1910.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 666.0,
      "bbox_min": [
        1910.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        752.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42010071873664856,
        -0.9074774980545044,
        -0.0
      ],
      "plane_d": 2509.287353515625,
      "bbox_min": [
        1910.0,
        1830.0,
        666.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        752.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9086204171180725,
        -0.4176231622695923,
        -0.0
      ],
      "plane_d": 2545.69580078125,
      "bbox_min": [
        1910.0,
        1909.88671875,
        666.0
      ],
      "bbox_max": [
        1923.88671875,
        1940.0999755859375,
        752.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486849308013916,
        0.3162228763103485,
        -0.0
      ],
      "plane_d": -2497.23486328125,
      "bbox_min": [
        2010.38427734375,
        1859.912109375,
        370.0
      ],
      "bbox_max": [
        2012.35205078125,
        1865.8155517578125,
        390.3166809082031
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5985074639320374,
        0.19949905574321747,
        -0.7758795022964478
      ],
      "plane_d": -1272.865478515625,
      "bbox_min": [
        2010.38427734375,
        1859.912109375,
        390.0
      ],
      "bbox_max": [
        2012.35205078125,
        1865.8155517578125,
        390.3166809082031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1910.0,
        1830.0,
        1130.0
      ],
      "bbox_max": [
        1913.6175537109375,
        1833.6175537109375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2646.3251953125,
      "bbox_min": [
        1910.0,
        1830.0,
        375.0
      ],
      "bbox_max": [
        1912.4688720703125,
        1832.4688720703125,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -379.9999694824219,
      "bbox_min": [
        1910.0,
        1830.0,
        380.0
      ],
      "bbox_max": [
        1912.4688720703125,
        1832.4688720703125,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1770.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        1910.0,
        2050.0,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2040.0,
      "bbox_min": [
        1770.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        1910.0,
        2050.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -390.0,
      "bbox_min": [
        1770.0,
        2040.0,
        390.0
      ],
      "bbox_max": [
        1910.0,
        2050.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1770.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        1910.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1770.0,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1912.11669921875,
        1130.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.25882136821746826,
        -0.9659252762794495,
        6.868348805255664e-07
      ],
      "plane_d": 1310.7298583984375,
      "bbox_min": [
        1784.3255615234375,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1892.9427490234375,
        1852.0001220703125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        6.103515625e-05,
        0.0
      ],
      "plane_d": 1839.88720703125,
      "bbox_min": [
        1840.0001220703125,
        1850.0001220703125,
        1106.0
      ],
      "bbox_max": [
        1840.000244140625,
        1852.0001220703125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588171064853668,
        -0.9659263491630554,
        6.86823625528632e-07
      ],
      "plane_d": 2263.186767578125,
      "bbox_min": [
        1784.3255615234375,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1892.9427490234375,
        1850.0001220703125,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660261034965515,
        -0.4999989867210388,
        0.0
      ],
      "plane_d": -713.4900512695312,
      "bbox_min": [
        1852.5001220703125,
        1837.9423828125,
        1106.0
      ],
      "bbox_max": [
        1886.000244140625,
        1848.516845703125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1852.5001220703125,
        1841.2918701171875,
        1110.0
      ],
      "bbox_max": [
        1873.0001220703125,
        1848.516845703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659256935119629,
        -0.2588197886943817,
        0.0
      ],
      "plane_d": -1332.1331787109375,
      "bbox_min": [
        1872.5001220703125,
        1841.2918701171875,
        1110.0
      ],
      "bbox_max": [
        1873.0001220703125,
        1843.157958984375,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 30.360889434814453,
      "bbox_min": [
        1784.3255615234375,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1892.9427490234375,
        1846.6510009765625,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2555.9375,
      "bbox_min": [
        1784.3255615234375,
        1830.0,
        1110.0
      ],
      "bbox_max": [
        1784.6409912109375,
        1830.15771484375,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1784.3255615234375,
        1830.0,
        1110.0
      ],
      "bbox_max": [
        1784.6409912109375,
        1830.15771484375,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 2632.51416015625,
      "bbox_min": [
        1848.03857421875,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1892.9427490234375,
        1846.6510009765625,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1848.03857421875,
        1830.0,
        1110.0
      ],
      "bbox_max": [
        1872.5001220703125,
        1846.6510009765625,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659256935119629,
        -0.2588197886943817,
        0.0
      ],
      "plane_d": -1332.1331787109375,
      "bbox_min": [
        1869.4744873046875,
        1830.0,
        1110.0
      ],
      "bbox_max": [
        1872.5001220703125,
        1841.2918701171875,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -383.0,
      "bbox_min": [
        1770.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        1910.0,
        1896.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881683826446533,
        0.9659264087677002,
        0.0
      ],
      "plane_d": -2296.994140625,
      "bbox_min": [
        1770.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        1910.0,
        1884.9998779296875,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881779193878174,
        0.9659262299537659,
        0.0
      ],
      "plane_d": -1344.546142578125,
      "bbox_min": [
        1770.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        1910.0,
        1884.9998779296875,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -375.0,
      "bbox_min": [
        1770.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        1910.0,
        1884.9998779296875,
        383.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2666.3251953125,
      "bbox_min": [
        1770.0,
        1860.753173828125,
        370.0
      ],
      "bbox_max": [
        1910.0,
        1868.253173828125,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -64.172119140625,
      "bbox_min": [
        1770.0,
        1860.753173828125,
        370.0
      ],
      "bbox_max": [
        1777.5,
        1868.253173828125,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588185966014862,
        0.965925931930542,
        0.0
      ],
      "plane_d": -1324.544189453125,
      "bbox_min": [
        1770.0,
        1830.0,
        375.0
      ],
      "bbox_max": [
        1910.0,
        1864.29443359375,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588185966014862,
        0.965925931930542,
        -0.0
      ],
      "plane_d": -2276.99658203125,
      "bbox_min": [
        1770.0,
        1830.0,
        375.0
      ],
      "bbox_max": [
        1910.0,
        1864.29443359375,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -379.9999694824219,
      "bbox_min": [
        1770.0,
        1830.0,
        375.0
      ],
      "bbox_max": [
        1910.0,
        1864.29443359375,
        383.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -44.1722412109375,
      "bbox_min": [
        1770.0,
        1832.4688720703125,
        375.0
      ],
      "bbox_max": [
        1910.0,
        1850.3216552734375,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2646.3251953125,
      "bbox_min": [
        1892.147216796875,
        1832.4688720703125,
        375.0
      ],
      "bbox_max": [
        1910.0,
        1850.3216552734375,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588140070438385,
        0.965927243232727,
        -0.0
      ],
      "plane_d": -2261.990234375,
      "bbox_min": [
        1788.7442626953125,
        1830.0,
        380.0
      ],
      "bbox_max": [
        1891.2557373046875,
        1848.76513671875,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881531834602356,
        0.9659268260002136,
        0.0
      ],
      "plane_d": -1309.5516357421875,
      "bbox_min": [
        1788.7442626953125,
        1830.0,
        380.0
      ],
      "bbox_max": [
        1891.2557373046875,
        1848.76513671875,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -29.172119140625,
      "bbox_min": [
        1788.7442626953125,
        1830.0,
        380.0
      ],
      "bbox_max": [
        1891.2557373046875,
        1836.873046875,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588140070438385,
        0.965927243232727,
        -0.0
      ],
      "plane_d": -2261.990234375,
      "bbox_min": [
        1788.7442626953125,
        1830.0,
        383.0
      ],
      "bbox_max": [
        1891.2557373046875,
        1848.76513671875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881531834602356,
        0.9659268260002136,
        0.0
      ],
      "plane_d": -1309.5516357421875,
      "bbox_min": [
        1788.7442626953125,
        1830.0,
        383.0
      ],
      "bbox_max": [
        1891.2557373046875,
        1848.76513671875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.258817195892334,
        -0.9659264087677002,
        0.0
      ],
      "plane_d": 1304.5474853515625,
      "bbox_min": [
        1788.7442626953125,
        1830.0,
        383.0
      ],
      "bbox_max": [
        1891.2557373046875,
        1843.5888671875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -29.172119140625,
      "bbox_min": [
        1788.7442626953125,
        1830.0,
        383.0
      ],
      "bbox_max": [
        1795.6173095703125,
        1836.873046875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.258817195892334,
        -0.9659264087677002,
        -0.0
      ],
      "plane_d": 2256.99462890625,
      "bbox_min": [
        1795.8153076171875,
        1830.0,
        383.0
      ],
      "bbox_max": [
        1891.2557373046875,
        1843.5888671875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2631.3251953125,
      "bbox_min": [
        1884.3826904296875,
        1830.0,
        383.0
      ],
      "bbox_max": [
        1891.2557373046875,
        1836.873046875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 24.1722412109375,
      "bbox_min": [
        1795.8153076171875,
        1830.0,
        383.0
      ],
      "bbox_max": [
        1884.1846923828125,
        1832.39013671875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2626.3251953125,
      "bbox_min": [
        1881.7945556640625,
        1830.0,
        383.0
      ],
      "bbox_max": [
        1884.1846923828125,
        1832.39013671875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588140070438385,
        0.965927243232727,
        -0.0
      ],
      "plane_d": -2261.990234375,
      "bbox_min": [
        1770.0,
        1830.0,
        385.0
      ],
      "bbox_max": [
        1910.0,
        1896.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881531834602356,
        0.9659268260002136,
        0.0
      ],
      "plane_d": -1309.5516357421875,
      "bbox_min": [
        1788.7442626953125,
        1830.0,
        385.0
      ],
      "bbox_max": [
        1891.2557373046875,
        1848.76513671875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -390.0,
      "bbox_min": [
        1788.7442626953125,
        1830.0,
        385.0
      ],
      "bbox_max": [
        1891.2557373046875,
        1848.76513671875,
        390.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.258817195892334,
        -0.9659264087677002,
        0.0
      ],
      "plane_d": 1304.5474853515625,
      "bbox_min": [
        1788.7442626953125,
        1830.0,
        385.0
      ],
      "bbox_max": [
        1891.2557373046875,
        1843.5888671875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.258817195892334,
        -0.9659264087677002,
        -0.0
      ],
      "plane_d": 2256.99462890625,
      "bbox_min": [
        1795.8153076171875,
        1830.0,
        385.0
      ],
      "bbox_max": [
        1891.2557373046875,
        1843.5888671875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2631.3251953125,
      "bbox_min": [
        1884.3826904296875,
        1830.0,
        385.0
      ],
      "bbox_max": [
        1891.2557373046875,
        1836.873046875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 24.1722412109375,
      "bbox_min": [
        1795.8153076171875,
        1830.0,
        385.0
      ],
      "bbox_max": [
        1884.1846923828125,
        1832.39013671875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2626.3251953125,
      "bbox_min": [
        1881.7945556640625,
        1830.0,
        385.0
      ],
      "bbox_max": [
        1884.1846923828125,
        1832.39013671875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 637.0455932617188,
      "bbox_min": [
        1770.0,
        1895.4892578125,
        1059.422119140625
      ],
      "bbox_max": [
        1910.0,
        1896.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2592.253662109375,
      "bbox_min": [
        1770.0,
        1895.74462890625,
        1059.422119140625
      ],
      "bbox_max": [
        1770.25537109375,
        1896.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 2843.666748046875,
      "bbox_min": [
        1909.74462890625,
        1895.4892578125,
        1059.422119140625
      ],
      "bbox_max": [
        1910.0,
        1896.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1689.9998779296875,
      "bbox_min": [
        -903.2229614257812,
        -2564.65576171875,
        159.59542846679688
      ],
      "bbox_max": [
        2130.0,
        1830.0,
        1733.090087890625
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        1.0,
        -1.1107383670605486e-06,
        0.0
      ],
      "plane_d": -1769.998291015625,
      "bbox_min": [
        -903.2229614257812,
        -2564.65576171875,
        159.59542846679688
      ],
      "bbox_max": [
        2020.0,
        1690.0,
        1733.090087890625
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.9688323736190796,
        0.24771738052368164,
        0.0
      ],
      "plane_d": -2026.9039306640625,
      "bbox_min": [
        -903.2229614257812,
        -2564.65576171875,
        159.59542846679688
      ],
      "bbox_max": [
        1770.0001220703125,
        1690.0,
        1733.090087890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1539.9998779296875,
      "bbox_min": [
        -903.2229614257812,
        -2564.65576171875,
        159.59542846679688
      ],
      "bbox_max": [
        1760.0,
        1690.0,
        1733.090087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1389.9998779296875,
      "bbox_min": [
        -903.2229614257812,
        -2564.65576171875,
        159.59542846679688
      ],
      "bbox_max": [
        1760.0,
        1540.0,
        1733.090087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1180.0,
      "bbox_min": [
        -903.2229614257812,
        -2564.65576171875,
        159.59542846679688
      ],
      "bbox_max": [
        1760.0,
        1390.0,
        1733.090087890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -903.2229614257812,
        -2564.65576171875,
        269.79852294921875
      ],
      "bbox_max": [
        1174.504638671875,
        1390.0,
        1733.090087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -825.0,
        -2564.65576171875,
        1547.9334716796875
      ],
      "bbox_max": [
        -575.9976806640625,
        -2275.0,
        1733.090087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.707107663154602,
        -0.7071059346199036,
        0.0
      ],
      "plane_d": 130.95574951171875,
      "bbox_min": [
        582.7122802734375,
        1310.2095947265625,
        269.79852294921875
      ],
      "bbox_max": [
        1174.504638671875,
        1390.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -1791.95849609375,
      "bbox_min": [
        582.7122802734375,
        1346.4150390625,
        269.79852294921875
      ],
      "bbox_max": [
        1174.504638671875,
        1390.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877842307090759,
        0.8090178370475769,
        -0.0
      ],
      "plane_d": -1500.44677734375,
      "bbox_min": [
        582.7122802734375,
        1346.4150390625,
        269.79852294921875
      ],
      "bbox_max": [
        699.5303955078125,
        1384.3714599609375,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1384.3714599609375,
      "bbox_min": [
        582.7122802734375,
        1384.3714599609375,
        273.3889465332031
      ],
      "bbox_max": [
        647.2877197265625,
        1384.3714599609375,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 91.9239501953125,
      "bbox_min": [
        1180.0,
        940.0,
        159.59542846679688
      ],
      "bbox_max": [
        1760.0,
        1390.0,
        777.8890380859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        9.390024615640868e-07,
        -0.0
      ],
      "plane_d": -1630.0013427734375,
      "bbox_min": [
        1420.0,
        940.0,
        159.59542846679688
      ],
      "bbox_max": [
        1760.0,
        1390.0,
        777.8890380859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": -1494.5458984375,
      "bbox_min": [
        1420.0,
        940.0,
        159.59542846679688
      ],
      "bbox_max": [
        1615.0,
        1130.0,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": -1414.94287109375,
      "bbox_min": [
        1420.0,
        940.0,
        159.59542846679688
      ],
      "bbox_max": [
        1615.0,
        1130.0,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        1420.0,
        960.0,
        171.21868896484375
      ],
      "bbox_max": [
        1535.0,
        1130.0,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1430.0,
      "bbox_min": [
        1420.0,
        960.0,
        465.0
      ],
      "bbox_max": [
        1525.0,
        1100.0,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        1420.0,
        1050.0,
        515.0
      ],
      "bbox_max": [
        1430.0,
        1050.0,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1510.0,
      "bbox_min": [
        1445.0,
        960.0,
        465.0
      ],
      "bbox_max": [
        1525.0,
        1100.0,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1445.0,
      "bbox_min": [
        1445.0,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1510.0,
        1100.0,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1485.0,
        1050.0,
        465.0
      ],
      "bbox_max": [
        1510.0,
        1100.0,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        1500.0,
        1050.0,
        515.0
      ],
      "bbox_max": [
        1510.0,
        1050.0,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1525.0,
      "bbox_min": [
        1510.0,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1525.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1510.0,
        1100.0,
        465.0
      ],
      "bbox_max": [
        1525.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        1535.0,
        940.0,
        159.59542846679688
      ],
      "bbox_max": [
        1615.0,
        1130.0,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1535.0,
      "bbox_min": [
        1535.0,
        940.0,
        171.2186737060547
      ],
      "bbox_max": [
        1605.0,
        1130.0,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1590.0,
      "bbox_min": [
        1565.0,
        940.0,
        390.0
      ],
      "bbox_max": [
        1605.0,
        1100.0,
        530.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1565.0,
        1050.0,
        465.0
      ],
      "bbox_max": [
        1590.0,
        1100.0,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        1580.0,
        1050.0,
        515.0
      ],
      "bbox_max": [
        1590.0,
        1050.0,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1605.0,
      "bbox_min": [
        1590.0,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1605.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1590.0,
        1100.0,
        465.0
      ],
      "bbox_max": [
        1605.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1615.0,
      "bbox_min": [
        1615.0,
        1030.0,
        159.59542846679688
      ],
      "bbox_max": [
        1615.0,
        1130.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1760.0,
      "bbox_min": [
        1700.0,
        998.5078125,
        325.0
      ],
      "bbox_max": [
        1760.0,
        1210.0,
        430.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": -1534.4217529296875,
      "bbox_min": [
        1700.0,
        998.5078125,
        325.0
      ],
      "bbox_max": [
        1760.0,
        1210.0,
        430.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1210.0,
      "bbox_min": [
        1700.0,
        1087.36865234375,
        325.0
      ],
      "bbox_max": [
        1760.0,
        1210.0,
        430.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 356.4822998046875,
      "bbox_min": [
        1700.0,
        1087.36865234375,
        325.0
      ],
      "bbox_max": [
        1760.0,
        1210.0,
        430.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2090.107421875,
      "bbox_min": [
        1700.0,
        1087.36865234375,
        325.0
      ],
      "bbox_max": [
        1760.0,
        1210.0,
        430.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9878292083740234,
        0.15554292500019073,
        0.0
      ],
      "plane_d": -1900.30322265625,
      "bbox_min": [
        1700.0,
        1087.36865234375,
        400.0
      ],
      "bbox_max": [
        1760.0,
        1210.0,
        430.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9878292083740234,
        -0.15554292500019073,
        0.0
      ],
      "plane_d": -1547.220703125,
      "bbox_min": [
        1700.0,
        1087.36865234375,
        400.0
      ],
      "bbox_max": [
        1745.0,
        1210.0,
        430.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1182.63134765625,
      "bbox_min": [
        1700.0,
        1182.63134765625,
        400.0
      ],
      "bbox_max": [
        1737.5,
        1210.0,
        430.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -1145.512939453125,
      "bbox_min": [
        1700.0,
        1191.7158203125,
        410.0
      ],
      "bbox_max": [
        1734.7652587890625,
        1210.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000008344650269,
        0.5000008344650269,
        0.7071056365966797
      ],
      "plane_d": -37.841888427734375,
      "bbox_min": [
        1700.0,
        1191.7158203125,
        410.0
      ],
      "bbox_max": [
        1718.2841796875,
        1210.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000008344650269,
        0.5000008344650269,
        0.7071056365966797
      ],
      "plane_d": -1767.8447265625,
      "bbox_min": [
        1733.1905517578125,
        1191.7158203125,
        410.0
      ],
      "bbox_max": [
        1760.0,
        1210.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -1145.512939453125,
      "bbox_min": [
        1733.1905517578125,
        1200.0,
        410.0
      ],
      "bbox_max": [
        1745.85791015625,
        1210.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9878292083740234,
        0.15554292500019073,
        0.0
      ],
      "plane_d": -1900.30322265625,
      "bbox_min": [
        1740.0,
        1103.24609375,
        425.0
      ],
      "bbox_max": [
        1745.0,
        1166.75390625,
        430.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9878292083740234,
        -0.15554292500019073,
        0.0
      ],
      "plane_d": -1547.220703125,
      "bbox_min": [
        1740.0,
        1103.24609375,
        425.0
      ],
      "bbox_max": [
        1745.0,
        1135.0,
        430.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -21.2132568359375,
      "bbox_min": [
        1180.0,
        1320.0,
        160.5279998779297
      ],
      "bbox_max": [
        1420.0,
        1390.0,
        629.3965454101562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1374.9998779296875,
      "bbox_min": [
        1180.0,
        1375.0,
        194.07266235351562
      ],
      "bbox_max": [
        1200.0,
        1375.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1180.0,
      "bbox_min": [
        1125.0072021484375,
        1390.0,
        160.0
      ],
      "bbox_max": [
        1630.0,
        1540.0,
        784.9600830078125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 223.29595947265625,
      "bbox_min": [
        1125.0072021484375,
        1390.0,
        190.92684936523438
      ],
      "bbox_max": [
        1174.504638671875,
        1539.7904052734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.707107663154602,
        0.7071059346199036,
        0.0
      ],
      "plane_d": -1884.296142578125,
      "bbox_min": [
        1125.0072021484375,
        1490.2928466796875,
        440.0
      ],
      "bbox_max": [
        1174.504638671875,
        1539.7904052734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -1791.95849609375,
      "bbox_min": [
        1125.0072021484375,
        1390.0,
        190.92684936523438
      ],
      "bbox_max": [
        1160.0,
        1460.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1160.0,
      "bbox_min": [
        1160.0,
        1390.0,
        190.92684936523438
      ],
      "bbox_max": [
        1160.0,
        1460.0,
        440.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        1180.0,
        1390.0,
        160.0
      ],
      "bbox_max": [
        1630.0,
        1540.0,
        784.9600830078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 91.9239501953125,
      "bbox_min": [
        1420.0,
        1390.0,
        160.0
      ],
      "bbox_max": [
        1630.0,
        1400.0,
        784.9600830078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        9.390024615640868e-07,
        -0.0
      ],
      "plane_d": -1630.0013427734375,
      "bbox_min": [
        1630.0,
        1390.0,
        160.0
      ],
      "bbox_max": [
        1630.0,
        1400.0,
        784.9600830078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -21.2132568359375,
      "bbox_min": [
        1420.0,
        1390.0,
        160.0
      ],
      "bbox_max": [
        1430.0,
        1400.0,
        643.5386962890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        1180.0,
        1400.0,
        160.0
      ],
      "bbox_max": [
        1480.0,
        1540.0,
        777.8890380859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1180.0,
        1400.0,
        160.0
      ],
      "bbox_max": [
        1480.0,
        1525.0,
        714.2493896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1524.9998779296875,
      "bbox_min": [
        1180.0,
        1525.0,
        178.2655029296875
      ],
      "bbox_max": [
        1200.0,
        1525.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -21.2132568359375,
      "bbox_min": [
        1430.0,
        1400.0,
        160.0
      ],
      "bbox_max": [
        1480.0,
        1450.0,
        714.2493896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1550.0,
      "bbox_min": [
        1090.0,
        1540.0,
        160.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        784.9600830078125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        1160.0,
        1540.0,
        160.0
      ],
      "bbox_max": [
        1480.0,
        1550.0,
        784.9600830078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1160.0,
      "bbox_min": [
        1160.0,
        1540.0,
        181.44256591796875
      ],
      "bbox_max": [
        1160.0,
        1550.0,
        440.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        1148.2298583984375,
        1630.0,
        261.0
      ],
      "bbox_max": [
        1350.0,
        1690.0,
        440.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -395.0,
      "bbox_min": [
        1164.2298583984375,
        1630.0,
        261.0
      ],
      "bbox_max": [
        1350.0,
        1690.0,
        440.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1350.0,
      "bbox_min": [
        1342.0,
        1630.0,
        261.0
      ],
      "bbox_max": [
        1350.0,
        1690.0,
        395.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.0,
        0.44721364974975586
      ],
      "plane_d": -1376.9708251953125,
      "bbox_min": [
        1342.0,
        1630.0,
        379.0
      ],
      "bbox_max": [
        1350.0,
        1690.0,
        395.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1685.0,
      "bbox_min": [
        1169.199951171875,
        1630.0,
        395.0
      ],
      "bbox_max": [
        1342.0,
        1690.0,
        440.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.0,
        0.44721364974975586
      ],
      "plane_d": -1376.9708251953125,
      "bbox_min": [
        1184.2298583984375,
        1630.0,
        395.0
      ],
      "bbox_max": [
        1342.0,
        1685.0,
        440.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826870620250702,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1017.6668701171875,
      "bbox_min": [
        1300.0,
        1640.0,
        429.0
      ],
      "bbox_max": [
        1320.0,
        1674.14208984375,
        440.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        0.3826870620250702,
        0.0
      ],
      "plane_d": -1854.779541015625,
      "bbox_min": [
        1314.14208984375,
        1645.85791015625,
        429.0
      ],
      "bbox_max": [
        1320.0,
        1674.14208984375,
        440.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        -0.3826870620250702,
        0.0
      ],
      "plane_d": -584.258544921875,
      "bbox_min": [
        1314.14208984375,
        1645.85791015625,
        429.0
      ],
      "bbox_max": [
        1320.0,
        1660.0,
        440.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        0.3826870620250702,
        0.0
      ],
      "plane_d": -1854.779541015625,
      "bbox_min": [
        1319.5,
        1658.792724609375,
        438.9999084472656
      ],
      "bbox_max": [
        1320.0,
        1661.207275390625,
        440.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238780736923218,
        -0.3826870620250702,
        0.0
      ],
      "plane_d": -584.258544921875,
      "bbox_min": [
        1319.5,
        1658.792724609375,
        438.9999084472656
      ],
      "bbox_max": [
        1320.0,
        1660.0,
        440.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.0,
        0.44721364974975586
      ],
      "plane_d": -1376.9708251953125,
      "bbox_min": [
        1332.0,
        1685.0,
        395.0
      ],
      "bbox_max": [
        1342.0,
        1690.0,
        415.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2483755201101303,
        0.9686638712882996,
        0.0
      ],
      "plane_d": -1970.0167236328125,
      "bbox_min": [
        1659.9998779296875,
        1420.0,
        170.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1689.9998779296875,
        1150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        6.781730462535052e-06,
        1.0,
        0.0
      ],
      "plane_d": -1532.511962890625,
      "bbox_min": [
        1729.9998779296875,
        1420.0,
        170.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1552.5,
        400.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1735.0,
      "bbox_min": [
        1729.9998779296875,
        1420.0,
        280.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1532.5,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 392.0,
      "bbox_min": [
        1729.9998779296875,
        1490.0,
        370.0
      ],
      "bbox_max": [
        1735.0,
        1530.5,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1729.9998779296875,
        1490.0,
        370.0
      ],
      "bbox_max": [
        1735.0,
        1530.5,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1730.0,
      "bbox_min": [
        1729.9998779296875,
        1490.0,
        370.0
      ],
      "bbox_max": [
        1735.0,
        1530.5,
        392.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3775233328342438,
        -0.9260000586509705,
        0.0
      ],
      "plane_d": 759.682861328125,
      "bbox_min": [
        1729.9998779296875,
        1490.0,
        370.0
      ],
      "bbox_max": [
        1735.0,
        1530.5,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9166505932807922,
        -0.3996894955635071,
        0.0
      ],
      "plane_d": -978.6640014648438,
      "bbox_min": [
        1733.5355224609375,
        1527.141357421875,
        370.0
      ],
      "bbox_max": [
        1735.0,
        1530.5,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1490.0,
      "bbox_min": [
        1729.9998779296875,
        1490.0,
        370.0
      ],
      "bbox_max": [
        1735.0,
        1514.0001220703125,
        392.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1502.0,
      "bbox_min": [
        1729.9998779296875,
        1493.9998779296875,
        370.0
      ],
      "bbox_max": [
        1735.0,
        1514.0001220703125,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.00012205541133880615,
        -1.0,
        0.0
      ],
      "plane_d": 1509.7886962890625,
      "bbox_min": [
        1729.9998779296875,
        1502.0,
        370.0
      ],
      "bbox_max": [
        1735.0,
        1514.0001220703125,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.00012208521366119385,
        1.0,
        0.0
      ],
      "plane_d": -1514.2113037109375,
      "bbox_min": [
        1729.9998779296875,
        1509.9998779296875,
        370.0
      ],
      "bbox_max": [
        1735.0,
        1514.0001220703125,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -380.0,
      "bbox_min": [
        1729.9998779296875,
        1509.9998779296875,
        370.0
      ],
      "bbox_max": [
        1735.0,
        1514.0001220703125,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1731.0,
      "bbox_min": [
        1729.9998779296875,
        1509.9998779296875,
        370.0
      ],
      "bbox_max": [
        1731.0,
        1514.0001220703125,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 374.0,
      "bbox_min": [
        1729.9998779296875,
        1509.9998779296875,
        370.0
      ],
      "bbox_max": [
        1731.0,
        1514.0001220703125,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1730.5,
      "bbox_min": [
        1730.0,
        1511.5,
        370.0
      ],
      "bbox_max": [
        1730.5,
        1512.5,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1511.5,
      "bbox_min": [
        1730.0,
        1511.5,
        370.0
      ],
      "bbox_max": [
        1730.5,
        1512.5,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1512.5,
      "bbox_min": [
        1730.0,
        1512.5,
        370.0
      ],
      "bbox_max": [
        1730.5,
        1512.5,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1511.5,
      "bbox_min": [
        1730.0,
        1511.5,
        380.0
      ],
      "bbox_max": [
        1735.0,
        1512.5,
        392.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1512.5,
      "bbox_min": [
        1730.0,
        1511.5,
        380.0
      ],
      "bbox_max": [
        1735.0,
        1512.5,
        392.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1730.5,
      "bbox_min": [
        1730.5,
        1511.5,
        380.0
      ],
      "bbox_max": [
        1735.0,
        1512.5,
        391.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -948.583740234375,
      "bbox_min": [
        1730.5,
        1511.5,
        389.0
      ],
      "bbox_max": [
        1735.0,
        1512.5,
        391.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 391.5,
      "bbox_min": [
        1733.0,
        1511.5,
        391.5
      ],
      "bbox_max": [
        1735.0,
        1512.5,
        391.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.00012208521366119385,
        1.0,
        0.0
      ],
      "plane_d": -1506.211181640625,
      "bbox_min": [
        1729.9998779296875,
        1502.0,
        370.0
      ],
      "bbox_max": [
        1735.0,
        1506.0,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -380.0,
      "bbox_min": [
        1729.9998779296875,
        1502.0,
        370.0
      ],
      "bbox_max": [
        1735.0,
        1506.0,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        3.0518509447574615e-05,
        0.0
      ],
      "plane_d": -1731.0458984375,
      "bbox_min": [
        1729.9998779296875,
        1502.0,
        370.0
      ],
      "bbox_max": [
        1731.0,
        1506.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 374.0,
      "bbox_min": [
        1729.9998779296875,
        1502.0,
        370.0
      ],
      "bbox_max": [
        1731.0,
        1506.0,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.00012208521366119385,
        0.0
      ],
      "plane_d": -1730.6837158203125,
      "bbox_min": [
        1729.9998779296875,
        1503.4998779296875,
        370.0
      ],
      "bbox_max": [
        1730.5001220703125,
        1504.5,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.00048804288962855935,
        -0.9999998807907104,
        0.0
      ],
      "plane_d": 1502.6553955078125,
      "bbox_min": [
        1729.9998779296875,
        1503.4998779296875,
        370.0
      ],
      "bbox_max": [
        1730.5001220703125,
        1504.5,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1504.5,
      "bbox_min": [
        1730.0,
        1504.5,
        370.0
      ],
      "bbox_max": [
        1730.5,
        1504.5,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.00048804288962855935,
        -0.9999998807907104,
        0.0
      ],
      "plane_d": 1502.6553955078125,
      "bbox_min": [
        1729.9998779296875,
        1503.4998779296875,
        380.0
      ],
      "bbox_max": [
        1735.0,
        1504.5001220703125,
        392.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1504.5,
      "bbox_min": [
        1730.0,
        1503.5,
        380.0
      ],
      "bbox_max": [
        1735.0,
        1504.5001220703125,
        392.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.00012208521366119385,
        0.0
      ],
      "plane_d": -1730.6837158203125,
      "bbox_min": [
        1730.5,
        1503.5,
        380.0
      ],
      "bbox_max": [
        1735.0,
        1504.5001220703125,
        391.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071240544319153,
        8.632938988739625e-05,
        -0.7070895433425903
      ],
      "plane_d": -948.750244140625,
      "bbox_min": [
        1730.5,
        1503.5,
        389.0
      ],
      "bbox_max": [
        1735.0,
        1504.5001220703125,
        391.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 391.5,
      "bbox_min": [
        1733.0,
        1503.5,
        391.5
      ],
      "bbox_max": [
        1735.0,
        1504.5001220703125,
        391.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.00012205541133880615,
        -1.0,
        0.0
      ],
      "plane_d": 1493.7886962890625,
      "bbox_min": [
        1729.9998779296875,
        1493.9998779296875,
        370.0
      ],
      "bbox_max": [
        1735.0,
        1498.0001220703125,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0001220703125,
        1.0,
        0.0
      ],
      "plane_d": -1498.2113037109375,
      "bbox_min": [
        1729.9998779296875,
        1493.9998779296875,
        370.0
      ],
      "bbox_max": [
        1735.0,
        1498.0001220703125,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -380.0,
      "bbox_min": [
        1729.9998779296875,
        1493.9998779296875,
        370.0
      ],
      "bbox_max": [
        1735.0,
        1498.0001220703125,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1731.0,
      "bbox_min": [
        1729.9998779296875,
        1493.9998779296875,
        370.0
      ],
      "bbox_max": [
        1731.0,
        1498.0001220703125,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 374.0,
      "bbox_min": [
        1729.9998779296875,
        1493.9998779296875,
        370.0
      ],
      "bbox_max": [
        1731.0,
        1498.0001220703125,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0001220703125,
        -0.0
      ],
      "plane_d": -1730.6826171875,
      "bbox_min": [
        1730.0,
        1495.5,
        370.0
      ],
      "bbox_max": [
        1730.5,
        1496.5,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1495.5,
      "bbox_min": [
        1730.0,
        1495.5,
        370.0
      ],
      "bbox_max": [
        1730.5,
        1496.5,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1496.5,
      "bbox_min": [
        1730.0,
        1496.5,
        370.0
      ],
      "bbox_max": [
        1730.4998779296875,
        1496.5,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1495.5,
      "bbox_min": [
        1730.0,
        1495.5,
        380.0
      ],
      "bbox_max": [
        1735.0,
        1496.5,
        392.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1496.5,
      "bbox_min": [
        1730.0,
        1495.5,
        380.0
      ],
      "bbox_max": [
        1735.0,
        1496.5,
        392.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0001220703125,
        -0.0
      ],
      "plane_d": -1730.6826171875,
      "bbox_min": [
        1730.4998779296875,
        1495.5,
        380.0
      ],
      "bbox_max": [
        1735.0,
        1496.5,
        391.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -948.583740234375,
      "bbox_min": [
        1730.4998779296875,
        1495.5,
        389.0
      ],
      "bbox_max": [
        1735.0,
        1496.5,
        391.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 391.5,
      "bbox_min": [
        1733.0,
        1495.5,
        391.5
      ],
      "bbox_max": [
        1735.0,
        1496.5,
        391.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1420.0,
      "bbox_min": [
        1735.0,
        1420.0,
        280.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1532.5,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 392.0,
      "bbox_min": [
        1735.0,
        1490.0,
        370.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1532.5,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1735.0,
        1490.0,
        370.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1532.5,
        392.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -3.014090907527134e-06,
        -0.0
      ],
      "plane_d": 1768.0045166015625,
      "bbox_min": [
        1735.0,
        1490.0,
        370.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1532.5,
        392.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1500.0,
      "bbox_min": [
        1768.0,
        1500.0,
        370.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1510.0,
        382.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1510.0,
      "bbox_min": [
        1768.0,
        1500.0,
        370.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1510.0,
        382.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 382.0,
      "bbox_min": [
        1768.0,
        1500.0,
        382.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1510.0,
        382.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1490.0,
      "bbox_min": [
        1735.0,
        1490.0,
        370.0
      ],
      "bbox_max": [
        1768.0001220703125,
        1532.5,
        392.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        6.975495125516318e-06,
        1.0,
        -0.0
      ],
      "plane_d": -1504.51220703125,
      "bbox_min": [
        1735.0,
        1495.5,
        370.0
      ],
      "bbox_max": [
        1768.0001220703125,
        1532.5,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1496.5,
      "bbox_min": [
        1735.0,
        1495.5,
        391.5
      ],
      "bbox_max": [
        1768.0001220703125,
        1504.5001220703125,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 391.5,
      "bbox_min": [
        1735.0,
        1495.5,
        391.5
      ],
      "bbox_max": [
        1768.0001220703125,
        1496.5,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1495.5,
      "bbox_min": [
        1735.0,
        1495.5,
        391.5
      ],
      "bbox_max": [
        1768.0001220703125,
        1495.5,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 391.5,
      "bbox_min": [
        1735.0,
        1503.5,
        391.5
      ],
      "bbox_max": [
        1768.0,
        1504.5001220703125,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1503.5,
      "bbox_min": [
        1735.0,
        1503.5,
        391.5
      ],
      "bbox_max": [
        1768.0,
        1503.5,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 391.5,
      "bbox_min": [
        1735.0,
        1510.0,
        370.0
      ],
      "bbox_max": [
        1768.0001220703125,
        1532.5,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1512.5,
      "bbox_min": [
        1735.0,
        1511.5,
        391.5
      ],
      "bbox_max": [
        1768.0001220703125,
        1530.5,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.4877109555964125e-06,
        -1.0,
        0.0
      ],
      "plane_d": 1511.493896484375,
      "bbox_min": [
        1735.0,
        1511.5,
        391.5
      ],
      "bbox_max": [
        1768.0001220703125,
        1511.5001220703125,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.6991141314501874e-06,
        -1.0,
        -0.0
      ],
      "plane_d": 1530.5064697265625,
      "bbox_min": [
        1735.0,
        1530.4998779296875,
        391.5
      ],
      "bbox_max": [
        1767.9998779296875,
        1530.5,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.6991141314501874e-06,
        -1.0,
        -0.0
      ],
      "plane_d": 1530.5064697265625,
      "bbox_min": [
        1735.0,
        1510.0,
        370.0
      ],
      "bbox_max": [
        1768.0,
        1532.5,
        391.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1754.0,
      "bbox_min": [
        1754.0,
        1530.5,
        370.0
      ],
      "bbox_max": [
        1764.0,
        1532.5,
        382.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1764.0,
      "bbox_min": [
        1754.0,
        1530.5,
        370.0
      ],
      "bbox_max": [
        1764.0,
        1532.5,
        382.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 382.0,
      "bbox_min": [
        1754.0,
        1530.5,
        382.0
      ],
      "bbox_max": [
        1764.0,
        1532.5,
        382.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1510.0,
      "bbox_min": [
        1758.0,
        1510.0,
        370.0
      ],
      "bbox_max": [
        1768.0,
        1520.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -380.0,
      "bbox_min": [
        1758.0,
        1510.0,
        370.0
      ],
      "bbox_max": [
        1768.0,
        1520.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1758.0,
      "bbox_min": [
        1758.0,
        1510.0,
        370.0
      ],
      "bbox_max": [
        1768.0,
        1520.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1520.0,
      "bbox_min": [
        1758.0,
        1520.0,
        370.0
      ],
      "bbox_max": [
        1768.0,
        1520.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        6.103553459979594e-06,
        0.0
      ],
      "plane_d": -1750.009521484375,
      "bbox_min": [
        1750.0,
        1532.5,
        170.0
      ],
      "bbox_max": [
        1770.0,
        1552.5,
        385.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1552.5,
      "bbox_min": [
        1750.0,
        1532.5,
        170.0
      ],
      "bbox_max": [
        1770.0,
        1552.5,
        385.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1768.0,
      "bbox_min": [
        1750.0,
        1532.5,
        170.0
      ],
      "bbox_max": [
        1770.0,
        1552.5,
        385.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -170.0,
      "bbox_min": [
        1768.0,
        1537.5,
        170.0
      ],
      "bbox_max": [
        1770.0,
        1547.5,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 385.0,
      "bbox_min": [
        1750.0,
        1532.5,
        170.0
      ],
      "bbox_max": [
        1768.0001220703125,
        1552.5,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -170.0,
      "bbox_min": [
        1750.0,
        1532.5,
        170.0
      ],
      "bbox_max": [
        1768.0001220703125,
        1552.5,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2350.28173828125,
      "bbox_min": [
        1659.9998779296875,
        1579.9000244140625,
        370.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1659.9998779296875,
        1579.9000244140625,
        370.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1659.9998779296875,
        1579.9000244140625,
        980.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1706.639892578125,
        1626.6397705078125,
        1130.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -103.237548828125,
      "bbox_min": [
        1734.9000244140625,
        1588.9000244140625,
        980.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1624.0001220703125,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1766.3829345703125,
        1686.3826904296875,
        1130.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2444.84375,
      "bbox_min": [
        1767.53125,
        1687.531005859375,
        375.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1689.9998779296875,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -379.9999694824219,
      "bbox_min": [
        1767.53125,
        1687.531005859375,
        380.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1689.9998779296875,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1769.9998779296875,
        998.5078125,
        325.0
      ],
      "bbox_max": [
        2020.0,
        1690.0,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9688333868980408,
        0.24771343171596527,
        0.0
      ],
      "plane_d": 1538.40771484375,
      "bbox_min": [
        1910.0,
        998.5078125,
        325.0
      ],
      "bbox_max": [
        2020.0,
        1690.0,
        1150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1920.0,
      "bbox_min": [
        1920.0,
        998.5078125,
        325.0
      ],
      "bbox_max": [
        1980.0,
        1210.0,
        535.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 1067.731201171875,
      "bbox_min": [
        1920.0,
        998.5078125,
        325.0
      ],
      "bbox_max": [
        1980.0,
        1210.0,
        535.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1210.0,
      "bbox_min": [
        1920.0,
        1176.0,
        325.0
      ],
      "bbox_max": [
        1980.0,
        1210.0,
        443.19329833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2245.6708984375,
      "bbox_min": [
        1920.0,
        1176.0,
        325.0
      ],
      "bbox_max": [
        1980.0,
        1210.0,
        443.19329833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 512.0458374023438,
      "bbox_min": [
        1920.0,
        1176.0,
        325.0
      ],
      "bbox_max": [
        1980.0,
        1210.0,
        443.19329833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -1145.512939453125,
      "bbox_min": [
        1920.0,
        1176.0,
        410.0
      ],
      "bbox_max": [
        1980.0,
        1210.0,
        443.19329833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000007748603821,
        0.5000007748603821,
        0.7071055769920349
      ],
      "plane_d": -1877.8447265625,
      "bbox_min": [
        1920.0,
        1176.0,
        410.0
      ],
      "bbox_max": [
        1980.0,
        1210.0,
        436.57659912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000007748603821,
        0.5000007748603821,
        0.7071055769920349
      ],
      "plane_d": 72.15829467773438,
      "bbox_min": [
        1920.0,
        1176.0,
        410.0
      ],
      "bbox_max": [
        1954.0,
        1210.0,
        436.57659912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9993956685066223,
        0.0,
        0.034761589020490646
      ],
      "plane_d": 1930.22412109375,
      "bbox_min": [
        1946.0,
        1176.0,
        420.0
      ],
      "bbox_max": [
        1954.0,
        1184.0,
        436.57659912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9993956685066223,
        0.034761589020490646
      ],
      "plane_d": -1197.88427734375,
      "bbox_min": [
        1946.0,
        1183.42333984375,
        420.0
      ],
      "bbox_max": [
        1954.0,
        1184.0,
        436.57659912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9993956685066223,
        0.034761589020490646
      ],
      "plane_d": -1197.88427734375,
      "bbox_min": [
        1946.5765380859375,
        1183.1932373046875,
        436.5765686035156
      ],
      "bbox_max": [
        1953.42333984375,
        1183.4234619140625,
        443.19329833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9993956685066223,
        0.0,
        0.034761589020490646
      ],
      "plane_d": 1930.22412109375,
      "bbox_min": [
        1946.5765380859375,
        1176.5765380859375,
        436.57659912109375
      ],
      "bbox_max": [
        1953.1932373046875,
        1183.4234619140625,
        535.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9993956685066223,
        0.034761589020490646
      ],
      "plane_d": -1197.88427734375,
      "bbox_min": [
        1946.5765380859375,
        1180.0,
        436.57659912109375
      ],
      "bbox_max": [
        1953.1932373046875,
        1183.4234619140625,
        535.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2483755201101303,
        0.9686638712882996,
        0.0
      ],
      "plane_d": -1055.994873046875,
      "bbox_min": [
        1910.0,
        1579.9000244140625,
        370.0
      ],
      "bbox_max": [
        2020.0,
        1690.0,
        1150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 251.871337890625,
      "bbox_min": [
        1910.0,
        1579.9000244140625,
        370.0
      ],
      "bbox_max": [
        2020.0,
        1690.0,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1910.0,
        1579.9000244140625,
        370.0
      ],
      "bbox_max": [
        2020.0,
        1690.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1910.0,
        1579.9000244140625,
        980.0
      ],
      "bbox_max": [
        2020.0,
        1690.0,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1910.0,
        1626.639892578125,
        1130.0
      ],
      "bbox_max": [
        1973.3599853515625,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2592.1123046875,
      "bbox_min": [
        1910.0,
        1588.9000244140625,
        980.0
      ],
      "bbox_max": [
        2011.0,
        1689.9998779296875,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071055173873901,
        -0.7071080207824707,
        0.0
      ],
      "plane_d": 2498.914794921875,
      "bbox_min": [
        1910.0,
        1588.9000244140625,
        980.0
      ],
      "bbox_max": [
        1945.0999755859375,
        1623.9998779296875,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1910.0,
        1624.5106201171875,
        370.0
      ],
      "bbox_max": [
        1975.4892578125,
        1689.9998779296875,
        1060.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -380.0,
      "bbox_min": [
        1910.0,
        1687.5311279296875,
        380.0
      ],
      "bbox_max": [
        1912.46875,
        1689.9998779296875,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1769.9998779296875,
        1469.9998779296875,
        370.0
      ],
      "bbox_max": [
        1910.0,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -8.719300694792764e-07,
        1.0,
        0.0
      ],
      "plane_d": -1479.998291015625,
      "bbox_min": [
        1769.9998779296875,
        1469.9998779296875,
        370.0
      ],
      "bbox_max": [
        1910.0,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -390.0,
      "bbox_min": [
        1769.9998779296875,
        1469.9998779296875,
        390.0
      ],
      "bbox_max": [
        1910.0,
        1480.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1769.9998779296875,
        1498.0,
        370.0
      ],
      "bbox_max": [
        1910.0,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1770.0001220703125,
        1607.8834228515625,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1840.0,
      "bbox_min": [
        1840.0,
        1668.0,
        1106.0
      ],
      "bbox_max": [
        1840.0,
        1670.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.258819580078125,
        0.9659257531166077,
        -0.0
      ],
      "plane_d": -2089.323974609375,
      "bbox_min": [
        1787.0576171875,
        1670.0,
        1060.0
      ],
      "bbox_max": [
        1895.67431640625,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1807.0,
        1671.4832763671875,
        1110.0
      ],
      "bbox_max": [
        1827.5,
        1678.7083740234375,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659259915351868,
        -0.25881874561309814,
        0.0
      ],
      "plane_d": -1332.1356201171875,
      "bbox_min": [
        1827.0,
        1671.4832763671875,
        1110.0
      ],
      "bbox_max": [
        1827.5,
        1673.349365234375,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        1.87645127880387e-06
      ],
      "plane_d": 143.49984741210938,
      "bbox_min": [
        1787.0576171875,
        1673.349365234375,
        1060.0
      ],
      "bbox_max": [
        1895.67431640625,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2535.23193359375,
      "bbox_min": [
        1895.359130859375,
        1689.84228515625,
        1110.0
      ],
      "bbox_max": [
        1895.67431640625,
        1689.9998779296875,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1895.359130859375,
        1689.84228515625,
        1110.0
      ],
      "bbox_max": [
        1895.67431640625,
        1689.9998779296875,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": -2458.6552734375,
      "bbox_min": [
        1787.0576171875,
        1673.349365234375,
        1060.0
      ],
      "bbox_max": [
        1831.9615478515625,
        1689.9998779296875,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1807.5,
        1673.349365234375,
        1110.0
      ],
      "bbox_max": [
        1831.9615478515625,
        1689.9998779296875,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659259915351868,
        -0.25881874561309814,
        0.0
      ],
      "plane_d": -1332.1356201171875,
      "bbox_min": [
        1827.5,
        1673.349365234375,
        1110.0
      ],
      "bbox_max": [
        1831.9615478515625,
        1689.9998779296875,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -385.0,
      "bbox_min": [
        1769.9998779296875,
        1498.0,
        370.0
      ],
      "bbox_max": [
        1910.0,
        1689.9998779296875,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -383.0,
      "bbox_min": [
        1769.9998779296875,
        1498.0,
        370.0
      ],
      "bbox_max": [
        1910.0,
        1689.9998779296875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588190734386444,
        -0.9659258723258972,
        -0.0
      ],
      "plane_d": 2055.515869140625,
      "bbox_min": [
        1769.9998779296875,
        1498.0,
        370.0
      ],
      "bbox_max": [
        1910.0,
        1689.9998779296875,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881779193878174,
        -0.9659262299537659,
        0.0
      ],
      "plane_d": 1103.064697265625,
      "bbox_min": [
        1770.0001220703125,
        1635.0,
        370.0
      ],
      "bbox_max": [
        1910.0,
        1689.9998779296875,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -375.0,
      "bbox_min": [
        1770.0001220703125,
        1635.0,
        370.0
      ],
      "bbox_max": [
        1910.0,
        1689.9998779296875,
        383.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -177.3092041015625,
      "bbox_min": [
        1770.0001220703125,
        1651.7467041015625,
        370.0
      ],
      "bbox_max": [
        1910.0,
        1659.246826171875,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2424.84375,
      "bbox_min": [
        1770.0001220703125,
        1651.746826171875,
        370.0
      ],
      "bbox_max": [
        1777.5,
        1659.2467041015625,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588185966014862,
        -0.965925931930542,
        0.0
      ],
      "plane_d": 1123.062744140625,
      "bbox_min": [
        1770.0001220703125,
        1655.70556640625,
        375.0
      ],
      "bbox_max": [
        1910.0,
        1689.9998779296875,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588185966014862,
        -0.965925931930542,
        0.0
      ],
      "plane_d": 2075.51513671875,
      "bbox_min": [
        1770.0001220703125,
        1655.70556640625,
        375.0
      ],
      "bbox_max": [
        1910.0,
        1689.9998779296875,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -380.0,
      "bbox_min": [
        1770.0001220703125,
        1655.70556640625,
        375.0
      ],
      "bbox_max": [
        1910.0,
        1689.9998779296875,
        383.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -157.3092041015625,
      "bbox_min": [
        1770.0001220703125,
        1669.6783447265625,
        375.0
      ],
      "bbox_max": [
        1910.0,
        1687.5311279296875,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2444.84375,
      "bbox_min": [
        1770.0001220703125,
        1669.6783447265625,
        375.0
      ],
      "bbox_max": [
        1787.852783203125,
        1687.531005859375,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881898403167725,
        -0.965925931930542,
        0.0
      ],
      "plane_d": 1138.06201171875,
      "bbox_min": [
        1788.74462890625,
        1671.2347412109375,
        380.0
      ],
      "bbox_max": [
        1891.255615234375,
        1689.9998779296875,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588202953338623,
        -0.9659255743026733,
        0.0
      ],
      "plane_d": 2090.517578125,
      "bbox_min": [
        1788.74462890625,
        1671.2347412109375,
        380.0
      ],
      "bbox_max": [
        1891.255615234375,
        1689.9998779296875,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2459.843994140625,
      "bbox_min": [
        1788.74462890625,
        1683.1270751953125,
        380.0
      ],
      "bbox_max": [
        1795.617431640625,
        1689.9998779296875,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1771.0,
      "bbox_min": [
        1770.5,
        1510.0,
        370.0
      ],
      "bbox_max": [
        1771.0,
        1512.0,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        5.459484236780554e-05,
        0.44721364974975586
      ],
      "plane_d": -1754.94873046875,
      "bbox_min": [
        1770.5,
        1510.0,
        382.0
      ],
      "bbox_max": [
        1771.0,
        1512.0,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1499.9998779296875,
      "bbox_min": [
        1770.0,
        1498.0,
        370.0
      ],
      "bbox_max": [
        1771.0,
        1500.0,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1498.0,
      "bbox_min": [
        1770.0,
        1498.0,
        370.0
      ],
      "bbox_max": [
        1771.0,
        1500.0,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -6.103515625e-05,
        0.0
      ],
      "plane_d": -1770.908447265625,
      "bbox_min": [
        1770.5,
        1498.0,
        370.0
      ],
      "bbox_max": [
        1771.0,
        1500.0,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944491147994995,
        -5.459284147946164e-05,
        0.4471699595451355
      ],
      "plane_d": -1754.806396484375,
      "bbox_min": [
        1770.5,
        1498.0,
        382.0
      ],
      "bbox_max": [
        1771.0,
        1500.0,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881898403167725,
        -0.965925931930542,
        0.0
      ],
      "plane_d": 1138.06201171875,
      "bbox_min": [
        1769.9998779296875,
        1498.0,
        383.0
      ],
      "bbox_max": [
        1891.255615234375,
        1689.9998779296875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588202953338623,
        -0.9659255743026733,
        0.0
      ],
      "plane_d": 2090.517578125,
      "bbox_min": [
        1788.74462890625,
        1671.2347412109375,
        383.0
      ],
      "bbox_max": [
        1891.255615234375,
        1689.9998779296875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.258817195892334,
        0.9659264087677002,
        0.0
      ],
      "plane_d": -2095.513671875,
      "bbox_min": [
        1788.74462890625,
        1676.4112548828125,
        383.0
      ],
      "bbox_max": [
        1891.255615234375,
        1689.9998779296875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2459.843994140625,
      "bbox_min": [
        1788.74462890625,
        1683.1270751953125,
        383.0
      ],
      "bbox_max": [
        1795.617431640625,
        1689.9998779296875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588133215904236,
        0.9659274220466614,
        0.0
      ],
      "plane_d": -1143.0750732421875,
      "bbox_min": [
        1795.815673828125,
        1676.4112548828125,
        383.0
      ],
      "bbox_max": [
        1891.255615234375,
        1689.9998779296875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -142.309326171875,
      "bbox_min": [
        1884.3828125,
        1683.1270751953125,
        383.0
      ],
      "bbox_max": [
        1891.255615234375,
        1689.9998779296875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 137.309326171875,
      "bbox_min": [
        1795.815673828125,
        1687.6097412109375,
        383.0
      ],
      "bbox_max": [
        1884.1845703125,
        1689.9998779296875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2464.843994140625,
      "bbox_min": [
        1795.815673828125,
        1687.6099853515625,
        383.0
      ],
      "bbox_max": [
        1798.20556640625,
        1689.9998779296875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944491147994995,
        -5.459284147946164e-05,
        0.4471699595451355
      ],
      "plane_d": -1754.806396484375,
      "bbox_min": [
        1769.9998779296875,
        1498.0,
        383.0
      ],
      "bbox_max": [
        1770.5,
        1512.0,
        384.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1510.0,
      "bbox_min": [
        1769.9998779296875,
        1498.0,
        383.0
      ],
      "bbox_max": [
        1770.5,
        1512.0,
        384.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.00012205541133880615,
        1.0,
        0.0
      ],
      "plane_d": -1511.7838134765625,
      "bbox_min": [
        1769.9998779296875,
        1511.9998779296875,
        383.0
      ],
      "bbox_max": [
        1770.5,
        1512.0,
        384.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1498.0,
      "bbox_min": [
        1770.0,
        1498.0,
        383.0
      ],
      "bbox_max": [
        1770.5,
        1500.0,
        384.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1499.9998779296875,
      "bbox_min": [
        1770.0001220703125,
        1500.0,
        383.0
      ],
      "bbox_max": [
        1770.5,
        1500.0,
        384.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881898403167725,
        -0.965925931930542,
        0.0
      ],
      "plane_d": 1138.06201171875,
      "bbox_min": [
        1770.0001220703125,
        1623.9998779296875,
        385.0
      ],
      "bbox_max": [
        1910.0,
        1689.9998779296875,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588202953338623,
        -0.9659255743026733,
        0.0
      ],
      "plane_d": 2090.517578125,
      "bbox_min": [
        1788.74462890625,
        1671.2347412109375,
        385.0
      ],
      "bbox_max": [
        1891.255615234375,
        1689.9998779296875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -390.0,
      "bbox_min": [
        1788.74462890625,
        1671.2347412109375,
        385.0
      ],
      "bbox_max": [
        1891.255615234375,
        1689.9998779296875,
        390.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.258817195892334,
        0.9659264087677002,
        0.0
      ],
      "plane_d": -2095.513671875,
      "bbox_min": [
        1788.74462890625,
        1676.4112548828125,
        385.0
      ],
      "bbox_max": [
        1891.255615234375,
        1689.9998779296875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588133215904236,
        0.9659274220466614,
        0.0
      ],
      "plane_d": -1143.0750732421875,
      "bbox_min": [
        1795.815673828125,
        1676.4112548828125,
        385.0
      ],
      "bbox_max": [
        1891.255615234375,
        1689.9998779296875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -142.309326171875,
      "bbox_min": [
        1884.3828125,
        1683.1270751953125,
        385.0
      ],
      "bbox_max": [
        1891.255615234375,
        1689.9998779296875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 137.309326171875,
      "bbox_min": [
        1795.815673828125,
        1687.6097412109375,
        385.0
      ],
      "bbox_max": [
        1884.1845703125,
        1689.9998779296875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2464.843994140625,
      "bbox_min": [
        1795.815673828125,
        1687.6099853515625,
        385.0
      ],
      "bbox_max": [
        1798.20556640625,
        1689.9998779296875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 732.9856567382812,
      "bbox_min": [
        1770.0001220703125,
        1623.9998779296875,
        1059.421875
      ],
      "bbox_max": [
        1910.0,
        1624.5108642578125,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071055173873901,
        -0.7071080207824707,
        0.0
      ],
      "plane_d": 2498.914794921875,
      "bbox_min": [
        1909.7445068359375,
        1623.9998779296875,
        1059.421875
      ],
      "bbox_max": [
        1910.0,
        1624.25537109375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5996253490447998,
        0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": -1473.6357421875,
      "bbox_min": [
        1770.0001220703125,
        1624.0001220703125,
        1059.4224853515625
      ],
      "bbox_max": [
        1770.25537109375,
        1624.5106201171875,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -103.237548828125,
      "bbox_min": [
        1770.0001220703125,
        1624.0001220703125,
        1059.4224853515625
      ],
      "bbox_max": [
        1770.25537109375,
        1624.25537109375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1549.9998779296875,
        1689.9998779296875,
        370.0
      ],
      "bbox_max": [
        2130.0,
        1830.0,
        1130.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.9659264087677002,
        0.25881683826446533,
        0.0
      ],
      "plane_d": -2353.56298828125,
      "bbox_min": [
        1715.0,
        1689.9998779296875,
        370.0
      ],
      "bbox_max": [
        1964.9998779296875,
        1830.0,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659258723258972,
        -0.2588190734386444,
        -0.0
      ],
      "plane_d": 2112.08447265625,
      "bbox_min": [
        1715.0,
        1689.9998779296875,
        370.0
      ],
      "bbox_max": [
        1964.9998779296875,
        1830.0,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659262299537659,
        0.25881779193878174,
        0.0
      ],
      "plane_d": 1201.044189453125,
      "bbox_min": [
        1715.0,
        1689.9998779296875,
        370.0
      ],
      "bbox_max": [
        1964.9998779296875,
        1830.0,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659262299537659,
        -0.25881779193878174,
        0.0
      ],
      "plane_d": -1442.525634765625,
      "bbox_min": [
        1715.0,
        1689.9998779296875,
        370.0
      ],
      "bbox_max": [
        1964.9998779296875,
        1830.0,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -375.0,
      "bbox_min": [
        1715.0,
        1689.9998779296875,
        370.0
      ],
      "bbox_max": [
        1964.9998779296875,
        1830.0,
        383.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -64.172119140625,
      "bbox_min": [
        1731.7467041015625,
        1689.9998779296875,
        370.0
      ],
      "bbox_max": [
        1948.253173828125,
        1830.0,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2424.84375,
      "bbox_min": [
        1731.746826171875,
        1689.9998779296875,
        370.0
      ],
      "bbox_max": [
        1948.253173828125,
        1830.0,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -177.3092041015625,
      "bbox_min": [
        1940.7530517578125,
        1689.9998779296875,
        370.0
      ],
      "bbox_max": [
        1948.253173828125,
        1830.0,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2666.3251953125,
      "bbox_min": [
        1940.753173828125,
        1822.5,
        370.0
      ],
      "bbox_max": [
        1948.253173828125,
        1830.0,
        375.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965925931930542,
        0.2588185966014862,
        -0.0
      ],
      "plane_d": -2333.565185546875,
      "bbox_min": [
        1735.70556640625,
        1689.9998779296875,
        375.0
      ],
      "bbox_max": [
        1944.29443359375,
        1830.0,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965925931930542,
        -0.2588185966014862,
        0.0
      ],
      "plane_d": -1422.523681640625,
      "bbox_min": [
        1735.70556640625,
        1689.9998779296875,
        375.0
      ],
      "bbox_max": [
        1944.29443359375,
        1830.0,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.965925931930542,
        -0.2588185966014862,
        0.0
      ],
      "plane_d": 2132.083740234375,
      "bbox_min": [
        1735.70556640625,
        1689.9998779296875,
        375.0
      ],
      "bbox_max": [
        1944.29443359375,
        1830.0,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.965925931930542,
        0.2588185966014862,
        0.0
      ],
      "plane_d": 1221.042236328125,
      "bbox_min": [
        1735.70556640625,
        1689.9998779296875,
        375.0
      ],
      "bbox_max": [
        1944.29443359375,
        1830.0,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -379.9999694824219,
      "bbox_min": [
        1735.70556640625,
        1689.9998779296875,
        375.0
      ],
      "bbox_max": [
        1944.29443359375,
        1830.0,
        383.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -157.3092041015625,
      "bbox_min": [
        1749.6783447265625,
        1689.9998779296875,
        375.0
      ],
      "bbox_max": [
        1930.3216552734375,
        1830.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2444.84375,
      "bbox_min": [
        1749.6783447265625,
        1689.9998779296875,
        375.0
      ],
      "bbox_max": [
        1930.3216552734375,
        1830.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -44.1722412109375,
      "bbox_min": [
        1749.6783447265625,
        1812.147216796875,
        375.0
      ],
      "bbox_max": [
        1930.3216552734375,
        1830.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2646.3251953125,
      "bbox_min": [
        1912.4688720703125,
        1812.147216796875,
        375.0
      ],
      "bbox_max": [
        1930.3216552734375,
        1830.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.965925931930542,
        0.25881898403167725,
        0.0
      ],
      "plane_d": 1236.041748046875,
      "bbox_min": [
        1751.2347412109375,
        1689.9998779296875,
        380.0
      ],
      "bbox_max": [
        1928.76513671875,
        1830.0,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965927243232727,
        0.2588140070438385,
        -0.0
      ],
      "plane_d": -2318.5595703125,
      "bbox_min": [
        1751.2347412109375,
        1689.9998779296875,
        380.0
      ],
      "bbox_max": [
        1928.76513671875,
        1830.0,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659255743026733,
        -0.2588202953338623,
        0.0
      ],
      "plane_d": 2147.086181640625,
      "bbox_min": [
        1751.2347412109375,
        1689.9998779296875,
        380.0
      ],
      "bbox_max": [
        1928.76513671875,
        1830.0,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659268260002136,
        -0.25881531834602356,
        0.0
      ],
      "plane_d": -1407.5311279296875,
      "bbox_min": [
        1763.1270751953125,
        1689.9998779296875,
        380.0
      ],
      "bbox_max": [
        1928.76513671875,
        1830.0,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2631.3251953125,
      "bbox_min": [
        1763.1270751953125,
        1804.3826904296875,
        380.0
      ],
      "bbox_max": [
        1916.873046875,
        1830.0,
        383.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965927243232727,
        0.2588140070438385,
        -0.0
      ],
      "plane_d": -2318.5595703125,
      "bbox_min": [
        1751.2347412109375,
        1689.9998779296875,
        383.0
      ],
      "bbox_max": [
        1928.76513671875,
        1830.0,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659255743026733,
        -0.2588202953338623,
        0.0
      ],
      "plane_d": 2147.086181640625,
      "bbox_min": [
        1751.2347412109375,
        1689.9998779296875,
        383.0
      ],
      "bbox_max": [
        1928.76513671875,
        1830.0,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659268260002136,
        -0.25881531834602356,
        0.0
      ],
      "plane_d": -1407.5311279296875,
      "bbox_min": [
        1756.4112548828125,
        1689.9998779296875,
        383.0
      ],
      "bbox_max": [
        1928.76513671875,
        1830.0,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659264087677002,
        -0.258817195892334,
        -0.0
      ],
      "plane_d": 2313.5634765625,
      "bbox_min": [
        1756.4112548828125,
        1689.9998779296875,
        383.0
      ],
      "bbox_max": [
        1923.5888671875,
        1830.0,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2631.3251953125,
      "bbox_min": [
        1909.8017578125,
        1804.3826904296875,
        383.0
      ],
      "bbox_max": [
        1916.873046875,
        1811.4539794921875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659264087677002,
        0.258817195892334,
        0.0
      ],
      "plane_d": 1402.527099609375,
      "bbox_min": [
        1756.4112548828125,
        1689.9998779296875,
        383.0
      ],
      "bbox_max": [
        1923.5888671875,
        1830.0,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -142.309326171875,
      "bbox_min": [
        1909.802001953125,
        1708.5462646484375,
        383.0
      ],
      "bbox_max": [
        1916.873046875,
        1715.6173095703125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659264087677002,
        0.258817195892334,
        0.0
      ],
      "plane_d": -2152.082275390625,
      "bbox_min": [
        1756.4112548828125,
        1689.9998779296875,
        383.0
      ],
      "bbox_max": [
        1912.39013671875,
        1830.0,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2459.843994140625,
      "bbox_min": [
        1763.1270751953125,
        1708.54638671875,
        383.0
      ],
      "bbox_max": [
        1770.1981201171875,
        1715.617431640625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659274220466614,
        -0.2588133215904236,
        0.0
      ],
      "plane_d": -1241.0543212890625,
      "bbox_min": [
        1756.4112548828125,
        1689.9998779296875,
        383.0
      ],
      "bbox_max": [
        1912.39013671875,
        1830.0,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -29.172119140625,
      "bbox_min": [
        1763.1270751953125,
        1804.3828125,
        383.0
      ],
      "bbox_max": [
        1770.1978759765625,
        1811.45361328125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2464.843994140625,
      "bbox_min": [
        1767.6097412109375,
        1689.9998779296875,
        383.0
      ],
      "bbox_max": [
        1912.39013671875,
        1830.0,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2459.843994140625,
      "bbox_min": [
        1770.1981201171875,
        1689.9998779296875,
        383.0
      ],
      "bbox_max": [
        1788.74462890625,
        1708.54638671875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 137.309326171875,
      "bbox_min": [
        1767.6097412109375,
        1689.9998779296875,
        383.0
      ],
      "bbox_max": [
        1912.39013671875,
        1830.0,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -142.309326171875,
      "bbox_min": [
        1891.255615234375,
        1689.9998779296875,
        383.0
      ],
      "bbox_max": [
        1909.802001953125,
        1708.5462646484375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 24.1722412109375,
      "bbox_min": [
        1767.6097412109375,
        1801.79443359375,
        383.0
      ],
      "bbox_max": [
        1912.39013671875,
        1830.0,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -29.172119140625,
      "bbox_min": [
        1770.1978759765625,
        1811.45361328125,
        383.0
      ],
      "bbox_max": [
        1788.7442626953125,
        1830.0,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2626.3251953125,
      "bbox_min": [
        1884.1846923828125,
        1801.7945556640625,
        383.0
      ],
      "bbox_max": [
        1912.39013671875,
        1830.0,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2631.3251953125,
      "bbox_min": [
        1891.2557373046875,
        1811.4539794921875,
        383.0
      ],
      "bbox_max": [
        1909.8017578125,
        1830.0,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1659.9998779296875,
        1689.9998779296875,
        385.0
      ],
      "bbox_max": [
        2020.0,
        1830.0,
        1130.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1687.8834228515625,
        1689.9998779296875,
        1060.0
      ],
      "bbox_max": [
        1992.11669921875,
        1830.0,
        1130.0
      ],
      "face_count": 18
    },
    {
      "plane_normal": [
        0.9659265279769897,
        -0.2588164508342743,
        0.0
      ],
      "plane_d": -1234.8544921875,
      "bbox_min": [
        1748.0,
        1689.9998779296875,
        1060.0
      ],
      "bbox_max": [
        1932.0001220703125,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500018298625946,
        -0.866014838218689,
        -0.0
      ],
      "plane_d": 2444.218017578125,
      "bbox_min": [
        1748.0,
        1760.0,
        1106.0
      ],
      "bbox_max": [
        1762.0577392578125,
        1806.0001220703125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1760.0,
      "bbox_min": [
        1748.0,
        1760.0,
        1106.0
      ],
      "bbox_max": [
        1750.0,
        1760.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659252762794495,
        0.25882136821746826,
        -6.868348805255664e-07
      ],
      "plane_d": 1408.7109375,
      "bbox_min": [
        1750.0,
        1689.9998779296875,
        1060.0
      ],
      "bbox_max": [
        1932.0001220703125,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1760.000244140625,
      "bbox_min": [
        1930.0001220703125,
        1760.0001220703125,
        1106.0
      ],
      "bbox_max": [
        1932.0001220703125,
        1760.000244140625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659257531166077,
        0.258819580078125,
        3.2501097848580685e-06
      ],
      "plane_d": -2145.89599609375,
      "bbox_min": [
        1750.0,
        1689.9998779296875,
        1060.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1830.0,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1751.4832763671875,
        1726.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1758.7081298828125,
        1747.5,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881874561309814,
        0.9659259915351868,
        0.0
      ],
      "plane_d": -1234.156005859375,
      "bbox_min": [
        1751.4832763671875,
        1726.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1758.7081298828125,
        1747.5,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881874561309814,
        -0.9659259915351868,
        -2.3582178982906044e-05
      ],
      "plane_d": 1213.4765625,
      "bbox_min": [
        1756.84228515625,
        1726.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1758.7081298828125,
        1727.5,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659263491630554,
        -0.2588171064853668,
        3.2501047826372087e-06
      ],
      "plane_d": 2319.75244140625,
      "bbox_min": [
        1753.34912109375,
        1689.9998779296875,
        1060.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1830.0,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1921.2918701171875,
        1772.5001220703125,
        1110.0
      ],
      "bbox_max": [
        1928.516845703125,
        1793.0001220703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882038474082947,
        -0.9659255146980286,
        0.0
      ],
      "plane_d": 1213.446533203125,
      "bbox_min": [
        1921.2918701171875,
        1772.5001220703125,
        1110.0
      ],
      "bbox_max": [
        1928.516845703125,
        1793.0001220703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588197886943817,
        0.9659256935119629,
        0.0
      ],
      "plane_d": -1234.153564453125,
      "bbox_min": [
        1921.2918701171875,
        1792.5001220703125,
        1110.0
      ],
      "bbox_max": [
        1923.157958984375,
        1793.0001220703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": -2458.6552734375,
      "bbox_min": [
        1753.34912109375,
        1689.9998779296875,
        1060.0
      ],
      "bbox_max": [
        1926.6507568359375,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 2632.51416015625,
      "bbox_min": [
        1753.34912109375,
        1689.9998779296875,
        1060.0
      ],
      "bbox_max": [
        1926.6507568359375,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        1.87645127880387e-06
      ],
      "plane_d": 143.49984741210938,
      "bbox_min": [
        1753.34912109375,
        1689.9998779296875,
        1060.0
      ],
      "bbox_max": [
        1926.6507568359375,
        1830.0,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1894.150634765625,
        1689.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1910.15771484375,
        1705.849365234375,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2555.937255859375,
      "bbox_min": [
        1894.150634765625,
        1689.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1910.15771484375,
        1705.849365234375,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2535.23193359375,
      "bbox_min": [
        1894.150634765625,
        1689.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1895.359130859375,
        1691.2083740234375,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 30.360889434814453,
      "bbox_min": [
        1753.34912109375,
        1689.9998779296875,
        1060.0
      ],
      "bbox_max": [
        1926.6507568359375,
        1830.0,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1769.84228515625,
        1814.1507568359375,
        1110.0
      ],
      "bbox_max": [
        1785.84912109375,
        1830.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2535.23193359375,
      "bbox_min": [
        1769.84228515625,
        1814.1507568359375,
        1110.0
      ],
      "bbox_max": [
        1785.84912109375,
        1830.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2555.9375,
      "bbox_min": [
        1784.6409912109375,
        1828.7918701171875,
        1110.0
      ],
      "bbox_max": [
        1785.84912109375,
        1830.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1753.34912109375,
        1689.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1926.6507568359375,
        1830.0,
        1125.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2555.9375,
      "bbox_min": [
        1753.34912109375,
        1689.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1926.6507568359375,
        1830.0,
        1125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2535.23193359375,
      "bbox_min": [
        1753.34912109375,
        1689.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1894.150634765625,
        1814.15087890625,
        1125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -95.20556640625,
      "bbox_min": [
        1860.0,
        1725.3590087890625,
        1115.0
      ],
      "bbox_max": [
        1874.6409912109375,
        1740.0,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881874561309814,
        -0.9659259915351868,
        -2.3582178982906044e-05
      ],
      "plane_d": 1213.4765625,
      "bbox_min": [
        1753.34912109375,
        1689.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1860.0,
        1760.0,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881874561309814,
        0.9659259915351868,
        0.0
      ],
      "plane_d": -1234.156005859375,
      "bbox_min": [
        1753.34912109375,
        1747.5,
        1110.0
      ],
      "bbox_max": [
        1800.0,
        1760.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659259915351868,
        -0.25881874561309814,
        0.0
      ],
      "plane_d": -1332.1356201171875,
      "bbox_min": [
        1805.3590087890625,
        1689.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1860.0,
        1740.0,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2506.94775390625,
      "bbox_min": [
        1805.3590087890625,
        1725.3590087890625,
        1110.0
      ],
      "bbox_max": [
        1820.0,
        1740.0,
        1125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.25882017612457275,
        -0.9659255146980286,
        0.0
      ],
      "plane_d": 1185.1627197265625,
      "bbox_min": [
        1840.0,
        1720.0,
        1115.0
      ],
      "bbox_max": [
        1860.0,
        1725.3590087890625,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588197886943817,
        0.9659256935119629,
        0.0
      ],
      "plane_d": -1234.153564453125,
      "bbox_min": [
        1820.0,
        1740.0,
        1110.0
      ],
      "bbox_max": [
        1926.6507568359375,
        1830.0,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882038474082947,
        -0.9659255146980286,
        0.0
      ],
      "plane_d": 1213.446533203125,
      "bbox_min": [
        1874.6409912109375,
        1740.0,
        1110.0
      ],
      "bbox_max": [
        1926.6507568359375,
        1780.0,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659255146980286,
        0.25882017612457275,
        -0.0
      ],
      "plane_d": -2271.46337890625,
      "bbox_min": [
        1874.6409912109375,
        1760.0,
        1115.0
      ],
      "bbox_max": [
        1880.0,
        1780.0,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659255146980286,
        -0.25882017612457275,
        0.0
      ],
      "plane_d": -1360.41650390625,
      "bbox_min": [
        1874.6409912109375,
        1740.0,
        1110.0
      ],
      "bbox_max": [
        1880.0,
        1760.0,
        1125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9659256935119629,
        -0.2588197886943817,
        0.0
      ],
      "plane_d": -1332.1331787109375,
      "bbox_min": [
        1820.0,
        1780.0,
        1110.0
      ],
      "bbox_max": [
        1874.6409912109375,
        1830.0,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882017612457275,
        0.9659255146980286,
        0.0
      ],
      "plane_d": -1262.436767578125,
      "bbox_min": [
        1820.0,
        1794.6409912109375,
        1115.0
      ],
      "bbox_max": [
        1840.0,
        1800.0,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2584.2216796875,
      "bbox_min": [
        1860.0,
        1780.0,
        1110.0
      ],
      "bbox_max": [
        1874.6409912109375,
        1794.6409912109375,
        1125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.965927243232727,
        0.2588140070438385,
        -0.0
      ],
      "plane_d": -2318.5595703125,
      "bbox_min": [
        1704.19970703125,
        1689.9998779296875,
        385.0
      ],
      "bbox_max": [
        1975.8001708984375,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.965925931930542,
        0.25881898403167725,
        0.0
      ],
      "plane_d": 1236.041748046875,
      "bbox_min": [
        1704.19970703125,
        1689.9998779296875,
        385.0
      ],
      "bbox_max": [
        1928.76513671875,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659255743026733,
        -0.2588202953338623,
        0.0
      ],
      "plane_d": 2147.086181640625,
      "bbox_min": [
        1751.2347412109375,
        1689.9998779296875,
        385.0
      ],
      "bbox_max": [
        1928.76513671875,
        1830.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659268260002136,
        -0.25881531834602356,
        0.0
      ],
      "plane_d": -1407.5311279296875,
      "bbox_min": [
        1751.2347412109375,
        1689.9998779296875,
        385.0
      ],
      "bbox_max": [
        1928.76513671875,
        1830.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -390.0,
      "bbox_min": [
        1751.2347412109375,
        1689.9998779296875,
        385.0
      ],
      "bbox_max": [
        1928.76513671875,
        1830.0,
        390.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.9659264087677002,
        -0.258817195892334,
        -0.0
      ],
      "plane_d": 2313.5634765625,
      "bbox_min": [
        1756.4112548828125,
        1689.9998779296875,
        385.0
      ],
      "bbox_max": [
        1923.5888671875,
        1830.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659264087677002,
        0.258817195892334,
        0.0
      ],
      "plane_d": 1402.527099609375,
      "bbox_min": [
        1756.4112548828125,
        1689.9998779296875,
        385.0
      ],
      "bbox_max": [
        1923.5888671875,
        1830.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659264087677002,
        0.258817195892334,
        0.0
      ],
      "plane_d": -2152.082275390625,
      "bbox_min": [
        1756.4112548828125,
        1689.9998779296875,
        385.0
      ],
      "bbox_max": [
        1912.39013671875,
        1830.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659274220466614,
        -0.2588133215904236,
        0.0
      ],
      "plane_d": -1241.0543212890625,
      "bbox_min": [
        1756.4112548828125,
        1689.9998779296875,
        385.0
      ],
      "bbox_max": [
        1912.39013671875,
        1830.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -29.172119140625,
      "bbox_min": [
        1763.1270751953125,
        1804.3828125,
        385.0
      ],
      "bbox_max": [
        1770.1978759765625,
        1811.45361328125,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2464.843994140625,
      "bbox_min": [
        1767.6097412109375,
        1689.9998779296875,
        385.0
      ],
      "bbox_max": [
        1912.39013671875,
        1830.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2459.843994140625,
      "bbox_min": [
        1770.1981201171875,
        1689.9998779296875,
        385.0
      ],
      "bbox_max": [
        1788.74462890625,
        1708.54638671875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 137.309326171875,
      "bbox_min": [
        1767.6097412109375,
        1689.9998779296875,
        385.0
      ],
      "bbox_max": [
        1912.39013671875,
        1830.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -142.309326171875,
      "bbox_min": [
        1891.255615234375,
        1689.9998779296875,
        385.0
      ],
      "bbox_max": [
        1909.802001953125,
        1708.5462646484375,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 24.1722412109375,
      "bbox_min": [
        1767.6097412109375,
        1801.79443359375,
        385.0
      ],
      "bbox_max": [
        1912.39013671875,
        1830.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -29.172119140625,
      "bbox_min": [
        1770.1978759765625,
        1811.45361328125,
        385.0
      ],
      "bbox_max": [
        1788.7442626953125,
        1830.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2626.3251953125,
      "bbox_min": [
        1884.1846923828125,
        1801.7945556640625,
        385.0
      ],
      "bbox_max": [
        1912.39013671875,
        1830.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2631.3251953125,
      "bbox_min": [
        1891.2557373046875,
        1811.4539794921875,
        385.0
      ],
      "bbox_max": [
        1909.8017578125,
        1830.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 637.0455932617188,
      "bbox_min": [
        1704.19970703125,
        1689.9998779296875,
        1059.6480712890625
      ],
      "bbox_max": [
        1704.5108642578125,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2499.056640625,
      "bbox_min": [
        1704.19970703125,
        1829.844482421875,
        1059.6480712890625
      ],
      "bbox_max": [
        1704.355224609375,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5996253490447998,
        0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": -1473.6357421875,
      "bbox_min": [
        1704.1998291015625,
        1689.9998779296875,
        1059.6480712890625
      ],
      "bbox_max": [
        1704.5108642578125,
        1690.1553955078125,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 732.9856567382812,
      "bbox_min": [
        1975.4891357421875,
        1689.9998779296875,
        1059.6480712890625
      ],
      "bbox_max": [
        1975.8001708984375,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2592.1123046875,
      "bbox_min": [
        1975.6446533203125,
        1689.9998779296875,
        1059.6480712890625
      ],
      "bbox_max": [
        1975.8001708984375,
        1690.1553955078125,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 2843.666748046875,
      "bbox_min": [
        1975.4892578125,
        1829.8446044921875,
        1059.6484375
      ],
      "bbox_max": [
        1975.800048828125,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -103.09619140625,
      "bbox_min": [
        1975.6446533203125,
        1829.8446044921875,
        1059.6484375
      ],
      "bbox_max": [
        1975.800048828125,
        1830.0,
        1060.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}